"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainId = exports.ChainName = void 0;
var ChainName;
(function (ChainName) {
    ChainName["EthereumMainnet"] = "Ethereum Mainnet";
    ChainName["ExpanseNetwork"] = "Expanse Network";
    ChainName["Ropsten"] = "Ropsten";
    ChainName["Rinkeby"] = "Rinkeby";
    ChainName["Goerli"] = "Goerli";
    ChainName["KottiTestnet"] = "Kotti Testnet";
    ChainName["ThaiChain"] = "ThaiChain";
    ChainName["Ubiq"] = "Ubiq";
    ChainName["UbiqNetworkTestnet"] = "Ubiq Network Testnet";
    ChainName["OPMainnet"] = "OP Mainnet";
    ChainName["MetadiumMainnet"] = "Metadium Mainnet";
    ChainName["MetadiumTestnet"] = "Metadium Testnet";
    ChainName["DiodeTestnetStaging"] = "Diode Testnet Staging";
    ChainName["FlareMainnet"] = "Flare Mainnet";
    ChainName["DiodePrenet"] = "Diode Prenet";
    ChainName["FlareTestnetCoston"] = "Flare Testnet Coston";
    ChainName["ThaiChain2.0ThaiFi"] = "ThaiChain 2.0 ThaiFi";
    ChainName["ThunderCoreTestnet"] = "ThunderCore Testnet";
    ChainName["SongbirdCanary-Network"] = "Songbird Canary-Network";
    ChainName["ElastosSmartChain"] = "Elastos Smart Chain";
    ChainName["ElastosSmartChainTestnet"] = "Elastos Smart Chain Testnet";
    ChainName["ELA-DID-SidechainMainnet"] = "ELA-DID-Sidechain Mainnet";
    ChainName["ELA-DID-SidechainTestnet"] = "ELA-DID-Sidechain Testnet";
    ChainName["KardiaChainMainnet"] = "KardiaChain Mainnet";
    ChainName["CronosMainnet"] = "Cronos Mainnet";
    ChainName["GenesisL1testnet"] = "Genesis L1 testnet";
    ChainName["ShibaChain"] = "ShibaChain";
    ChainName["BobaNetworkRinkebyTestnet"] = "Boba Network Rinkeby Testnet";
    ChainName["GenesisL1"] = "Genesis L1";
    ChainName["RootstockMainnet"] = "Rootstock Mainnet";
    ChainName["RootstockTestnet"] = "Rootstock Testnet";
    ChainName["GoodDataTestnet"] = "GoodData Testnet";
    ChainName["GoodDataMainnet"] = "GoodData Mainnet";
    ChainName["SecureChainMainnet"] = "SecureChain Mainnet";
    ChainName["TBWGChain"] = "TBWG Chain";
    ChainName["DxchainMainnet"] = "Dxchain Mainnet";
    ChainName["XplaMainnet"] = "Xpla Mainnet";
    ChainName["Valorbit"] = "Valorbit";
    ChainName["U2USolarisMainnet"] = "U2U Solaris Mainnet";
    ChainName["TelosEVMMainnet"] = "Telos EVM Mainnet";
    ChainName["TelosEVMTestnet"] = "Telos EVM Testnet";
    ChainName["LUKSOMainnet"] = "LUKSO Mainnet";
    ChainName["DarwiniaPangolinTestnet"] = "Darwinia Pangolin Testnet";
    ChainName["CrabNetwork"] = "Crab Network";
    ChainName["DarwiniaPangoroTestnet"] = "Darwinia Pangoro Testnet";
    ChainName["DarwiniaNetwork"] = "Darwinia Network";
    ChainName["AcriaIntelliChain"] = "Acria IntelliChain";
    ChainName["EnnothemMainnetProterozoic"] = "Ennothem Mainnet Proterozoic";
    ChainName["EnnothemTestnetPioneer"] = "Ennothem Testnet Pioneer";
    ChainName["XDCNetwork"] = "XDC Network";
    ChainName["XDCApothemNetwork"] = "XDC Apothem Network";
    ChainName["CoinExSmartChainMainnet"] = "CoinEx Smart Chain Mainnet";
    ChainName["CoinExSmartChainTestnet"] = "CoinEx Smart Chain Testnet";
    ChainName["OpenpieceMainnet"] = "Openpiece Mainnet";
    ChainName["ZyxMainnet"] = "Zyx Mainnet";
    ChainName["BNBSmartChainMainnet"] = "BNB Smart Chain Mainnet";
    ChainName["SyscoinMainnet"] = "Syscoin Mainnet";
    ChainName["OntologyMainnet"] = "Ontology Mainnet";
    ChainName["EOSEVMLegacy"] = "EOS EVM Legacy";
    ChainName["GoChain"] = "GoChain";
    ChainName["EthereumClassic"] = "Ethereum Classic";
    ChainName["MordenTestnet"] = "Morden Testnet";
    ChainName["MordorTestnet"] = "Mordor Testnet";
    ChainName["Ellaism"] = "Ellaism";
    ChainName["OKExChainTestnet"] = "OKExChain Testnet";
    ChainName["OKXChainMainnet"] = "OKXChain Mainnet";
    ChainName["DBChainTestnet"] = "DBChain Testnet";
    ChainName["SoterOneMainnet"] = "SoterOne Mainnet";
    ChainName["OptimismKovan"] = "Optimism Kovan";
    ChainName["HooSmartChain"] = "Hoo Smart Chain";
    ChainName["ConfluxeSpace(Testnet)"] = "Conflux eSpace (Testnet)";
    ChainName["DxChainTestnet"] = "DxChain Testnet";
    ChainName["FNCY"] = "FNCY";
    ChainName["IDChainMainnet"] = "IDChain Mainnet";
    ChainName["DecimalSmartChainMainnet"] = "Decimal Smart Chain Mainnet";
    ChainName["Mix"] = "Mix";
    ChainName["POANetworkSokol"] = "POA Network Sokol";
    ChainName["PrimusChainmainnet"] = "PrimusChain mainnet";
    ChainName["ZenithMainnet"] = "Zenith Mainnet";
    ChainName["GeneChain"] = "GeneChain";
    ChainName["JapanOpenChainMainnet"] = "Japan Open Chain Mainnet";
    ChainName["MeterMainnet"] = "Meter Mainnet";
    ChainName["MeterTestnet"] = "Meter Testnet";
    ChainName["LinqtoDevnet"] = "Linqto Devnet";
    ChainName["GateChainTestnet"] = "GateChain Testnet";
    ChainName["GateChainMainnet"] = "GateChain Mainnet";
    ChainName["NovaNetwork"] = "Nova Network";
    ChainName["TomoChain"] = "TomoChain";
    ChainName["TomoChainTestnet"] = "TomoChain Testnet";
    ChainName["GarizonStage0"] = "Garizon Stage0";
    ChainName["GarizonStage1"] = "Garizon Stage1";
    ChainName["GarizonStage2"] = "Garizon Stage2";
    ChainName["GarizonStage3"] = "Garizon Stage3";
    ChainName["SwissDLT"] = "SwissDLT";
    ChainName["CamDLMainnet"] = "CamDL Mainnet";
    ChainName["BitkubChain"] = "Bitkub Chain";
    ChainName["BNBSmartChainTestnet"] = "BNB Smart Chain Testnet";
    ChainName["SixProtocol"] = "Six Protocol";
    ChainName["POANetworkCore"] = "POA Network Core";
    ChainName["Gnosis"] = "Gnosis";
    ChainName["EtherInc"] = "EtherInc";
    ChainName["Web3GamesTestnet"] = "Web3Games Testnet";
    ChainName["WorldlandMainnet"] = "Worldland Mainnet";
    ChainName["KaibaLightningChainTestnet"] = "Kaiba Lightning Chain Testnet";
    ChainName["Web3GamesDevnet"] = "Web3Games Devnet";
    ChainName["VelasEVMMainnet"] = "Velas EVM Mainnet";
    ChainName["NebulaTestnet"] = "Nebula Testnet";
    ChainName["ThunderCoreMainnet"] = "ThunderCore Mainnet";
    ChainName["Shibarium"] = "Shibarium";
    ChainName["ProtonTestnet"] = "Proton Testnet";
    ChainName["EtherLiteChain"] = "EtherLite Chain";
    ChainName["CoinbitMainnet"] = "Coinbit Mainnet";
    ChainName["Dehvo"] = "Dehvo";
    ChainName["FlareTestnetCoston2"] = "Flare Testnet Coston2";
    ChainName["DeBankTestnet(Deprecated)"] = "DeBank Testnet(Deprecated)";
    ChainName["DeBankMainnet"] = "DeBank Mainnet";
    ChainName["UptickMainnet"] = "Uptick Mainnet";
    ChainName["ArcologyTestnet"] = "Arcology Testnet";
    ChainName["ENULSMainnet"] = "ENULS Mainnet";
    ChainName["ENULSTestnet"] = "ENULS Testnet";
    ChainName["RealchainMainnet"] = "Realchain Mainnet";
    ChainName["FuseMainnet"] = "Fuse Mainnet";
    ChainName["FuseSparknet"] = "Fuse Sparknet";
    ChainName["DecentralizedWebMainnet"] = "Decentralized Web Mainnet";
    ChainName["OYchainTestnet"] = "OYchain Testnet";
    ChainName["OYchainMainnet"] = "OYchain Mainnet";
    ChainName["Factory127Mainnet"] = "Factory 127 Mainnet";
    ChainName["HuobiECOChainMainnet"] = "Huobi ECO Chain Mainnet";
    ChainName["InnovatorChain"] = "Innovator Chain";
    ChainName["EngramTestnet"] = "Engram Testnet";
    ChainName["IExecSidechain"] = "iExec Sidechain";
    ChainName["AlyxChainTestnet"] = "Alyx Chain Testnet";
    ChainName["DeamchainMainnet"] = "Deamchain Mainnet";
    ChainName["PolygonMainnet"] = "Polygon Mainnet";
    ChainName["DefiOracleMetaMainnet"] = "Defi Oracle Meta Mainnet";
    ChainName["WoopChainMainnet"] = "WoopChain Mainnet";
    ChainName["OpenpieceTestnet"] = "Openpiece Testnet";
    ChainName["DAXCHAIN"] = "DAX CHAIN";
    ChainName["PHINetworkv2"] = "PHI Network v2";
    ChainName["ShimmerEVM"] = "ShimmerEVM";
    ChainName["SixProtocolTestnet"] = "Six Protocol Testnet";
    ChainName["RedbellyNetworkMainnet"] = "Redbelly Network Mainnet";
    ChainName["RedbellyNetworkDevnet"] = "Redbelly Network Devnet";
    ChainName["RedbellyNetworkTestnet"] = "Redbelly Network Testnet";
    ChainName["RedbellyNetworkTGE"] = "Redbelly Network TGE";
    ChainName["TenetTestnet"] = "Tenet Testnet";
    ChainName["OEBlockTestnet"] = "OEBlock Testnet";
    ChainName["ArmoniaEvaChainMainnet"] = "Armonia Eva Chain Mainnet";
    ChainName["ArmoniaEvaChainTestnet"] = "Armonia Eva Chain Testnet";
    ChainName["LightstreamsTestnet"] = "Lightstreams Testnet";
    ChainName["LightstreamsMainnet"] = "Lightstreams Mainnet";
    ChainName["OmniTestnet"] = "Omni Testnet";
    ChainName["AtoshiTestnet"] = "Atoshi Testnet";
    ChainName["AIOZNetwork"] = "AIOZ Network";
    ChainName["MantaPacificMainnet"] = "Manta Pacific Mainnet";
    ChainName["HOOSmartChainTestnet"] = "HOO Smart Chain Testnet";
    ChainName["Latam-BlockchainResilTestnet"] = "Latam-Blockchain Resil Testnet";
    ChainName["AMEChainMainnet"] = "AME Chain Mainnet";
    ChainName["SeeleMainnet"] = "Seele Mainnet";
    ChainName["BMCMainnet"] = "BMC Mainnet";
    ChainName["BMCTestnet"] = "BMC Testnet";
    ChainName["CryptoEmergency"] = "Crypto Emergency";
    ChainName["X1Testnet"] = "X1 Testnet";
    ChainName["X1Mainnet"] = "X1 Mainnet";
    ChainName["NeutrinosTestNet"] = "Neutrinos TestNet";
    ChainName["BitchainMainnet"] = "Bitchain Mainnet";
    ChainName["BitTorrentChainMainnet"] = "BitTorrent Chain Mainnet";
    ChainName["ArbitrumonxDai"] = "Arbitrum on xDai";
    ChainName["MOACtestnet"] = "MOAC testnet";
    ChainName["OpBNBMainnet"] = "opBNB Mainnet";
    ChainName["VinuChainTestnet"] = "VinuChain Testnet";
    ChainName["VinuChainNetwork"] = "VinuChain Network";
    ChainName["StructxMainnet"] = "Structx Mainnet";
    ChainName["Bitnet"] = "Bitnet";
    ChainName["FreightTrustNetwork"] = "Freight Trust Network";
    ChainName["MAPMakalu"] = "MAP Makalu";
    ChainName["ShinariumMainnet"] = "Shinarium Mainnet";
    ChainName["SiriusNetV2"] = "SiriusNet V2";
    ChainName["SoterOneMainnetold"] = "SoterOne Mainnet old";
    ChainName["ScalindTestnet"] = "Scalind Testnet";
    ChainName["Permission"] = "Permission";
    ChainName["LACHAINMainnet"] = "LACHAIN Mainnet";
    ChainName["LACHAINTestnet"] = "LACHAIN Testnet";
    ChainName["SwapDEX"] = "SwapDEX";
    ChainName["DeamchainTestnet"] = "Deamchain Testnet";
    ChainName["BlastMainnet"] = "Blast Mainnet";
    ChainName["PlingaMainnet"] = "Plinga Mainnet";
    ChainName["EnergyWebChain"] = "Energy Web Chain";
    ChainName["OasysMainnet"] = "Oasys Mainnet";
    ChainName["FantomOpera"] = "Fantom Opera";
    ChainName["FraxtalMainnet"] = "Fraxtal Mainnet";
    ChainName["Kroma"] = "Kroma";
    ChainName["HuobiECOChainTestnet"] = "Huobi ECO Chain Testnet";
    ChainName["Setheum"] = "Setheum";
    ChainName["NeonlinkMainnet"] = "Neonlink Mainnet";
    ChainName["SURBlockchainNetwork"] = "SUR Blockchain Network";
    ChainName["HighPerformanceBlockchain"] = "High Performance Blockchain";
    ChainName["EgonCoinMainnet"] = "EgonCoin Mainnet";
    ChainName["LaChain"] = "LaChain";
    ChainName["ZkSyncEraGoerliTestnet(deprecated)"] = "zkSync Era Goerli Testnet (deprecated)";
    ChainName["BobaNetwork"] = "Boba Network";
    ChainName["OrderlyMainnet"] = "Orderly Mainnet";
    ChainName["HederaMainnet"] = "Hedera Mainnet";
    ChainName["HederaTestnet"] = "Hedera Testnet";
    ChainName["HederaPreviewnet"] = "Hedera Previewnet";
    ChainName["HederaLocalnet"] = "Hedera Localnet";
    ChainName["ZkSyncSepoliaTestnet"] = "zkSync Sepolia Testnet";
    ChainName["Bobaopera"] = "Bobaopera";
    ChainName["NeurochainTestnet"] = "Neurochain Testnet";
    ChainName["WyzthTestnet"] = "Wyzth Testnet";
    ChainName["OmaxMainnet"] = "Omax Mainnet";
    ChainName["NeurochainMainnet"] = "Neurochain Mainnet";
    ChainName["Filecoin-Mainnet"] = "Filecoin - Mainnet";
    ChainName["KCCMainnet"] = "KCC Mainnet";
    ChainName["KCCTestnet"] = "KCC Testnet";
    ChainName["ZkSyncMainnet"] = "zkSync Mainnet";
    ChainName["Web3QMainnet"] = "Web3Q Mainnet";
    ChainName["DFKChainTest"] = "DFK Chain Test";
    ChainName["Shiden"] = "Shiden";
    ChainName["CronosTestnet"] = "Cronos Testnet";
    ChainName["ThetaMainnet"] = "Theta Mainnet";
    ChainName["ThetaSapphireTestnet"] = "Theta Sapphire Testnet";
    ChainName["ThetaAmberTestnet"] = "Theta Amber Testnet";
    ChainName["ThetaTestnet"] = "Theta Testnet";
    ChainName["PulseChain"] = "PulseChain";
    ChainName["ConstaTestnet"] = "Consta Testnet";
    ChainName["ZKAmoebaTestnet"] = "ZKAmoeba Testnet";
    ChainName["ZKAmoebaMainnet"] = "ZKAmoeba Mainnet";
    ChainName["Lisinski"] = "Lisinski";
    ChainName["Nativ3Mainnet"] = "Nativ3 Mainnet";
    ChainName["HyperonChainTestNet"] = "HyperonChain TestNet";
    ChainName["OzoneChainTestnet"] = "Ozone Chain Testnet";
    ChainName["PepeChainMainnet"] = "Pepe Chain Mainnet";
    ChainName["SXNetworkMainnet"] = "SX Network Mainnet";
    ChainName["LaTestnet"] = "LaTestnet";
    ChainName["OptimismGoerliTestnet"] = "Optimism Goerli Testnet";
    ChainName["PGN(PublicGoodsNetwork)"] = "PGN (Public Goods Network)";
    ChainName["ZeethChain"] = "Zeeth Chain";
    ChainName["GesoVerse"] = "Geso Verse";
    ChainName["TenTestnet"] = "Ten Testnet";
    ChainName["SynapseChainTestnet"] = "Synapse Chain Testnet";
    ChainName["ARZIOChain"] = "ARZIO Chain";
    ChainName["AreonNetworkTestnet"] = "Areon Network Testnet";
    ChainName["AreonNetworkMainnet"] = "Areon Network Mainnet";
    ChainName["Rupaya"] = "Rupaya";
    ChainName["CaminoC-Chain"] = "Camino C-Chain";
    ChainName["ColumbusTestNetwork"] = "Columbus Test Network";
    ChainName["Double-AChainMainnet"] = "Double-A Chain Mainnet";
    ChainName["Double-AChainTestnet"] = "Double-A Chain Testnet";
    ChainName["GearZeroNetworkMainnet"] = "Gear Zero Network Mainnet";
    ChainName["XTSmartChainMainnet"] = "XT Smart Chain Mainnet";
    ChainName["FirechainMainnet"] = "Firechain Mainnet";
    ChainName["F(x)CoreMainnetNetwork"] = "F(x)Core Mainnet Network";
    ChainName["Candle"] = "Candle";
    ChainName["PAWCHAINTestnet"] = "PAWCHAIN Testnet";
    ChainName["Vela1ChainMainnet"] = "Vela1 Chain Mainnet";
    ChainName["TaoNetwork"] = "Tao Network";
    ChainName["DogechainTestnet"] = "Dogechain Testnet";
    ChainName["RolluxMainnet"] = "Rollux Mainnet";
    ChainName["MetaChainMainnet"] = "MetaChain Mainnet";
    ChainName["MetisStardustTestnet"] = "Metis Stardust Testnet";
    ChainName["Astar"] = "Astar";
    ChainName["AcalaMandalaTestnetTC9"] = "Acala Mandala Testnet TC9";
    ChainName["KaruraNetworkTestnet"] = "Karura Network Testnet";
    ChainName["AcalaNetworkTestnet"] = "Acala Network Testnet";
    ChainName["MetisGoerliTestnet"] = "Metis Goerli Testnet";
    ChainName["Meshnyantestnet"] = "Meshnyan testnet";
    ChainName["VineTestnet"] = "Vine Testnet";
    ChainName["EIOBMainnet"] = "EIOB Mainnet";
    ChainName["GraphlinqBlockchainMainnet"] = "Graphlinq Blockchain Mainnet";
    ChainName["Avocado"] = "Avocado";
    ChainName["SXNetworkTestnet"] = "SX Network Testnet";
    ChainName["EnduranceSmartChainMainnet"] = "Endurance Smart Chain Mainnet";
    ChainName["KalichainTestnet"] = "Kalichain Testnet";
    ChainName["Kalichain"] = "Kalichain";
    ChainName["PixieChainTestnet"] = "Pixie Chain Testnet";
    ChainName["LAOSArrakis"] = "LAOS Arrakis";
    ChainName["JuncaChain"] = "JuncaChain";
    ChainName["JuncaChaintestnet"] = "JuncaChain testnet";
    ChainName["KaruraNetwork"] = "Karura Network";
    ChainName["StarSocialTestnet"] = "Star Social Testnet";
    ChainName["BlockChainStationMainnet"] = "BlockChain Station Mainnet";
    ChainName["BlockChainStationTestnet"] = "BlockChain Station Testnet";
    ChainName["Highbury"] = "Highbury";
    ChainName["ShibariumBeta"] = "Shibarium Beta";
    ChainName["LycanChain"] = "Lycan Chain";
    ChainName["Blucrates"] = "Blucrates";
    ChainName["CantoTestnet"] = "Canto Testnet";
    ChainName["VentionSmartChainTestnet"] = "Vention Smart Chain Testnet";
    ChainName["ScriptTestnet"] = "Script Testnet";
    ChainName["QL1"] = "QL1";
    ChainName["OpenChainTestnet"] = "OpenChain Testnet";
    ChainName["CheapETH"] = "cheapETH";
    ChainName["MAALChain"] = "MAAL Chain";
    ChainName["AcalaNetwork"] = "Acala Network";
    ChainName["AerochainTestnet"] = "Aerochain Testnet";
    ChainName["Patex"] = "Patex";
    ChainName["LucidBlockchain"] = "Lucid Blockchain";
    ChainName["Haic"] = "Haic";
    ChainName["PortalFantasyChainTest"] = "Portal Fantasy Chain Test";
    ChainName["Haven1Testnet"] = "Haven1 Testnet";
    ChainName["Qitmeer"] = "Qitmeer";
    ChainName["FirechainzkEVM"] = "Firechain zkEVM";
    ChainName["BeOneChainMainnet"] = "BeOne Chain Mainnet";
    ChainName["CallistoMainnet"] = "Callisto Mainnet";
    ChainName["CallistoTestnetDeprecated"] = "Callisto Testnet Deprecated";
    ChainName["TaraxaMainnet"] = "Taraxa Mainnet";
    ChainName["TaraxaTestnet"] = "Taraxa Testnet";
    ChainName["ZeethChainDev"] = "Zeeth Chain Dev";
    ChainName["FantasiaChainMainnet"] = "Fantasia Chain Mainnet";
    ChainName["BandaiNamcoResearchVerseMainnet"] = "Bandai Namco Research Verse Mainnet";
    ChainName["DexitNetwork"] = "Dexit Network";
    ChainName["AmbrosChainMainnet"] = "Ambros Chain Mainnet";
    ChainName["Wanchain"] = "Wanchain";
    ChainName["GarizonTestnetStage0"] = "Garizon Testnet Stage0";
    ChainName["GarizonTestnetStage1"] = "Garizon Testnet Stage1";
    ChainName["GarizonTestnetStage2"] = "Garizon Testnet Stage2";
    ChainName["GarizonTestnetStage3"] = "Garizon Testnet Stage3";
    ChainName["PortalFantasyChain"] = "Portal Fantasy Chain";
    ChainName["DecentraBoneLayer1Testnet"] = "DecentraBone Layer1 Testnet";
    ChainName["RiniaTestnet"] = "Rinia Testnet";
    ChainName["ModeTestnet"] = "Mode Testnet";
    ChainName["YidarkChainMainnet"] = "Yidark Chain Mainnet";
    ChainName["PulseChainTestnet"] = "PulseChain Testnet";
    ChainName["PulseChainTestnetv2b"] = "PulseChain Testnet v2b";
    ChainName["PulseChainTestnetv3"] = "PulseChain Testnet v3";
    ChainName["PulseChainTestnetv4"] = "PulseChain Testnet v4";
    ChainName["MuNodeTestnet"] = "muNode Testnet";
    ChainName["LyraChain"] = "Lyra Chain";
    ChainName["BTC20SmartChain"] = "BTC20 Smart Chain";
    ChainName["OortMainnet"] = "Oort Mainnet";
    ChainName["OortHuygens"] = "Oort Huygens";
    ChainName["OortAscraeus"] = "Oort Ascraeus";
    ChainName["NepalBlockchainNetwork"] = "Nepal Blockchain Network";
    ChainName["TOPMainnetEVM"] = "TOP Mainnet EVM";
    ChainName["MemoSmartChainMainnet"] = "Memo Smart Chain Mainnet";
    ChainName["TOPMainnet"] = "TOP Mainnet";
    ChainName["ELibertyMainnet"] = "eLiberty Mainnet";
    ChainName["5ireChainThunder"] = "5ireChain Thunder";
    ChainName["LuckyNetwork"] = "Lucky Network";
    ChainName["WanchainTestnet"] = "Wanchain Testnet";
    ChainName["GTONMainnet"] = "GTON Mainnet";
    ChainName["KlaytnTestnetBaobab"] = "Klaytn Testnet Baobab";
    ChainName["TectumEmissionToken"] = "Tectum Emission Token";
    ChainName["T-EKTA"] = "T-EKTA";
    ChainName["NewtonTestnet"] = "Newton Testnet";
    ChainName["EurusMainnet"] = "Eurus Mainnet";
    ChainName["EvriceNetwork"] = "Evrice Network";
    ChainName["Newton"] = "Newton";
    ChainName["Sakura"] = "Sakura";
    ChainName["CloverTestnet"] = "Clover Testnet";
    ChainName["CLVParachain"] = "CLV Parachain";
    ChainName["BitTorrentChainTestnet"] = "BitTorrent Chain Testnet";
    ChainName["ConfluxeSpace"] = "Conflux eSpace";
    ChainName["ProxyNetworkTestnet"] = "Proxy Network Testnet";
    ChainName["BronosTestnet"] = "Bronos Testnet";
    ChainName["BronosMainnet"] = "Bronos Mainnet";
    ChainName["ShimmerEVMTestnetDeprecated"] = "ShimmerEVM Testnet Deprecated";
    ChainName["ShimmerEVMTestnetDeprecated1072"] = "ShimmerEVM Testnet Deprecated 1072";
    ChainName["ShimmerEVMTestnet"] = "ShimmerEVM Testnet";
    ChainName["MintaraTestnet"] = "Mintara Testnet";
    ChainName["MintaraMainnet"] = "Mintara Mainnet";
    ChainName["MetisAndromedaMainnet"] = "Metis Andromeda Mainnet";
    ChainName["Humans.aiMainnet"] = "Humans.ai Mainnet";
    ChainName["MOACmainnet"] = "MOAC mainnet";
    ChainName["PolygonzkEVM"] = "Polygon zkEVM";
    ChainName["BLXqTestnet"] = "BLXq Testnet";
    ChainName["BLXqMainnet"] = "BLXq Mainnet";
    ChainName["WEMIX3.0Mainnet"] = "WEMIX3.0 Mainnet";
    ChainName["WEMIX3.0Testnet"] = "WEMIX3.0 Testnet";
    ChainName["CoreBlockchainTestnet"] = "Core Blockchain Testnet";
    ChainName["CoreBlockchainMainnet"] = "Core Blockchain Mainnet";
    ChainName["DogcoinMainnet"] = "Dogcoin Mainnet";
    ChainName["DeFiChainEVMNetworkMainnet"] = "DeFiChain EVM Network Mainnet";
    ChainName["DeFiChainEVMNetworkTestnet"] = "DeFiChain EVM Network Testnet";
    ChainName["DeFiMetaChainChangiTestnet"] = "DeFiMetaChain Changi Testnet";
    ChainName["AmStarTestnet"] = "AmStar Testnet";
    ChainName["MathChain"] = "MathChain";
    ChainName["MathChainTestnet"] = "MathChain Testnet";
    ChainName["SymplexiaSmartChain"] = "Symplexia Smart Chain";
    ChainName["OriginTestnet"] = "Origin Testnet";
    ChainName["SmartHostTeknolojiTESTNET"] = "Smart Host Teknoloji TESTNET";
    ChainName["IoraChain"] = "Iora Chain";
    ChainName["EvanescoTestnet"] = "Evanesco Testnet";
    ChainName["WorldTradeTechnicalChainMainnet"] = "World Trade Technical Chain Mainnet";
    ChainName["PopcateumMainnet"] = "Popcateum Mainnet";
    ChainName["EnterChainMainnet"] = "EnterChain Mainnet";
    ChainName["ExzoNetworkMainnet"] = "Exzo Network Mainnet";
    ChainName["UltronTestnet"] = "Ultron Testnet";
    ChainName["UltronMainnet"] = "Ultron Mainnet";
    ChainName["StepNetwork"] = "Step Network";
    ChainName["ARCMainnet"] = "ARC Mainnet";
    ChainName["ARCTestnet"] = "ARC Testnet";
    ChainName["OMPlatformMainnet"] = "OM Platform Mainnet";
    ChainName["DogetherMainnet"] = "Dogether Mainnet";
    ChainName["CICChainTestnet"] = "CIC Chain Testnet";
    ChainName["HALOMainnet"] = "HALO Mainnet";
    ChainName["Moonbeam"] = "Moonbeam";
    ChainName["Moonriver"] = "Moonriver";
    ChainName["Moonrockold"] = "Moonrock old";
    ChainName["MoonbaseAlpha"] = "Moonbase Alpha";
    ChainName["Moonrock"] = "Moonrock";
    ChainName["SwisstronikTestnet"] = "Swisstronik Testnet";
    ChainName["Bobabeam"] = "Bobabeam";
    ChainName["BobabaseTestnet"] = "Bobabase Testnet";
    ChainName["DosFujiSubnet"] = "Dos Fuji Subnet";
    ChainName["AlyxMainnet"] = "Alyx Mainnet";
    ChainName["AIAMainnet"] = "AIA Mainnet";
    ChainName["AIATestnet"] = "AIA Testnet";
    ChainName["GethTestnet"] = "Geth Testnet";
    ChainName["ElysiumTestnet"] = "Elysium Testnet";
    ChainName["ElysiumMainnet"] = "Elysium Mainnet";
    ChainName["BlitzSubnet"] = "Blitz Subnet";
    ChainName["CICChainMainnet"] = "CIC Chain Mainnet";
    ChainName["ZafiriumMainnet"] = "Zafirium Mainnet";
    ChainName["KalarChain"] = "Kalar Chain";
    ChainName["AmStarMainnet"] = "AmStar Mainnet";
    ChainName["JoseonMainnet"] = "Joseon Mainnet";
    ChainName["PolygonzkEVMTestnetold"] = "Polygon zkEVM Testnet old";
    ChainName["PolygonzkEVMTestnetPreAudit-Upgraded"] = "Polygon zkEVM Testnet Pre Audit-Upgraded";
    ChainName["RikezaNetworkMainnet"] = "Rikeza Network Mainnet";
    ChainName["LivingAssetsMainnet"] = "Living Assets Mainnet";
    ChainName["PolygonzkEVMTestnet"] = "Polygon zkEVM Testnet";
    ChainName["GILTestnet"] = "GIL Testnet";
    ChainName["CtexScanBlockchain"] = "Ctex Scan Blockchain";
    ChainName["BEVMCanary"] = "BEVM Canary";
    ChainName["SherpaxMainnet"] = "Sherpax Mainnet";
    ChainName["SherpaxTestnet"] = "Sherpax Testnet";
    ChainName["BeagleMessagingChain"] = "Beagle Messaging Chain";
    ChainName["Tenet"] = "Tenet";
    ChainName["CatecoinChainMainnet"] = "Catecoin Chain Mainnet";
    ChainName["Atheios"] = "Atheios";
    ChainName["Btachain"] = "Btachain";
    ChainName["Liquichain"] = "Liquichain";
    ChainName["HorizenGobiTestnet"] = "Horizen Gobi Testnet";
    ChainName["LUDANMainnet"] = "LUDAN Mainnet";
    ChainName["AnytypeEVMChain"] = "Anytype EVM Chain";
    ChainName["TBSIMainnet"] = "TBSI Mainnet";
    ChainName["TBSITestnet"] = "TBSI Testnet";
    ChainName["PaletteChainMainnet"] = "Palette Chain Mainnet";
    ChainName["PartyChain"] = "PartyChain";
    ChainName["GaussMainnet"] = "Gauss Mainnet";
    ChainName["Kerleano"] = "Kerleano";
    ChainName["RabbitAnalogTestnetChain"] = "Rabbit Analog Testnet Chain";
    ChainName["CubeChainMainnet"] = "Cube Chain Mainnet";
    ChainName["CubeChainTestnet"] = "Cube Chain Testnet";
    ChainName["RubySmartChainMAINNET"] = "Ruby Smart Chain MAINNET";
    ChainName["Teslafunds"] = "Teslafunds";
    ChainName["WhiteBITNetwork"] = "WhiteBIT Network";
    ChainName["GitshockCartenzTestnet"] = "Gitshock Cartenz Testnet";
    ChainName["LightlinkPhoenixMainnet"] = "Lightlink Phoenix Mainnet";
    ChainName["LightlinkPegasusTestnet"] = "Lightlink Pegasus Testnet";
    ChainName["BONNetwork"] = "BON Network";
    ChainName["SportsChainNetwork"] = "Sports Chain Network";
    ChainName["BitcichainMainnet"] = "Bitcichain Mainnet";
    ChainName["BitcichainTestnet"] = "Bitcichain Testnet";
    ChainName["MerkleScan"] = "Merkle Scan";
    ChainName["Scalind"] = "Scalind";
    ChainName["RubySmartChainTestnet"] = "Ruby Smart Chain Testnet";
    ChainName["ONUSChainTestnet"] = "ONUS Chain Testnet";
    ChainName["D-ChainMainnet"] = "D-Chain Mainnet";
    ChainName["DexillaTestnet"] = "Dexilla Testnet";
    ChainName["Eleanor"] = "Eleanor";
    ChainName["SuperSmartChainTestnet"] = "Super Smart Chain Testnet";
    ChainName["SuperSmartChainMainnet"] = "Super Smart Chain Mainnet";
    ChainName["Atelier"] = "Atelier";
    ChainName["RedeCoin"] = "RedeCoin";
    ChainName["ONUSChainMainnet"] = "ONUS Chain Mainnet";
    ChainName["EurusTestnet"] = "Eurus Testnet";
    ChainName["SatoshIE"] = "SatoshIE";
    ChainName["SatoshIETestnet"] = "SatoshIE Testnet";
    ChainName["EtherGem"] = "EtherGem";
    ChainName["Ekta"] = "Ekta";
    ChainName["EdeXaTestnet"] = "edeXa Testnet";
    ChainName["KyotoTestnet"] = "Kyoto Testnet";
    ChainName["DogechainMainnet"] = "Dogechain Mainnet";
    ChainName["MilkomedaC1Mainnet"] = "Milkomeda C1 Mainnet";
    ChainName["MilkomedaA1Mainnet"] = "Milkomeda A1 Mainnet";
    ChainName["CloudWalkTestnet"] = "CloudWalk Testnet";
    ChainName["CloudWalkMainnet"] = "CloudWalk Mainnet";
    ChainName["MainnetZMainnet"] = "MainnetZ Mainnet";
    ChainName["PublicMintDevnet"] = "PublicMint Devnet";
    ChainName["PublicMintTestnet"] = "PublicMint Testnet";
    ChainName["PublicMintMainnet"] = "PublicMint Mainnet";
    ChainName["EdgewareEdgeEVMMainnet"] = "Edgeware EdgeEVM Mainnet";
    ChainName["BeresheetBereEVMTestnet"] = "Beresheet BereEVM Testnet";
    ChainName["TaycanTestnet"] = "Taycan Testnet";
    ChainName["RangersProtocolMainnet"] = "Rangers Protocol Mainnet";
    ChainName["Centrifuge"] = "Centrifuge";
    ChainName["Catalyst"] = "Catalyst";
    ChainName["PhalaNetwork"] = "Phala Network";
    ChainName["KiwiSubnet"] = "Kiwi Subnet";
    ChainName["ShrapnelTestnet"] = "Shrapnel Testnet";
    ChainName["OriginTrailParachain"] = "OriginTrail Parachain";
    ChainName["ShrapnelSubnet"] = "Shrapnel Subnet";
    ChainName["StratosTestnet"] = "Stratos Testnet";
    ChainName["Stratos"] = "Stratos";
    ChainName["MovoSmartChainMainnet"] = "Movo Smart Chain Mainnet";
    ChainName["QuokkacoinMainnet"] = "Quokkacoin Mainnet";
    ChainName["Altair"] = "Altair";
    ChainName["Algol"] = "Algol";
    ChainName["EcoballMainnet"] = "Ecoball Mainnet";
    ChainName["EcoballTestnetEspuma"] = "Ecoball Testnet Espuma";
    ChainName["ExosamaNetwork"] = "Exosama Network";
    ChainName["MetaplayeroneMainnet"] = "Metaplayerone Mainnet";
    ChainName["MetaplayeroneDubaiTestnet"] = "Metaplayerone Dubai Testnet";
    ChainName["BigShortBets"] = "BigShortBets";
    ChainName["DefiOracleMetaTestnet"] = "Defi Oracle Meta Testnet";
    ChainName["BOSagoraMainnet"] = "BOSagora Mainnet";
    ChainName["FindoraMainnet"] = "Findora Mainnet";
    ChainName["FindoraTestnet"] = "Findora Testnet";
    ChainName["FindoraForge"] = "Findora Forge";
    ChainName["MoonsamaNetwork"] = "Moonsama Network";
    ChainName["AntofyMainnet"] = "Antofy Mainnet";
    ChainName["BitcoinEVM"] = "Bitcoin EVM";
    ChainName["EvanescoMainnet"] = "Evanesco Mainnet";
    ChainName["KavaTestnet"] = "Kava Testnet";
    ChainName["Kava"] = "Kava";
    ChainName["VChainMainnet"] = "VChain Mainnet";
    ChainName["KrestNetwork"] = "Krest Network";
    ChainName["BOMBChain"] = "BOMB Chain";
    ChainName["EbroNetwork"] = "Ebro Network";
    ChainName["Arevia"] = "Arevia";
    ChainName["SOMANetworkTestnet"] = "SOMA Network Testnet";
    ChainName["Altcoinchain"] = "Altcoinchain";
    ChainName["SOMANetworkMainnet"] = "SOMA Network Mainnet";
    ChainName["(deprecated)KromaSepolia"] = "(deprecated) Kroma Sepolia";
    ChainName["KromaSepolia"] = "Kroma Sepolia";
    ChainName["BOMBChainTestnet"] = "BOMB Chain Testnet";
    ChainName["TCGVerseMainnet"] = "TCG Verse Mainnet";
    ChainName["XODEX"] = "XODEX";
    ChainName["HybridChainNetworkTestnet"] = "Hybrid Chain Network Testnet";
    ChainName["HybridChainNetworkMainnet"] = "Hybrid Chain Network Mainnet";
    ChainName["UnicornUltraNebulasTestnet"] = "Unicorn Ultra Nebulas Testnet";
    ChainName["FraxtalTestnet"] = "Fraxtal Testnet";
    ChainName["KorthoMainnet"] = "Kortho Mainnet";
    ChainName["TechPayMainnet"] = "TechPay Mainnet";
    ChainName["PoCRNet"] = "PoCRNet";
    ChainName["RedlightChainMainnet"] = "Redlight Chain Mainnet";
    ChainName["EZChainC-ChainMainnet"] = "EZChain C-Chain Mainnet";
    ChainName["EZChainC-ChainTestnet"] = "EZChain C-Chain Testnet";
    ChainName["WhiteBITNetworkTestnet"] = "WhiteBIT Network Testnet";
    ChainName["MorphTestnet"] = "Morph Testnet";
    ChainName["K-LAOS"] = "K-LAOS";
    ChainName["BobaNetworkGoerliTestnet"] = "Boba Network Goerli Testnet";
    ChainName["BitYuanMainnet"] = "BitYuan Mainnet";
    ChainName["CENNZnetRata"] = "CENNZnet Rata";
    ChainName["CENNZnetNikau"] = "CENNZnet Nikau";
    ChainName["CanxiumMainnet"] = "Canxium Mainnet";
    ChainName["PLAYA3ULLGAMES"] = "PLAYA3ULL GAMES";
    ChainName["OrlandoChain"] = "Orlando Chain";
    ChainName["BifrostMainnet"] = "Bifrost Mainnet";
    ChainName["Immu3EVM"] = "Immu3 EVM";
    ChainName["VultureEVMBeta"] = "Vulture EVM Beta";
    ChainName["Filecoin-Hyperspacetestnet"] = "Filecoin - Hyperspace testnet";
    ChainName["Dubxcoinnetwork"] = "Dubxcoin network";
    ChainName["Dubxcointestnet"] = "Dubxcoin testnet";
    ChainName["DebounceSubnetTestnet"] = "Debounce Subnet Testnet";
    ChainName["ZCoreTestnet"] = "ZCore Testnet";
    ChainName["Web3QTestnet"] = "Web3Q Testnet";
    ChainName["Web3QGalileo"] = "Web3Q Galileo";
    ChainName["ParibuNetMainnet"] = "Paribu Net Mainnet";
    ChainName["SecureChainTestnet"] = "SecureChain Testnet";
    ChainName["ParibuNetTestnet"] = "Paribu Net Testnet";
    ChainName["JFINChain"] = "JFIN Chain";
    ChainName["PandoProjectMainnet"] = "PandoProject Mainnet";
    ChainName["PandoProjectTestnet"] = "PandoProject Testnet";
    ChainName["BotanixTestnet"] = "Botanix Testnet";
    ChainName["BotanixMainnet"] = "Botanix Mainnet";
    ChainName["IChainNetwork"] = "iChain Network";
    ChainName["JouleverseMainnet"] = "Jouleverse Mainnet";
    ChainName["BittexMainnet"] = "Bittex Mainnet";
    ChainName["EmpireNetwork"] = "Empire Network";
    ChainName["SenjePowersTestnet"] = "SenjePowers Testnet";
    ChainName["SenjePowersMainnet"] = "SenjePowers Mainnet";
    ChainName["XplaTestnet"] = "Xpla Testnet";
    ChainName["Crossbell"] = "Crossbell";
    ChainName["AlveyChainMainnet"] = "AlveyChain Mainnet";
    ChainName["TangleTestnet"] = "Tangle Testnet";
    ChainName["FirechainzkEVMGhostrider"] = "Firechain zkEVM Ghostrider";
    ChainName["KalyChainMainnet"] = "KalyChain Mainnet";
    ChainName["KalyChainTestnet"] = "KalyChain Testnet";
    ChainName["DRACNetwork"] = "DRAC Network";
    ChainName["DOSTesnet"] = "DOS Tesnet";
    ChainName["DYNOMainnet"] = "DYNO Mainnet";
    ChainName["DYNOTestnet"] = "DYNO Testnet";
    ChainName["YuanChainMainnet"] = "YuanChain Mainnet";
    ChainName["OzoneChainMainnet"] = "Ozone Chain Mainnet";
    ChainName["PeperiumChainTestnet"] = "Peperium Chain Testnet";
    ChainName["FantomTestnet"] = "Fantom Testnet";
    ChainName["X1Fastnet"] = "X1 Fastnet";
    ChainName["BobaoperaTestnet"] = "Bobaopera Testnet";
    ChainName["Nahmii3Mainnet"] = "Nahmii 3 Mainnet";
    ChainName["Nahmii3Testnet"] = "Nahmii 3 Testnet";
    ChainName["MusterMainnet"] = "Muster Mainnet";
    ChainName["FastexChain(Bahamut)OasisTestnet"] = "Fastex Chain (Bahamut) Oasis Testnet";
    ChainName["BitindiTestnet"] = "Bitindi Testnet";
    ChainName["BitindiMainnet"] = "Bitindi Mainnet";
    ChainName["AIOZNetworkTestnet"] = "AIOZ Network Testnet";
    ChainName["Humans.aiTestnet"] = "Humans.ai Testnet";
    ChainName["TipboxcoinTestnet"] = "Tipboxcoin Testnet";
    ChainName["PHINetworkV1"] = "PHI Network V1";
    ChainName["LUKSOTestnet"] = "LUKSO Testnet";
    ChainName["NexiMainnet"] = "Nexi Mainnet";
    ChainName["NexiV2Mainnet"] = "Nexi V2 Mainnet";
    ChainName["BobafujiTestnet"] = "Bobafuji Testnet";
    ChainName["Beam"] = "Beam";
    ChainName["CreditSmartChainMainnet"] = "Credit Smart Chain Mainnet";
    ChainName["HtmlcoinMainnet"] = "Htmlcoin Mainnet";
    ChainName["OrderlySepoliaTestnet"] = "Orderly Sepolia Testnet";
    ChainName["IoTeXNetworkMainnet"] = "IoTeX Network Mainnet";
    ChainName["IoTeXNetworkTestnet"] = "IoTeX Network Testnet";
    ChainName["MEVerseChainTestnet"] = "MEVerse Chain Testnet";
    ChainName["BlackFortExchangeNetworkTestnet"] = "BlackFort Exchange Network Testnet";
    ChainName["GlobelChain"] = "Globel Chain";
    ChainName["VenidiumTestnet"] = "Venidium Testnet";
    ChainName["VenidiumMainnet"] = "Venidium Mainnet";
    ChainName["BlackFortExchangeNetwork"] = "BlackFort Exchange Network";
    ChainName["Mantle"] = "Mantle";
    ChainName["MantleTestnet"] = "Mantle Testnet";
    ChainName["TreasurenetMainnetAlpha"] = "Treasurenet Mainnet Alpha";
    ChainName["MantleSepoliaTestnet"] = "Mantle Sepolia Testnet";
    ChainName["TreasurenetTestnet"] = "Treasurenet Testnet";
    ChainName["Bahamut"] = "Bahamut";
    ChainName["SmartLayerNetwork"] = "Smart Layer Network";
    ChainName["TLChainNetworkMainnet"] = "TLChain Network Mainnet";
    ChainName["EraSwapMainnet"] = "EraSwap Mainnet";
    ChainName["HumanodeMainnet"] = "Humanode Mainnet";
    ChainName["FirechainMainnetOld"] = "Firechain Mainnet Old";
    ChainName["UzmiNetworkMainnet"] = "Uzmi Network Mainnet";
    ChainName["TritaniumTestnet"] = "Tritanium Testnet";
    ChainName["VEXEVMTESTNET"] = "VEX EVM TESTNET";
    ChainName["NahmiiMainnet"] = "Nahmii Mainnet";
    ChainName["NahmiiTestnet"] = "Nahmii Testnet";
    ChainName["ChainVerseMainnet"] = "Chain Verse Mainnet";
    ChainName["OpBNBTestnet"] = "opBNB Testnet";
    ChainName["ArcturusChainTestnet"] = "Arcturus Chain Testnet";
    ChainName["TanssiEVMContainerChain"] = "Tanssi EVM ContainerChain";
    ChainName["SyscoinTanenbaumTestnet"] = "Syscoin Tanenbaum Testnet";
    ChainName["HikaNetworkTestnet"] = "Hika Network Testnet";
    ChainName["SatoshiChainTestnet"] = "SatoshiChain Testnet";
    ChainName["Ganache"] = "Ganache";
    ChainName["OntologyTestnet"] = "Ontology Testnet";
    ChainName["WegochainRubidiumMainnet"] = "Wegochain Rubidium Mainnet";
    ChainName["TresTestnet"] = "Tres Testnet";
    ChainName["TresMainnet"] = "Tres Mainnet";
    ChainName["CascadiaTestnet"] = "Cascadia Testnet";
    ChainName["UPTNTestnet"] = "UPTN Testnet";
    ChainName["UPTN"] = "UPTN";
    ChainName["DigitSoulSmartChain"] = "Digit Soul Smart Chain";
    ChainName["Peerpay"] = "Peerpay";
    ChainName["ScolcoinWeiChainTestnet"] = "Scolcoin WeiChain Testnet";
    ChainName["FoxTestnetNetwork"] = "Fox Testnet Network";
    ChainName["PixieChainMainnet"] = "Pixie Chain Mainnet";
    ChainName["LatestChainTestnet"] = "Latest Chain Testnet";
    ChainName["CybriaMainnet"] = "Cybria Mainnet";
    ChainName["CybriaTestnet"] = "Cybria Testnet";
    ChainName["IRIShub"] = "IRIShub";
    ChainName["PAXBMainnet"] = "PAXB Mainnet";
    ChainName["CompverseMainnet"] = "Compverse Mainnet";
    ChainName["GoldSmartChainMainnet"] = "Gold Smart Chain Mainnet";
    ChainName["TombChainMainnet"] = "Tomb Chain Mainnet";
    ChainName["PolySmartChain"] = "PolySmartChain";
    ChainName["ZetaChainMainnet"] = "ZetaChain Mainnet";
    ChainName["ZetaChainAthens3Testnet"] = "ZetaChain Athens 3 Testnet";
    ChainName["BSTChain"] = "BST Chain";
    ChainName["Ellatheheart"] = "Ella the heart";
    ChainName["PlanqMainnet"] = "Planq Mainnet";
    ChainName["Nume"] = "Nume";
    ChainName["HelpTheHomeless"] = "Help The Homeless";
    ChainName["BitrockMainnet"] = "Bitrock Mainnet";
    ChainName["KLYNTAR"] = "KLYNTAR";
    ChainName["HorizenEONMainnet"] = "Horizen EON Mainnet";
    ChainName["ShyftMainnet"] = "Shyft Mainnet";
    ChainName["RabaNetworkMainnet"] = "Raba Network Mainnet";
    ChainName["MEVerseChainMainnet"] = "MEVerse Chain Mainnet";
    ChainName["ADILTestnet"] = "ADIL Testnet";
    ChainName["AdilChainV2Mainnet"] = "Adil Chain V2 Mainnet";
    ChainName["TheRootNetwork-Mainnet"] = "The Root Network - Mainnet";
    ChainName["TheRootNetwork-PorciniTestnet"] = "The Root Network - Porcini Testnet";
    ChainName["Canto"] = "Canto";
    ChainName["CantoTesnet"] = "Canto Tesnet";
    ChainName["BitrockTestnet"] = "Bitrock Testnet";
    ChainName["RiseoftheWarbotsTestnet"] = "Rise of the Warbots Testnet";
    ChainName["MaalChainTestnet"] = "MaalChain Testnet";
    ChainName["HazlorTestnet"] = "Hazlor Testnet";
    ChainName["KintoMainnet"] = "Kinto Mainnet";
    ChainName["ARDENIUMAthena"] = "ARDENIUM Athena";
    ChainName["DOSChain"] = "DOS Chain";
    ChainName["Teleport"] = "Teleport";
    ChainName["TeleportTestnet"] = "Teleport Testnet";
    ChainName["MDGLTestnet"] = "MDGL Testnet";
    ChainName["ShardeumLiberty1.X"] = "Shardeum Liberty 1.X";
    ChainName["ShardeumLiberty2.X"] = "Shardeum Liberty 2.X";
    ChainName["ShardeumSphinx1.X"] = "Shardeum Sphinx 1.X";
    ChainName["BitcoinChain"] = "Bitcoin Chain";
    ChainName["E-Dollar"] = "E-Dollar";
    ChainName["StreamuXBlockchain"] = "StreamuX Blockchain";
    ChainName["QitmeerNetworkTestnet"] = "Qitmeer Network Testnet";
    ChainName["QitmeerNetworkMixnet"] = "Qitmeer Network Mixnet";
    ChainName["QitmeerNetworkPrivnet"] = "Qitmeer Network Privnet";
    ChainName["Amana"] = "Amana";
    ChainName["Flana"] = "Flana";
    ChainName["Mizana"] = "Mizana";
    ChainName["TestnetBeOneChain"] = "Testnet BeOne Chain";
    ChainName["TorusMainnet"] = "Torus Mainnet";
    ChainName["TorusTestnet"] = "Torus Testnet";
    ChainName["KlaytnMainnetCypress"] = "Klaytn Mainnet Cypress";
    ChainName["BlocktonBlockchain"] = "Blockton Blockchain";
    ChainName["KorthoTest"] = "KorthoTest";
    ChainName["DraconesFinancialServices"] = "Dracones Financial Services";
    ChainName["Base"] = "Base";
    ChainName["TokiNetwork"] = "Toki Network";
    ChainName["TokiTestnet"] = "Toki Testnet";
    ChainName["HelaOfficialRuntimeMainnet"] = "Hela Official Runtime Mainnet";
    ChainName["TOOLGlobalMainnet"] = "TOOL Global Mainnet";
    ChainName["TOOLGlobalTestnet"] = "TOOL Global Testnet";
    ChainName["StoragechainMainnet"] = "Storagechain Mainnet";
    ChainName["StoragechainTestnet"] = "Storagechain Testnet";
    ChainName["AlphNetwork"] = "Alph Network";
    ChainName["TMYChain"] = "TMY Chain";
    ChainName["MAROBlockchainMainnet"] = "MARO Blockchain Mainnet";
    ChainName["Unique"] = "Unique";
    ChainName["QuartzbyUnique"] = "Quartz by Unique";
    ChainName["OpaltestnetbyUnique"] = "Opal testnet by Unique";
    ChainName["SapphirebyUnique"] = "Sapphire by Unique";
    ChainName["XANAChain"] = "XANAChain";
    ChainName["VyvoSmartChain"] = "Vyvo Smart Chain";
    ChainName["MammothMainnet"] = "Mammoth Mainnet";
    ChainName["JIBCHAINL1"] = "JIBCHAIN L1";
    ChainName["GiantMammothMainnet"] = "Giant Mammoth Mainnet";
    ChainName["Bloxberg"] = "bloxberg";
    ChainName["EvmosTestnet"] = "Evmos Testnet";
    ChainName["Evmos"] = "Evmos";
    ChainName["BerylBitMainnet"] = "BerylBit Mainnet";
    ChainName["NexaBlock"] = "Nexa Block";
    ChainName["GenesisCoin"] = "Genesis Coin";
    ChainName["RiniaTestnetOld"] = "Rinia Testnet Old";
    ChainName["CodefinMainnet"] = "Codefin Mainnet";
    ChainName["DogcoinTestnet"] = "Dogcoin Testnet";
    ChainName["EvokeMainnet"] = "Evoke Mainnet";
    ChainName["RangersProtocolTestnetRobin"] = "Rangers Protocol Testnet Robin";
    ChainName["QEasyWeb3Testnet"] = "QEasyWeb3 Testnet";
    ChainName["NeonlinkTestnet"] = "Neonlink Testnet";
    ChainName["OortMainnetDev"] = "Oort MainnetDev";
    ChainName["BobaBNBTestnet"] = "Boba BNB Testnet";
    ChainName["MainnetZTestnet"] = "MainnetZ Testnet";
    ChainName["PepeNetworkMainnet"] = "PepeNetwork Mainnet";
    ChainName["CarbonEVM"] = "Carbon EVM";
    ChainName["CarbonEVMTestnet"] = "Carbon EVM Testnet";
    ChainName["IMPERIUMTESTNET"] = "IMPERIUM TESTNET";
    ChainName["IMPERIUMMAINNET"] = "IMPERIUM MAINNET";
    ChainName["DogelayerMainnet"] = "Dogelayer Mainnet";
    ChainName["MindSmartChainTestnet"] = "Mind Smart Chain Testnet";
    ChainName["ComboMainnet"] = "Combo Mainnet";
    ChainName["AgungNetwork"] = "Agung Network";
    ChainName["MindSmartChainMainnet"] = "Mind Smart Chain Mainnet";
    ChainName["AltLayerTestnet"] = "AltLayer Testnet";
    ChainName["MyOwnTestnet"] = "myOwn Testnet";
    ChainName["SmartBitcoinCash"] = "Smart Bitcoin Cash";
    ChainName["SmartBitcoinCashTestnet"] = "Smart Bitcoin Cash Testnet";
    ChainName["GonChain"] = "Gon Chain";
    ChainName["JapanOpenChainTestnet"] = "Japan Open Chain Testnet";
    ChainName["SJATSH"] = "SJATSH";
    ChainName["BlockchainGenesisMainnet"] = "Blockchain Genesis Mainnet";
    ChainName["GnosisChiadoTestnet"] = "Gnosis Chiado Testnet";
    ChainName["MaxxChainMainnet"] = "MaxxChain Mainnet";
    ChainName["ArtheraMainnet"] = "Arthera Mainnet";
    ChainName["ArtheraTestnet"] = "Arthera Testnet";
    ChainName["0XTade"] = "0XTade";
    ChainName["WorldlandTestnet"] = "Worldland Testnet";
    ChainName["NumbersMainnet"] = "Numbers Mainnet";
    ChainName["NumbersTestnet"] = "Numbers Testnet";
    ChainName["CryptoCoinPay"] = "CryptoCoinPay";
    ChainName["QuadransBlockchain"] = "Quadrans Blockchain";
    ChainName["QuadransBlockchainTestnet"] = "Quadrans Blockchain Testnet";
    ChainName["Astra"] = "Astra";
    ChainName["WAGMI"] = "WAGMI";
    ChainName["AstraTestnet"] = "Astra Testnet";
    ChainName["HashBitMainnet"] = "HashBit Mainnet";
    ChainName["HaqqNetwork"] = "Haqq Network";
    ChainName["ShyftTestnet"] = "Shyft Testnet";
    ChainName["SardisTestnet"] = "Sardis Testnet";
    ChainName["SanRChain"] = "SanR Chain";
    ChainName["PolygonSupernetArianee"] = "Polygon Supernet Arianee";
    ChainName["SatoshiChainMainnet"] = "SatoshiChain Mainnet";
    ChainName["SingularityZEROTestnet"] = "Singularity ZERO Testnet";
    ChainName["SingularityZEROMainnet"] = "Singularity ZERO Mainnet";
    ChainName["BRCChainMainnet"] = "BRC Chain Mainnet";
    ChainName["FibonacciMainnet"] = "Fibonacci Mainnet";
    ChainName["BLGTestnet"] = "BLG Testnet";
    ChainName["StepTestnet"] = "Step Testnet";
    ChainName["AstarzkEVM"] = "Astar zkEVM";
    ChainName["RikezaNetworkTestnet"] = "Rikeza Network Testnet";
    ChainName["QuantumChainTestnet"] = "Quantum Chain Testnet";
    ChainName["SPS"] = "SPS";
    ChainName["CreditSmartChain"] = "Credit Smart Chain";
    ChainName["BeamTestnet"] = "Beam Testnet";
    ChainName["ImmutablezkEVM"] = "Immutable zkEVM";
    ChainName["PhoenixMainnet"] = "Phoenix Mainnet";
    ChainName["ImmutablezkEVMTestnet"] = "Immutable zkEVM Testnet";
    ChainName["Susono"] = "Susono";
    ChainName["SPSTestnet"] = "SPS Testnet";
    ChainName["HumanodeTestnet5Israfel"] = "Humanode Testnet 5 Israfel";
    ChainName["ImmutablezkEVMDevnet"] = "Immutable zkEVM Devnet";
    ChainName["LoopNetworkMainnet"] = "LoopNetwork Mainnet";
    ChainName["TrustEVMTestnet"] = "Trust EVM Testnet";
    ChainName["EOSEVMNetworkTestnet"] = "EOS EVM Network Testnet";
    ChainName["MetaDotMainnet"] = "MetaDot Mainnet";
    ChainName["MetaDotTestnet"] = "MetaDot Testnet";
    ChainName["GenesysMainnet"] = "Genesys Mainnet";
    ChainName["IRIShubTestnet"] = "IRIShub Testnet";
    ChainName["AirDAOMainnet"] = "AirDAO Mainnet";
    ChainName["IVARChainTestnet"] = "IVAR Chain Testnet";
    ChainName["Holesky"] = "Holesky";
    ChainName["RedstoneHoleskyTestnet"] = "Redstone Holesky Testnet";
    ChainName["G8ChainMainnet"] = "G8Chain Mainnet";
    ChainName["EclipseSubnet"] = "Eclipse Subnet";
    ChainName["PaletteChainTestnet"] = "Palette Chain Testnet";
    ChainName["EOSEVMNetwork"] = "EOS EVM Network";
    ChainName["FrontierofDreamsTestnet"] = "Frontier of Dreams Testnet";
    ChainName["SmartTradeNetworks"] = "Smart Trade Networks";
    ChainName["ProofOfMemes"] = "Proof Of Memes";
    ChainName["G8ChainTestnet"] = "G8Chain Testnet";
    ChainName["MXCzkEVMMainnet"] = "MXC zkEVM Mainnet";
    ChainName["HOMEVerseMainnet"] = "HOME Verse Mainnet";
    ChainName["MagnetNetwork"] = "Magnet Network";
    ChainName["BTCIXNetwork"] = "BTCIX Network";
    ChainName["CamelarkMainnet"] = "Camelark Mainnet";
    ChainName["CallistoTestnet"] = "Callisto Testnet";
    ChainName["P12Chain"] = "P12 Chain";
    ChainName["Jono11Subnet"] = "Jono11 Subnet";
    ChainName["CENNZnetAzalea"] = "CENNZnet Azalea";
    ChainName["OmChainMainnet"] = "omChain Mainnet";
    ChainName["BSLMainnet"] = "BSL Mainnet";
    ChainName["Taycan"] = "Taycan";
    ChainName["AirDAOTestnet"] = "AirDAO Testnet";
    ChainName["NautilusMainnet"] = "Nautilus Mainnet";
    ChainName["GoldXChainTestnet"] = "GoldXChain Testnet";
    ChainName["MAPMainnet"] = "MAP Mainnet";
    ChainName["AntofyTestnet"] = "Antofy Testnet";
    ChainName["OpsideTestnet"] = "Opside Testnet";
    ChainName["OasisSapphire"] = "Oasis Sapphire";
    ChainName["OasisSapphireTestnet"] = "Oasis Sapphire Testnet";
    ChainName["BlastTestnet"] = "Blast Testnet";
    ChainName["Webchain"] = "Webchain";
    ChainName["MintMe.comCoin"] = "MintMe.com Coin";
    ChainName["LiquidLayerMainnet"] = "LiquidLayer Mainnet";
    ChainName["HammerChainMainnet"] = "Hammer Chain Mainnet";
    ChainName["BitkubChainTestnet"] = "Bitkub Chain Testnet";
    ChainName["FerrumTestnet"] = "Ferrum Testnet";
    ChainName["HertzNetworkMainnet"] = "Hertz Network Mainnet";
    ChainName["OasisChainMainnet"] = "OasisChain Mainnet";
    ChainName["OptimismBedrock(GoerliAlphaTestnet)"] = "Optimism Bedrock (Goerli Alpha Testnet)";
    ChainName["MCHVerseMainnet"] = "MCH Verse Mainnet";
    ChainName["Piecetestnet"] = "Piece testnet";
    ChainName["CeriumTestnet"] = "Cerium Testnet";
    ChainName["EthersocialNetwork"] = "Ethersocial Network";
    ChainName["CloudTxMainnet"] = "CloudTx Mainnet";
    ChainName["CloudTxTestnet"] = "CloudTx Testnet";
    ChainName["GoChainTestnet"] = "GoChain Testnet";
    ChainName["EvokeTestnet"] = "Evoke Testnet";
    ChainName["Filecoin-Wallabytestnet"] = "Filecoin - Wallaby testnet";
    ChainName["W3GamezHoleskyTestnet"] = "W3Gamez Holesky Testnet";
    ChainName["BitgertMainnet"] = "Bitgert Mainnet";
    ChainName["FusionMainnet"] = "Fusion Mainnet";
    ChainName["ZilliqaEVM"] = "Zilliqa EVM";
    ChainName["ZilliqaEVMIsolatedServer"] = "Zilliqa EVM Isolated Server";
    ChainName["ZilliqaEVMTestnet"] = "Zilliqa EVM Testnet";
    ChainName["CloudverseSubnet"] = "Cloudverse Subnet";
    ChainName["AvesMainnet"] = "Aves Mainnet";
    ChainName["ZilliqaEVMDevnet"] = "Zilliqa EVM Devnet";
    ChainName["Zilliqa2EVMDevnet"] = "Zilliqa 2 EVM Devnet";
    ChainName["Mode"] = "Mode";
    ChainName["J2OTaro"] = "J2O Taro";
    ChainName["QMainnet"] = "Q Mainnet";
    ChainName["QTestnet"] = "Q Testnet";
    ChainName["ConnectorManager"] = "ConnectorManager";
    ChainName["ConnectorManagerRobin"] = "ConnectorManager Robin";
    ChainName["EnergiMainnet"] = "Energi Mainnet";
    ChainName["OHOMainnet"] = "OHO Mainnet";
    ChainName["Opulent-XBETA"] = "Opulent-X BETA";
    ChainName["Pegglecoin"] = "pegglecoin";
    ChainName["ArbitrumOne"] = "Arbitrum One";
    ChainName["ArbitrumNova"] = "Arbitrum Nova";
    ChainName["CeloMainnet"] = "Celo Mainnet";
    ChainName["OasisEmeraldTestnet"] = "Oasis Emerald Testnet";
    ChainName["OasisEmerald"] = "Oasis Emerald";
    ChainName["GoldXChainMainnet"] = "GoldXChain Mainnet";
    ChainName["ZKFairMainnet"] = "ZKFair Mainnet";
    ChainName["GesotenVerseTestnet"] = "Gesoten Verse Testnet";
    ChainName["KintoTestnet"] = "Kinto Testnet";
    ChainName["Athereum"] = "Athereum";
    ChainName["AvalancheFujiTestnet"] = "Avalanche Fuji Testnet";
    ChainName["AvalancheC-Chain"] = "Avalanche C-Chain";
    ChainName["BobaAvax"] = "Boba Avax";
    ChainName["ZKFairTestnet"] = "ZKFair Testnet";
    ChainName["Frenchain"] = "Frenchain";
    ChainName["CeloAlfajoresTestnet"] = "Celo Alfajores Testnet";
    ChainName["AutobahnNetwork"] = "Autobahn Network";
    ChainName["DeelanceMainnet"] = "Deelance Mainnet";
    ChainName["FusionTestnet"] = "Fusion Testnet";
    ChainName["REINetwork"] = "REI Network";
    ChainName["WireshapeFloripaTestnet"] = "Wireshape Floripa Testnet";
    ChainName["BifrostTestnet"] = "Bifrost Testnet";
    ChainName["EnergiTestnet"] = "Energi Testnet";
    ChainName["LiveplexOracleEVM"] = "Liveplex OracleEVM";
    ChainName["YooldoVerseMainnet"] = "Yooldo Verse Mainnet";
    ChainName["YooldoVerseTestnet"] = "Yooldo Verse Testnet";
    ChainName["GTONTestnet"] = "GTON Testnet";
    ChainName["LumozTestnetAlpha"] = "Lumoz Testnet Alpha";
    ChainName["SardisMainnet"] = "Sardis Mainnet";
    ChainName["ElectroneumMainnet"] = "Electroneum Mainnet";
    ChainName["DFKChain"] = "DFK Chain";
    ChainName["HaqqChainTestnet"] = "Haqq Chain Testnet";
    ChainName["ToronetTestnet"] = "Toronet Testnet";
    ChainName["Titan"] = "Titan";
    ChainName["REIChainMainnet"] = "REI Chain Mainnet";
    ChainName["REIChainTestnet"] = "REI Chain Testnet";
    ChainName["BobaBNBMainnet"] = "Boba BNB Mainnet";
    ChainName["VELOLabsMainnet"] = "VELO Labs Mainnet";
    ChainName["RolluxTestnet"] = "Rollux Testnet";
    ChainName["SepoliaPGN(PublicGoodsNetwork)"] = "Sepolia PGN (Public Goods Network)";
    ChainName["LineaTestnet"] = "Linea Testnet";
    ChainName["Linea"] = "Linea";
    ChainName["GenesysCodeMainnet"] = "Genesys Code Mainnet";
    ChainName["ThinkiumTestnetChain0"] = "Thinkium Testnet Chain 0";
    ChainName["ThinkiumTestnetChain1"] = "Thinkium Testnet Chain 1";
    ChainName["ThinkiumTestnetChain2"] = "Thinkium Testnet Chain 2";
    ChainName["ThinkiumTestnetChain103"] = "Thinkium Testnet Chain 103";
    ChainName["AxelChainDev-Net"] = "AxelChain Dev-Net";
    ChainName["EticaMainnet"] = "Etica Mainnet";
    ChainName["DoKENSuperChainMainnet"] = "DoKEN Super Chain Mainnet";
    ChainName["CeloBaklavaTestnet"] = "Celo Baklava Testnet";
    ChainName["MultiVACMainnet"] = "MultiVAC Mainnet";
    ChainName["ECreditsMainnet"] = "eCredits Mainnet";
    ChainName["ECreditsTestnet"] = "eCredits Testnet";
    ChainName["ScolcoinMainnet"] = "Scolcoin Mainnet";
    ChainName["JanusTestnet"] = "Janus Testnet";
    ChainName["SiriusNet"] = "SiriusNet";
    ChainName["CosmicChain"] = "Cosmic Chain";
    ChainName["DM2VerseMainnet"] = "DM2 Verse Mainnet";
    ChainName["Condrieu"] = "Condrieu";
    ChainName["ThinkiumMainnetChain0"] = "Thinkium Mainnet Chain 0";
    ChainName["ThinkiumMainnetChain1"] = "Thinkium Mainnet Chain 1";
    ChainName["ThinkiumMainnetChain2"] = "Thinkium Mainnet Chain 2";
    ChainName["ThinkiumMainnetChain103"] = "Thinkium Mainnet Chain 103";
    ChainName["GuapcoinX"] = "GuapcoinX";
    ChainName["PolyjuiceTestnet"] = "Polyjuice Testnet";
    ChainName["GodwokenTestnetv1"] = "Godwoken Testnet v1";
    ChainName["GodwokenMainnet"] = "Godwoken Mainnet";
    ChainName["GrokChainMainnet"] = "Grok Chain Mainnet";
    ChainName["EnergyWebVoltaTestnet"] = "Energy Web Volta Testnet";
    ChainName["MixinVirtualMachine"] = "Mixin Virtual Machine";
    ChainName["ResinCoinMainnet"] = "ResinCoin Mainnet";
    ChainName["FoundryChainTestnet"] = "Foundry Chain Testnet";
    ChainName["VentionSmartChainMainnet"] = "Vention Smart Chain Mainnet";
    ChainName["ToronetMainnet"] = "Toronet Mainnet";
    ChainName["Firenzetestnetwork"] = "Firenze test network";
    ChainName["DragonflyMainnet(Hexapod)"] = "Dragonfly Mainnet (Hexapod)";
    ChainName["AmplifySubnet"] = "Amplify Subnet";
    ChainName["BulletinSubnet"] = "Bulletin Subnet";
    ChainName["ConduitSubnet"] = "Conduit Subnet";
    ChainName["GoldSmartChainTestnet"] = "Gold Smart Chain Testnet";
    ChainName["Mumbai"] = "Mumbai";
    ChainName["BerachainArtio"] = "Berachain Artio";
    ChainName["NordekMainnet"] = "Nordek Mainnet";
    ChainName["AmanaTestnet"] = "Amana Testnet";
    ChainName["AmanaMixnet"] = "Amana Mixnet";
    ChainName["AmanaPrivnet"] = "Amana Privnet";
    ChainName["FlanaTestnet"] = "Flana Testnet";
    ChainName["FlanaMixnet"] = "Flana Mixnet";
    ChainName["FlanaPrivnet"] = "Flana Privnet";
    ChainName["MizanaTestnet"] = "Mizana Testnet";
    ChainName["MizanaMixnet"] = "Mizana Mixnet";
    ChainName["MizanaPrivnet"] = "Mizana Privnet";
    ChainName["QuantumChainMainnet"] = "Quantum Chain Mainnet";
    ChainName["SmartLayerNetworkTestnet"] = "Smart Layer Network Testnet";
    ChainName["BaseGoerliTestnet"] = "Base Goerli Testnet";
    ChainName["BaseSepoliaTestnet"] = "Base Sepolia Testnet";
    ChainName["AerieNetwork"] = "Aerie Network";
    ChainName["CYBERTRUST"] = "CYBERTRUST";
    ChainName["NautilusProteusTestnet"] = "Nautilus Proteus Testnet";
    ChainName["ChilizScovilleTestnet"] = "Chiliz Scoville Testnet";
    ChainName["IVARChainMainnet"] = "IVAR Chain Mainnet";
    ChainName["BeverlyHills"] = "Beverly Hills";
    ChainName["NautilusTritionChain"] = "Nautilus Trition Chain";
    ChainName["ComboTestnet"] = "Combo Testnet";
    ChainName["LambdaTestnet"] = "Lambda Testnet";
    ChainName["LiquidLayerTestnet"] = "LiquidLayer Testnet";
    ChainName["MantisTestnet(Hexapod)"] = "Mantis Testnet (Hexapod)";
    ChainName["BobaBNBMainnetOld"] = "Boba BNB Mainnet Old";
    ChainName["ELibertyTestnet"] = "eLiberty Testnet";
    ChainName["UBSmartChain(testnet)"] = "UB Smart Chain(testnet)";
    ChainName["UBSmartChain"] = "UB Smart Chain";
    ChainName["QuarkChainMainnetRoot"] = "QuarkChain Mainnet Root";
    ChainName["QuarkChainMainnetShard0"] = "QuarkChain Mainnet Shard 0";
    ChainName["QuarkChainMainnetShard1"] = "QuarkChain Mainnet Shard 1";
    ChainName["QuarkChainMainnetShard2"] = "QuarkChain Mainnet Shard 2";
    ChainName["QuarkChainMainnetShard3"] = "QuarkChain Mainnet Shard 3";
    ChainName["QuarkChainMainnetShard4"] = "QuarkChain Mainnet Shard 4";
    ChainName["QuarkChainMainnetShard5"] = "QuarkChain Mainnet Shard 5";
    ChainName["QuarkChainMainnetShard6"] = "QuarkChain Mainnet Shard 6";
    ChainName["QuarkChainMainnetShard7"] = "QuarkChain Mainnet Shard 7";
    ChainName["VeChain"] = "VeChain";
    ChainName["VeChainTestnet"] = "VeChain Testnet";
    ChainName["DeprecatedCHI"] = "Deprecated CHI";
    ChainName["SoverunTestnet"] = "Soverun Testnet";
    ChainName["Crystaleum"] = "Crystaleum";
    ChainName["BROChainMainnet"] = "BROChain Mainnet";
    ChainName["QuarkChainDevnetRoot"] = "QuarkChain Devnet Root";
    ChainName["QuarkChainDevnetShard0"] = "QuarkChain Devnet Shard 0";
    ChainName["QuarkChainDevnetShard1"] = "QuarkChain Devnet Shard 1";
    ChainName["QuarkChainDevnetShard2"] = "QuarkChain Devnet Shard 2";
    ChainName["QuarkChainDevnetShard3"] = "QuarkChain Devnet Shard 3";
    ChainName["QuarkChainDevnetShard4"] = "QuarkChain Devnet Shard 4";
    ChainName["QuarkChainDevnetShard5"] = "QuarkChain Devnet Shard 5";
    ChainName["QuarkChainDevnetShard6"] = "QuarkChain Devnet Shard 6";
    ChainName["QuarkChainDevnetShard7"] = "QuarkChain Devnet Shard 7";
    ChainName["SiberiumTestNetwork"] = "Siberium Test Network";
    ChainName["SiberiumNetwork"] = "Siberium Network";
    ChainName["MetachainOneMainnet"] = "Metachain One Mainnet";
    ChainName["ADILDevnet"] = "ADIL Devnet";
    ChainName["EtherlinkTestnet"] = "Etherlink Testnet";
    ChainName["ETNDChainMainnets"] = "ETND Chain Mainnets";
    ChainName["ICPlazaMainnet"] = "ICPlaza Mainnet";
    ChainName["Taiko(Alpha-2Testnet)"] = "Taiko (Alpha-2 Testnet)";
    ChainName["TaikoGrimsvotnL2"] = "Taiko Grimsvotn L2";
    ChainName["TaikoEldfellL3"] = "Taiko Eldfell L3";
    ChainName["TaikoJolnirL2"] = "Taiko Jolnir L2";
    ChainName["TaikoKatlaL2"] = "Taiko Katla L2";
    ChainName["BiticaChainMainnet"] = "Bitica Chain Mainnet";
    ChainName["CondorTestNetwork"] = "Condor Test Network";
    ChainName["MilkomedaC1Testnet"] = "Milkomeda C1 Testnet";
    ChainName["MilkomedaA1Testnet"] = "Milkomeda A1 Testnet";
    ChainName["Akroma"] = "Akroma";
    ChainName["AlayaMainnet"] = "Alaya Mainnet";
    ChainName["AlayaDevTestnet"] = "Alaya Dev Testnet";
    ChainName["MythicalChain"] = "Mythical Chain";
    ChainName["DecimalSmartChainTestnet"] = "Decimal Smart Chain Testnet";
    ChainName["X1Devnet"] = "X1 Devnet";
    ChainName["Jellie"] = "Jellie";
    ChainName["X1Network"] = "X1 Network";
    ChainName["PlatONMainnet"] = "PlatON Mainnet";
    ChainName["MasMainnet"] = "Mas Mainnet";
    ChainName["ReapchainMainnet"] = "Reapchain Mainnet";
    ChainName["ReapchainTestnet"] = "Reapchain Testnet";
    ChainName["TafECOChainMainnet"] = "Taf ECO Chain Mainnet";
    ChainName["CONETSeboliaTestnet"] = "CONET Sebolia Testnet";
    ChainName["CONETHolesky"] = "CONET Holesky";
    ChainName["HashKeyChainTestnet"] = "HashKey Chain Testnet";
    ChainName["HaymoTestnet"] = "Haymo Testnet";
    ChainName["ARTISsigma1"] = "ARTIS sigma1";
    ChainName["ARTISTestnettau1"] = "ARTIS Testnet tau1";
    ChainName["SaakuruTestnet"] = "Saakuru Testnet";
    ChainName["CMP-Mainnet"] = "CMP-Mainnet";
    ChainName["GearZeroNetworkTestnet"] = "Gear Zero Network Testnet";
    ChainName["EgonCoinTestnet"] = "EgonCoin Testnet";
    ChainName["SocialSmartChainMainnet"] = "Social Smart Chain Mainnet";
    ChainName["Filecoin-Calibrationtestnet"] = "Filecoin - Calibration testnet";
    ChainName["TTcoinSmartChainMainnet"] = "TTcoin Smart Chain Mainnet";
    ChainName["AvesTestnet"] = "Aves Testnet";
    ChainName["Nativ3Testnet"] = "Nativ3 Testnet";
    ChainName["OoneChainTestnet"] = "Oone Chain Testnet";
    ChainName["OoneChainDevnet"] = "Oone Chain Devnet";
    ChainName["PolisTestnet"] = "Polis Testnet";
    ChainName["PolisMainnet"] = "Polis Mainnet";
    ChainName["BitfinityNetworkTestnet"] = "Bitfinity Network Testnet";
    ChainName["DigitSoulSmartChain2"] = "Digit Soul Smart Chain 2";
    ChainName["HAPchainTestnet"] = "HAPchain Testnet";
    ChainName["MetalC-Chain"] = "Metal C-Chain";
    ChainName["MetalTahoeC-Chain"] = "Metal Tahoe C-Chain";
    ChainName["TipboxcoinMainnet"] = "Tipboxcoin Mainnet";
    ChainName["Kekchain"] = "Kekchain";
    ChainName["Kekchain(kektest)"] = "Kekchain (kektest)";
    ChainName["AlteriumL2Testnet"] = "Alterium L2 Testnet";
    ChainName["ArbitrumRinkeby"] = "Arbitrum Rinkeby";
    ChainName["ArbitrumGoerli"] = "Arbitrum Goerli";
    ChainName["ArbitrumSepolia"] = "Arbitrum Sepolia";
    ChainName["FastexChaintestnet"] = "Fastex Chain testnet";
    ChainName["MarkrGo"] = "Markr Go";
    ChainName["DexalotSubnetTestnet"] = "Dexalot Subnet Testnet";
    ChainName["DexalotSubnet"] = "Dexalot Subnet";
    ChainName["WeelinkTestnet"] = "Weelink Testnet";
    ChainName["PatexSepoliaTestnet"] = "Patex Sepolia Testnet";
    ChainName["UltraProMainnet"] = "Ultra Pro Mainnet";
    ChainName["OpenChainMainnet"] = "OpenChain Mainnet";
    ChainName["CMP-Testnet"] = "CMP-Testnet";
    ChainName["EthereumFair"] = "ethereum Fair";
    ChainName["ScrollSepoliaTestnet"] = "Scroll Sepolia Testnet";
    ChainName["Scroll"] = "Scroll";
    ChainName["ScrollAlphaTestnet"] = "Scroll Alpha Testnet";
    ChainName["ScrollPre-AlphaTestnet"] = "Scroll Pre-Alpha Testnet";
    ChainName["ShinariumBeta"] = "Shinarium Beta";
    ChainName["BeanEcoSmartChain"] = "BeanEco SmartChain";
    ChainName["HypraMainnet"] = "Hypra Mainnet";
    ChainName["BearNetworkChainMainnet"] = "Bear Network Chain Mainnet";
    ChainName["ALLMainnet"] = "ALL Mainnet";
    ChainName["Vision-VpioneerTestChain"] = "Vision - Vpioneer Test Chain";
    ChainName["HelaOfficialRuntimeTestnet"] = "Hela Official Runtime Testnet";
    ChainName["BearNetworkChainTestnet"] = "Bear Network Chain Testnet";
    ChainName["MiexsSmartchain"] = "Miexs Smartchain";
    ChainName["Modularium"] = "Modularium";
    ChainName["OctaSpace"] = "OctaSpace";
    ChainName["CURVEMainnet"] = "CURVE Mainnet";
    ChainName["4GoodNetwork"] = "4GoodNetwork";
    ChainName["Dodao"] = "Dodao";
    ChainName["BlocXMainnet"] = "BlocX Mainnet";
    ChainName["Vision-Mainnet"] = "Vision - Mainnet";
    ChainName["PosichainMainnetShard0"] = "Posichain Mainnet Shard 0";
    ChainName["PosichainTestnetShard0"] = "Posichain Testnet Shard 0";
    ChainName["AstriaEVMDusknet"] = "Astria EVM Dusknet";
    ChainName["PosichainDevnetShard0"] = "Posichain Devnet Shard 0";
    ChainName["PosichainDevnetShard1"] = "Posichain Devnet Shard 1";
    ChainName["FNCYTestnet"] = "FNCY Testnet";
    ChainName["Jono12Subnet"] = "Jono12 Subnet";
    ChainName["EluvioContentFabric"] = "Eluvio Content Fabric";
    ChainName["EcroxChainMainnet"] = "Ecrox Chain Mainnet";
    ChainName["TiltyardSubnet"] = "Tiltyard Subnet";
    ChainName["ZKatana"] = "zKatana";
    ChainName["EthoProtocol"] = "Etho Protocol";
    ChainName["Xerom"] = "Xerom";
    ChainName["Kintsugi"] = "Kintsugi";
    ChainName["Kiln"] = "Kiln";
    ChainName["Zhejiang"] = "Zhejiang";
    ChainName["TurkeyDemoDev"] = "Turkey Demo Dev";
    ChainName["DeBankTestnet"] = "DeBank Testnet";
    ChainName["PlianMainnetMain"] = "Plian Mainnet Main";
    ChainName["PlatONDevTestnetDeprecated"] = "PlatON Dev Testnet Deprecated";
    ChainName["PlatONDevTestnet2"] = "PlatON Dev Testnet2";
    ChainName["DPUChain"] = "DPU Chain";
    ChainName["Filecoin-Butterflytestnet"] = "Filecoin - Butterfly testnet";
    ChainName["MantaPacificTestnet"] = "Manta Pacific Testnet";
    ChainName["AltLayerZeroGasNetwork"] = "AltLayer Zero Gas Network";
    ChainName["WorldsCaldera"] = "Worlds Caldera";
    ChainName["MXCWannseezkEVMTestnet"] = "MXC Wannsee zkEVM Testnet";
    ChainName["ElectroneumTestnet"] = "Electroneum Testnet";
    ChainName["ImversedMainnet"] = "Imversed Mainnet";
    ChainName["ImversedTestnet"] = "Imversed Testnet";
    ChainName["SaakuruMainnet"] = "Saakuru Mainnet";
    ChainName["OpenVessel"] = "OpenVessel";
    ChainName["QL1Testnet"] = "QL1 Testnet";
    ChainName["Musicoin"] = "Musicoin";
    ChainName["Zora"] = "Zora";
    ChainName["PlianMainnetSubchain1"] = "Plian Mainnet Subchain 1";
    ChainName["Hokum"] = "Hokum";
    ChainName["HAPchain"] = "HAPchain";
    ChainName["QuarixTestnet"] = "Quarix Testnet";
    ChainName["Quarix"] = "Quarix";
    ChainName["XCAP"] = "XCAP";
    ChainName["Milvine"] = "Milvine";
    ChainName["PlianTestnetSubchain1"] = "Plian Testnet Subchain 1";
    ChainName["SoverunMainnet"] = "Soverun Mainnet";
    ChainName["Sepolia"] = "Sepolia";
    ChainName["OPSepoliaTestnet"] = "OP Sepolia Testnet";
    ChainName["PepChainChurchill"] = "PepChain Churchill";
    ChainName["AnduschainMainnet"] = "Anduschain Mainnet";
    ChainName["PlianTestnetMain"] = "Plian Testnet Main";
    ChainName["IOLite"] = "IOLite";
    ChainName["SmartMeshMainnet"] = "SmartMesh Mainnet";
    ChainName["Quarkblockchain"] = "quarkblockchain";
    ChainName["PegoNetwork"] = "Pego Network";
    ChainName["HokumTestnet"] = "Hokum Testnet";
    ChainName["ExcelonMainnet"] = "Excelon Mainnet";
    ChainName["ExcoincialChainVolta-Testnet"] = "Excoincial Chain Volta-Testnet";
    ChainName["ExcoincialChainMainnet"] = "Excoincial Chain Mainnet";
    ChainName["Ancient8Testnet"] = "Ancient8 Testnet";
    ChainName["AuxiliumNetworkMainnet"] = "Auxilium Network Mainnet";
    ChainName["FlachainMainnet"] = "Flachain Mainnet";
    ChainName["Filecoin-Localtestnet"] = "Filecoin - Local testnet";
    ChainName["JoysDigitalMainnet"] = "Joys Digital Mainnet";
    ChainName["Maistestsubnet"] = "maistestsubnet";
    ChainName["Aquachain"] = "Aquachain";
    ChainName["AutonityBakerloo(Thames)Testnet"] = "Autonity Bakerloo (Thames) Testnet";
    ChainName["AutonityBakerloo(Barada)Testnet"] = "Autonity Bakerloo (Barada) Testnet";
    ChainName["AutonityPiccadilly(Thames)Testnet"] = "Autonity Piccadilly (Thames) Testnet";
    ChainName["AutonityPiccadilly(Barada)Testnet"] = "Autonity Piccadilly (Barada) Testnet";
    ChainName["FrameTestnet"] = "Frame Testnet";
    ChainName["T.E.A.MBlockchain"] = "T.E.A.M Blockchain";
    ChainName["JoysDigitalTestNet"] = "Joys Digital TestNet";
    ChainName["BlastSepoliaTestnet"] = "Blast Sepolia Testnet";
    ChainName["GatherMainnetNetwork"] = "Gather Mainnet Network";
    ChainName["Kanazawa"] = "Kanazawa";
    ChainName["NeonEVMDevnet"] = "Neon EVM Devnet";
    ChainName["NeonEVMMainnet"] = "Neon EVM Mainnet";
    ChainName["NeonEVMTestNet"] = "Neon EVM TestNet";
    ChainName["RazorSkaleChain"] = "Razor Skale Chain";
    ChainName["OneLedgerMainnet"] = "OneLedger Mainnet";
    ChainName["Meld"] = "Meld";
    ChainName["SKALECalypsoHubTestnet"] = "SKALE Calypso Hub Testnet";
    ChainName["GatherTestnetNetwork"] = "Gather Testnet Network";
    ChainName["SKALEEuropaHubTestnet"] = "SKALE Europa Hub Testnet";
    ChainName["GatherDevnetNetwork"] = "Gather Devnet Network";
    ChainName["SKALENebulaHubTestnet"] = "SKALE Nebula Hub Testnet";
    ChainName["ZoraSepoliaTestnet"] = "Zora Sepolia Testnet";
    ChainName["IPOSNetwork"] = "IPOS Network";
    ChainName["CyberdeckNet"] = "CyberdeckNet";
    ChainName["HUMANProtocol"] = "HUMAN Protocol";
    ChainName["AuroraMainnet"] = "Aurora Mainnet";
    ChainName["AuroraTestnet"] = "Aurora Testnet";
    ChainName["AuroraBetanet"] = "Aurora Betanet";
    ChainName["SKALETitanHub"] = "SKALE Titan Hub";
    ChainName["Chaos(SKALETestnet)"] = "Chaos (SKALE Testnet)";
    ChainName["RaptorChain"] = "RaptorChain";
    ChainName["SKALENebulaHub"] = "SKALE Nebula Hub";
    ChainName["SKALETitanHubTestnet"] = "SKALE Titan Hub Testnet";
    ChainName["SKALECalypsoHub"] = "SKALE Calypso Hub";
    ChainName["HarmonyMainnetShard0"] = "Harmony Mainnet Shard 0";
    ChainName["HarmonyMainnetShard1"] = "Harmony Mainnet Shard 1";
    ChainName["HarmonyMainnetShard2"] = "Harmony Mainnet Shard 2";
    ChainName["HarmonyMainnetShard3"] = "Harmony Mainnet Shard 3";
    ChainName["HarmonyTestnetShard0"] = "Harmony Testnet Shard 0";
    ChainName["HarmonyTestnetShard1"] = "Harmony Testnet Shard 1";
    ChainName["HarmonyDevnetShard0"] = "Harmony Devnet Shard 0";
    ChainName["HarmonyDevnetShard1"] = "Harmony Devnet Shard 1";
    ChainName["DataHopper"] = "DataHopper";
    ChainName["SKALEEuropaHub"] = "SKALE Europa Hub";
    ChainName["Ancient8Testnet(deprecated)"] = "Ancient8 Testnet (deprecated)";
    ChainName["Pirl"] = "Pirl";
    ChainName["OneLedgerTestnetFrankenstein"] = "OneLedger Testnet Frankenstein";
    ChainName["PalmTestnet"] = "Palm Testnet";
    ChainName["Palm"] = "Palm";
    ChainName["AlphabetMainnet"] = "Alphabet Mainnet";
    ChainName["NtityMainnet"] = "Ntity Mainnet";
    ChainName["HaradevTestnet"] = "Haradev Testnet";
    ChainName["Zeniq"] = "Zeniq";
    ChainName["PDCMainnet"] = "PDC Mainnet";
    ChainName["MolereumNetwork"] = "Molereum Network";
    ChainName["GodwokenTestnet(V1)"] = "Godwoken Testnet (V1)";
})(ChainName = exports.ChainName || (exports.ChainName = {}));
var ChainId;
(function (ChainId) {
    ChainId[ChainId["EthereumMainnet"] = 1] = "EthereumMainnet";
    ChainId[ChainId["ExpanseNetwork"] = 2] = "ExpanseNetwork";
    ChainId[ChainId["Ropsten"] = 3] = "Ropsten";
    ChainId[ChainId["Rinkeby"] = 4] = "Rinkeby";
    ChainId[ChainId["Goerli"] = 5] = "Goerli";
    ChainId[ChainId["KottiTestnet"] = 6] = "KottiTestnet";
    ChainId[ChainId["ThaiChain"] = 7] = "ThaiChain";
    ChainId[ChainId["Ubiq"] = 8] = "Ubiq";
    ChainId[ChainId["UbiqNetworkTestnet"] = 9] = "UbiqNetworkTestnet";
    ChainId[ChainId["OPMainnet"] = 10] = "OPMainnet";
    ChainId[ChainId["MetadiumMainnet"] = 11] = "MetadiumMainnet";
    ChainId[ChainId["MetadiumTestnet"] = 12] = "MetadiumTestnet";
    ChainId[ChainId["DiodeTestnetStaging"] = 13] = "DiodeTestnetStaging";
    ChainId[ChainId["FlareMainnet"] = 14] = "FlareMainnet";
    ChainId[ChainId["DiodePrenet"] = 15] = "DiodePrenet";
    ChainId[ChainId["FlareTestnetCoston"] = 16] = "FlareTestnetCoston";
    ChainId[ChainId["ThaiChain2.0ThaiFi"] = 17] = "ThaiChain2.0ThaiFi";
    ChainId[ChainId["ThunderCoreTestnet"] = 18] = "ThunderCoreTestnet";
    ChainId[ChainId["SongbirdCanary-Network"] = 19] = "SongbirdCanary-Network";
    ChainId[ChainId["ElastosSmartChain"] = 20] = "ElastosSmartChain";
    ChainId[ChainId["ElastosSmartChainTestnet"] = 21] = "ElastosSmartChainTestnet";
    ChainId[ChainId["ELA-DID-SidechainMainnet"] = 22] = "ELA-DID-SidechainMainnet";
    ChainId[ChainId["ELA-DID-SidechainTestnet"] = 23] = "ELA-DID-SidechainTestnet";
    ChainId[ChainId["KardiaChainMainnet"] = 24] = "KardiaChainMainnet";
    ChainId[ChainId["CronosMainnet"] = 25] = "CronosMainnet";
    ChainId[ChainId["GenesisL1testnet"] = 26] = "GenesisL1testnet";
    ChainId[ChainId["ShibaChain"] = 27] = "ShibaChain";
    ChainId[ChainId["BobaNetworkRinkebyTestnet"] = 28] = "BobaNetworkRinkebyTestnet";
    ChainId[ChainId["GenesisL1"] = 29] = "GenesisL1";
    ChainId[ChainId["RootstockMainnet"] = 30] = "RootstockMainnet";
    ChainId[ChainId["RootstockTestnet"] = 31] = "RootstockTestnet";
    ChainId[ChainId["GoodDataTestnet"] = 32] = "GoodDataTestnet";
    ChainId[ChainId["GoodDataMainnet"] = 33] = "GoodDataMainnet";
    ChainId[ChainId["SecureChainMainnet"] = 34] = "SecureChainMainnet";
    ChainId[ChainId["TBWGChain"] = 35] = "TBWGChain";
    ChainId[ChainId["DxchainMainnet"] = 36] = "DxchainMainnet";
    ChainId[ChainId["XplaMainnet"] = 37] = "XplaMainnet";
    ChainId[ChainId["Valorbit"] = 38] = "Valorbit";
    ChainId[ChainId["U2USolarisMainnet"] = 39] = "U2USolarisMainnet";
    ChainId[ChainId["TelosEVMMainnet"] = 40] = "TelosEVMMainnet";
    ChainId[ChainId["TelosEVMTestnet"] = 41] = "TelosEVMTestnet";
    ChainId[ChainId["LUKSOMainnet"] = 42] = "LUKSOMainnet";
    ChainId[ChainId["DarwiniaPangolinTestnet"] = 43] = "DarwiniaPangolinTestnet";
    ChainId[ChainId["CrabNetwork"] = 44] = "CrabNetwork";
    ChainId[ChainId["DarwiniaPangoroTestnet"] = 45] = "DarwiniaPangoroTestnet";
    ChainId[ChainId["DarwiniaNetwork"] = 46] = "DarwiniaNetwork";
    ChainId[ChainId["AcriaIntelliChain"] = 47] = "AcriaIntelliChain";
    ChainId[ChainId["EnnothemMainnetProterozoic"] = 48] = "EnnothemMainnetProterozoic";
    ChainId[ChainId["EnnothemTestnetPioneer"] = 49] = "EnnothemTestnetPioneer";
    ChainId[ChainId["XDCNetwork"] = 50] = "XDCNetwork";
    ChainId[ChainId["XDCApothemNetwork"] = 51] = "XDCApothemNetwork";
    ChainId[ChainId["CoinExSmartChainMainnet"] = 52] = "CoinExSmartChainMainnet";
    ChainId[ChainId["CoinExSmartChainTestnet"] = 53] = "CoinExSmartChainTestnet";
    ChainId[ChainId["OpenpieceMainnet"] = 54] = "OpenpieceMainnet";
    ChainId[ChainId["ZyxMainnet"] = 55] = "ZyxMainnet";
    ChainId[ChainId["BNBSmartChainMainnet"] = 56] = "BNBSmartChainMainnet";
    ChainId[ChainId["SyscoinMainnet"] = 57] = "SyscoinMainnet";
    ChainId[ChainId["OntologyMainnet"] = 58] = "OntologyMainnet";
    ChainId[ChainId["EOSEVMLegacy"] = 59] = "EOSEVMLegacy";
    ChainId[ChainId["GoChain"] = 60] = "GoChain";
    ChainId[ChainId["EthereumClassic"] = 61] = "EthereumClassic";
    ChainId[ChainId["MordenTestnet"] = 62] = "MordenTestnet";
    ChainId[ChainId["MordorTestnet"] = 63] = "MordorTestnet";
    ChainId[ChainId["Ellaism"] = 64] = "Ellaism";
    ChainId[ChainId["OKExChainTestnet"] = 65] = "OKExChainTestnet";
    ChainId[ChainId["OKXChainMainnet"] = 66] = "OKXChainMainnet";
    ChainId[ChainId["DBChainTestnet"] = 67] = "DBChainTestnet";
    ChainId[ChainId["SoterOneMainnet"] = 68] = "SoterOneMainnet";
    ChainId[ChainId["OptimismKovan"] = 69] = "OptimismKovan";
    ChainId[ChainId["HooSmartChain"] = 70] = "HooSmartChain";
    ChainId[ChainId["ConfluxeSpace(Testnet)"] = 71] = "ConfluxeSpace(Testnet)";
    ChainId[ChainId["DxChainTestnet"] = 72] = "DxChainTestnet";
    ChainId[ChainId["FNCY"] = 73] = "FNCY";
    ChainId[ChainId["IDChainMainnet"] = 74] = "IDChainMainnet";
    ChainId[ChainId["DecimalSmartChainMainnet"] = 75] = "DecimalSmartChainMainnet";
    ChainId[ChainId["Mix"] = 76] = "Mix";
    ChainId[ChainId["POANetworkSokol"] = 77] = "POANetworkSokol";
    ChainId[ChainId["PrimusChainmainnet"] = 78] = "PrimusChainmainnet";
    ChainId[ChainId["ZenithMainnet"] = 79] = "ZenithMainnet";
    ChainId[ChainId["GeneChain"] = 80] = "GeneChain";
    ChainId[ChainId["JapanOpenChainMainnet"] = 81] = "JapanOpenChainMainnet";
    ChainId[ChainId["MeterMainnet"] = 82] = "MeterMainnet";
    ChainId[ChainId["MeterTestnet"] = 83] = "MeterTestnet";
    ChainId[ChainId["LinqtoDevnet"] = 84] = "LinqtoDevnet";
    ChainId[ChainId["GateChainTestnet"] = 85] = "GateChainTestnet";
    ChainId[ChainId["GateChainMainnet"] = 86] = "GateChainMainnet";
    ChainId[ChainId["NovaNetwork"] = 87] = "NovaNetwork";
    ChainId[ChainId["TomoChain"] = 88] = "TomoChain";
    ChainId[ChainId["TomoChainTestnet"] = 89] = "TomoChainTestnet";
    ChainId[ChainId["GarizonStage0"] = 90] = "GarizonStage0";
    ChainId[ChainId["GarizonStage1"] = 91] = "GarizonStage1";
    ChainId[ChainId["GarizonStage2"] = 92] = "GarizonStage2";
    ChainId[ChainId["GarizonStage3"] = 93] = "GarizonStage3";
    ChainId[ChainId["SwissDLT"] = 94] = "SwissDLT";
    ChainId[ChainId["CamDLMainnet"] = 95] = "CamDLMainnet";
    ChainId[ChainId["BitkubChain"] = 96] = "BitkubChain";
    ChainId[ChainId["BNBSmartChainTestnet"] = 97] = "BNBSmartChainTestnet";
    ChainId[ChainId["SixProtocol"] = 98] = "SixProtocol";
    ChainId[ChainId["POANetworkCore"] = 99] = "POANetworkCore";
    ChainId[ChainId["Gnosis"] = 100] = "Gnosis";
    ChainId[ChainId["EtherInc"] = 101] = "EtherInc";
    ChainId[ChainId["Web3GamesTestnet"] = 102] = "Web3GamesTestnet";
    ChainId[ChainId["WorldlandMainnet"] = 103] = "WorldlandMainnet";
    ChainId[ChainId["KaibaLightningChainTestnet"] = 104] = "KaibaLightningChainTestnet";
    ChainId[ChainId["Web3GamesDevnet"] = 105] = "Web3GamesDevnet";
    ChainId[ChainId["VelasEVMMainnet"] = 106] = "VelasEVMMainnet";
    ChainId[ChainId["NebulaTestnet"] = 107] = "NebulaTestnet";
    ChainId[ChainId["ThunderCoreMainnet"] = 108] = "ThunderCoreMainnet";
    ChainId[ChainId["Shibarium"] = 109] = "Shibarium";
    ChainId[ChainId["ProtonTestnet"] = 110] = "ProtonTestnet";
    ChainId[ChainId["EtherLiteChain"] = 111] = "EtherLiteChain";
    ChainId[ChainId["CoinbitMainnet"] = 112] = "CoinbitMainnet";
    ChainId[ChainId["Dehvo"] = 113] = "Dehvo";
    ChainId[ChainId["FlareTestnetCoston2"] = 114] = "FlareTestnetCoston2";
    ChainId[ChainId["DeBankTestnet(Deprecated)"] = 115] = "DeBankTestnet(Deprecated)";
    ChainId[ChainId["DeBankMainnet"] = 116] = "DeBankMainnet";
    ChainId[ChainId["UptickMainnet"] = 117] = "UptickMainnet";
    ChainId[ChainId["ArcologyTestnet"] = 118] = "ArcologyTestnet";
    ChainId[ChainId["ENULSMainnet"] = 119] = "ENULSMainnet";
    ChainId[ChainId["ENULSTestnet"] = 120] = "ENULSTestnet";
    ChainId[ChainId["RealchainMainnet"] = 121] = "RealchainMainnet";
    ChainId[ChainId["FuseMainnet"] = 122] = "FuseMainnet";
    ChainId[ChainId["FuseSparknet"] = 123] = "FuseSparknet";
    ChainId[ChainId["DecentralizedWebMainnet"] = 124] = "DecentralizedWebMainnet";
    ChainId[ChainId["OYchainTestnet"] = 125] = "OYchainTestnet";
    ChainId[ChainId["OYchainMainnet"] = 126] = "OYchainMainnet";
    ChainId[ChainId["Factory127Mainnet"] = 127] = "Factory127Mainnet";
    ChainId[ChainId["HuobiECOChainMainnet"] = 128] = "HuobiECOChainMainnet";
    ChainId[ChainId["InnovatorChain"] = 129] = "InnovatorChain";
    ChainId[ChainId["EngramTestnet"] = 131] = "EngramTestnet";
    ChainId[ChainId["IExecSidechain"] = 134] = "IExecSidechain";
    ChainId[ChainId["AlyxChainTestnet"] = 135] = "AlyxChainTestnet";
    ChainId[ChainId["DeamchainMainnet"] = 136] = "DeamchainMainnet";
    ChainId[ChainId["PolygonMainnet"] = 137] = "PolygonMainnet";
    ChainId[ChainId["DefiOracleMetaMainnet"] = 138] = "DefiOracleMetaMainnet";
    ChainId[ChainId["WoopChainMainnet"] = 139] = "WoopChainMainnet";
    ChainId[ChainId["OpenpieceTestnet"] = 141] = "OpenpieceTestnet";
    ChainId[ChainId["DAXCHAIN"] = 142] = "DAXCHAIN";
    ChainId[ChainId["PHINetworkv2"] = 144] = "PHINetworkv2";
    ChainId[ChainId["ShimmerEVM"] = 148] = "ShimmerEVM";
    ChainId[ChainId["SixProtocolTestnet"] = 150] = "SixProtocolTestnet";
    ChainId[ChainId["RedbellyNetworkMainnet"] = 151] = "RedbellyNetworkMainnet";
    ChainId[ChainId["RedbellyNetworkDevnet"] = 152] = "RedbellyNetworkDevnet";
    ChainId[ChainId["RedbellyNetworkTestnet"] = 153] = "RedbellyNetworkTestnet";
    ChainId[ChainId["RedbellyNetworkTGE"] = 154] = "RedbellyNetworkTGE";
    ChainId[ChainId["TenetTestnet"] = 155] = "TenetTestnet";
    ChainId[ChainId["OEBlockTestnet"] = 156] = "OEBlockTestnet";
    ChainId[ChainId["ArmoniaEvaChainMainnet"] = 160] = "ArmoniaEvaChainMainnet";
    ChainId[ChainId["ArmoniaEvaChainTestnet"] = 161] = "ArmoniaEvaChainTestnet";
    ChainId[ChainId["LightstreamsTestnet"] = 162] = "LightstreamsTestnet";
    ChainId[ChainId["LightstreamsMainnet"] = 163] = "LightstreamsMainnet";
    ChainId[ChainId["OmniTestnet"] = 165] = "OmniTestnet";
    ChainId[ChainId["AtoshiTestnet"] = 167] = "AtoshiTestnet";
    ChainId[ChainId["AIOZNetwork"] = 168] = "AIOZNetwork";
    ChainId[ChainId["MantaPacificMainnet"] = 169] = "MantaPacificMainnet";
    ChainId[ChainId["HOOSmartChainTestnet"] = 170] = "HOOSmartChainTestnet";
    ChainId[ChainId["Latam-BlockchainResilTestnet"] = 172] = "Latam-BlockchainResilTestnet";
    ChainId[ChainId["AMEChainMainnet"] = 180] = "AMEChainMainnet";
    ChainId[ChainId["SeeleMainnet"] = 186] = "SeeleMainnet";
    ChainId[ChainId["BMCMainnet"] = 188] = "BMCMainnet";
    ChainId[ChainId["BMCTestnet"] = 189] = "BMCTestnet";
    ChainId[ChainId["CryptoEmergency"] = 193] = "CryptoEmergency";
    ChainId[ChainId["X1Testnet"] = 195] = "X1Testnet";
    ChainId[ChainId["X1Mainnet"] = 196] = "X1Mainnet";
    ChainId[ChainId["NeutrinosTestNet"] = 197] = "NeutrinosTestNet";
    ChainId[ChainId["BitchainMainnet"] = 198] = "BitchainMainnet";
    ChainId[ChainId["BitTorrentChainMainnet"] = 199] = "BitTorrentChainMainnet";
    ChainId[ChainId["ArbitrumonxDai"] = 200] = "ArbitrumonxDai";
    ChainId[ChainId["MOACtestnet"] = 201] = "MOACtestnet";
    ChainId[ChainId["OpBNBMainnet"] = 204] = "OpBNBMainnet";
    ChainId[ChainId["VinuChainTestnet"] = 206] = "VinuChainTestnet";
    ChainId[ChainId["VinuChainNetwork"] = 207] = "VinuChainNetwork";
    ChainId[ChainId["StructxMainnet"] = 208] = "StructxMainnet";
    ChainId[ChainId["Bitnet"] = 210] = "Bitnet";
    ChainId[ChainId["FreightTrustNetwork"] = 211] = "FreightTrustNetwork";
    ChainId[ChainId["MAPMakalu"] = 212] = "MAPMakalu";
    ChainId[ChainId["ShinariumMainnet"] = 214] = "ShinariumMainnet";
    ChainId[ChainId["SiriusNetV2"] = 217] = "SiriusNetV2";
    ChainId[ChainId["SoterOneMainnetold"] = 218] = "SoterOneMainnetold";
    ChainId[ChainId["ScalindTestnet"] = 220] = "ScalindTestnet";
    ChainId[ChainId["Permission"] = 222] = "Permission";
    ChainId[ChainId["LACHAINMainnet"] = 225] = "LACHAINMainnet";
    ChainId[ChainId["LACHAINTestnet"] = 226] = "LACHAINTestnet";
    ChainId[ChainId["SwapDEX"] = 230] = "SwapDEX";
    ChainId[ChainId["DeamchainTestnet"] = 236] = "DeamchainTestnet";
    ChainId[ChainId["BlastMainnet"] = 238] = "BlastMainnet";
    ChainId[ChainId["PlingaMainnet"] = 242] = "PlingaMainnet";
    ChainId[ChainId["EnergyWebChain"] = 246] = "EnergyWebChain";
    ChainId[ChainId["OasysMainnet"] = 248] = "OasysMainnet";
    ChainId[ChainId["FantomOpera"] = 250] = "FantomOpera";
    ChainId[ChainId["FraxtalMainnet"] = 252] = "FraxtalMainnet";
    ChainId[ChainId["Kroma"] = 255] = "Kroma";
    ChainId[ChainId["HuobiECOChainTestnet"] = 256] = "HuobiECOChainTestnet";
    ChainId[ChainId["Setheum"] = 258] = "Setheum";
    ChainId[ChainId["NeonlinkMainnet"] = 259] = "NeonlinkMainnet";
    ChainId[ChainId["SURBlockchainNetwork"] = 262] = "SURBlockchainNetwork";
    ChainId[ChainId["HighPerformanceBlockchain"] = 269] = "HighPerformanceBlockchain";
    ChainId[ChainId["EgonCoinMainnet"] = 271] = "EgonCoinMainnet";
    ChainId[ChainId["LaChain"] = 274] = "LaChain";
    ChainId[ChainId["ZkSyncEraGoerliTestnet(deprecated)"] = 280] = "ZkSyncEraGoerliTestnet(deprecated)";
    ChainId[ChainId["BobaNetwork"] = 288] = "BobaNetwork";
    ChainId[ChainId["OrderlyMainnet"] = 291] = "OrderlyMainnet";
    ChainId[ChainId["HederaMainnet"] = 295] = "HederaMainnet";
    ChainId[ChainId["HederaTestnet"] = 296] = "HederaTestnet";
    ChainId[ChainId["HederaPreviewnet"] = 297] = "HederaPreviewnet";
    ChainId[ChainId["HederaLocalnet"] = 298] = "HederaLocalnet";
    ChainId[ChainId["ZkSyncSepoliaTestnet"] = 300] = "ZkSyncSepoliaTestnet";
    ChainId[ChainId["Bobaopera"] = 301] = "Bobaopera";
    ChainId[ChainId["NeurochainTestnet"] = 303] = "NeurochainTestnet";
    ChainId[ChainId["WyzthTestnet"] = 309] = "WyzthTestnet";
    ChainId[ChainId["OmaxMainnet"] = 311] = "OmaxMainnet";
    ChainId[ChainId["NeurochainMainnet"] = 313] = "NeurochainMainnet";
    ChainId[ChainId["Filecoin-Mainnet"] = 314] = "Filecoin-Mainnet";
    ChainId[ChainId["KCCMainnet"] = 321] = "KCCMainnet";
    ChainId[ChainId["KCCTestnet"] = 322] = "KCCTestnet";
    ChainId[ChainId["ZkSyncMainnet"] = 324] = "ZkSyncMainnet";
    ChainId[ChainId["Web3QMainnet"] = 333] = "Web3QMainnet";
    ChainId[ChainId["DFKChainTest"] = 335] = "DFKChainTest";
    ChainId[ChainId["Shiden"] = 336] = "Shiden";
    ChainId[ChainId["CronosTestnet"] = 338] = "CronosTestnet";
    ChainId[ChainId["ThetaMainnet"] = 361] = "ThetaMainnet";
    ChainId[ChainId["ThetaSapphireTestnet"] = 363] = "ThetaSapphireTestnet";
    ChainId[ChainId["ThetaAmberTestnet"] = 364] = "ThetaAmberTestnet";
    ChainId[ChainId["ThetaTestnet"] = 365] = "ThetaTestnet";
    ChainId[ChainId["PulseChain"] = 369] = "PulseChain";
    ChainId[ChainId["ConstaTestnet"] = 371] = "ConstaTestnet";
    ChainId[ChainId["ZKAmoebaTestnet"] = 380] = "ZKAmoebaTestnet";
    ChainId[ChainId["ZKAmoebaMainnet"] = 381] = "ZKAmoebaMainnet";
    ChainId[ChainId["Lisinski"] = 385] = "Lisinski";
    ChainId[ChainId["Nativ3Mainnet"] = 399] = "Nativ3Mainnet";
    ChainId[ChainId["HyperonChainTestNet"] = 400] = "HyperonChainTestNet";
    ChainId[ChainId["OzoneChainTestnet"] = 401] = "OzoneChainTestnet";
    ChainId[ChainId["PepeChainMainnet"] = 411] = "PepeChainMainnet";
    ChainId[ChainId["SXNetworkMainnet"] = 416] = "SXNetworkMainnet";
    ChainId[ChainId["LaTestnet"] = 418] = "LaTestnet";
    ChainId[ChainId["OptimismGoerliTestnet"] = 420] = "OptimismGoerliTestnet";
    ChainId[ChainId["PGN(PublicGoodsNetwork)"] = 424] = "PGN(PublicGoodsNetwork)";
    ChainId[ChainId["ZeethChain"] = 427] = "ZeethChain";
    ChainId[ChainId["GesoVerse"] = 428] = "GesoVerse";
    ChainId[ChainId["TenTestnet"] = 443] = "TenTestnet";
    ChainId[ChainId["SynapseChainTestnet"] = 444] = "SynapseChainTestnet";
    ChainId[ChainId["ARZIOChain"] = 456] = "ARZIOChain";
    ChainId[ChainId["AreonNetworkTestnet"] = 462] = "AreonNetworkTestnet";
    ChainId[ChainId["AreonNetworkMainnet"] = 463] = "AreonNetworkMainnet";
    ChainId[ChainId["Rupaya"] = 499] = "Rupaya";
    ChainId[ChainId["CaminoC-Chain"] = 500] = "CaminoC-Chain";
    ChainId[ChainId["ColumbusTestNetwork"] = 501] = "ColumbusTestNetwork";
    ChainId[ChainId["Double-AChainMainnet"] = 512] = "Double-AChainMainnet";
    ChainId[ChainId["Double-AChainTestnet"] = 513] = "Double-AChainTestnet";
    ChainId[ChainId["GearZeroNetworkMainnet"] = 516] = "GearZeroNetworkMainnet";
    ChainId[ChainId["XTSmartChainMainnet"] = 520] = "XTSmartChainMainnet";
    ChainId[ChainId["FirechainMainnet"] = 529] = "FirechainMainnet";
    ChainId[ChainId["F(x)CoreMainnetNetwork"] = 530] = "F(x)CoreMainnetNetwork";
    ChainId[ChainId["Candle"] = 534] = "Candle";
    ChainId[ChainId["PAWCHAINTestnet"] = 542] = "PAWCHAINTestnet";
    ChainId[ChainId["Vela1ChainMainnet"] = 555] = "Vela1ChainMainnet";
    ChainId[ChainId["TaoNetwork"] = 558] = "TaoNetwork";
    ChainId[ChainId["DogechainTestnet"] = 568] = "DogechainTestnet";
    ChainId[ChainId["RolluxMainnet"] = 570] = "RolluxMainnet";
    ChainId[ChainId["MetaChainMainnet"] = 571] = "MetaChainMainnet";
    ChainId[ChainId["MetisStardustTestnet"] = 588] = "MetisStardustTestnet";
    ChainId[ChainId["Astar"] = 592] = "Astar";
    ChainId[ChainId["AcalaMandalaTestnetTC9"] = 595] = "AcalaMandalaTestnetTC9";
    ChainId[ChainId["KaruraNetworkTestnet"] = 596] = "KaruraNetworkTestnet";
    ChainId[ChainId["AcalaNetworkTestnet"] = 597] = "AcalaNetworkTestnet";
    ChainId[ChainId["MetisGoerliTestnet"] = 599] = "MetisGoerliTestnet";
    ChainId[ChainId["Meshnyantestnet"] = 600] = "Meshnyantestnet";
    ChainId[ChainId["VineTestnet"] = 601] = "VineTestnet";
    ChainId[ChainId["EIOBMainnet"] = 612] = "EIOBMainnet";
    ChainId[ChainId["GraphlinqBlockchainMainnet"] = 614] = "GraphlinqBlockchainMainnet";
    ChainId[ChainId["Avocado"] = 634] = "Avocado";
    ChainId[ChainId["SXNetworkTestnet"] = 647] = "SXNetworkTestnet";
    ChainId[ChainId["EnduranceSmartChainMainnet"] = 648] = "EnduranceSmartChainMainnet";
    ChainId[ChainId["KalichainTestnet"] = 653] = "KalichainTestnet";
    ChainId[ChainId["Kalichain"] = 654] = "Kalichain";
    ChainId[ChainId["PixieChainTestnet"] = 666] = "PixieChainTestnet";
    ChainId[ChainId["LAOSArrakis"] = 667] = "LAOSArrakis";
    ChainId[ChainId["JuncaChain"] = 668] = "JuncaChain";
    ChainId[ChainId["JuncaChaintestnet"] = 669] = "JuncaChaintestnet";
    ChainId[ChainId["KaruraNetwork"] = 686] = "KaruraNetwork";
    ChainId[ChainId["StarSocialTestnet"] = 700] = "StarSocialTestnet";
    ChainId[ChainId["BlockChainStationMainnet"] = 707] = "BlockChainStationMainnet";
    ChainId[ChainId["BlockChainStationTestnet"] = 708] = "BlockChainStationTestnet";
    ChainId[ChainId["Highbury"] = 710] = "Highbury";
    ChainId[ChainId["ShibariumBeta"] = 719] = "ShibariumBeta";
    ChainId[ChainId["LycanChain"] = 721] = "LycanChain";
    ChainId[ChainId["Blucrates"] = 727] = "Blucrates";
    ChainId[ChainId["CantoTestnet"] = 740] = "CantoTestnet";
    ChainId[ChainId["VentionSmartChainTestnet"] = 741] = "VentionSmartChainTestnet";
    ChainId[ChainId["ScriptTestnet"] = 742] = "ScriptTestnet";
    ChainId[ChainId["QL1"] = 766] = "QL1";
    ChainId[ChainId["OpenChainTestnet"] = 776] = "OpenChainTestnet";
    ChainId[ChainId["CheapETH"] = 777] = "CheapETH";
    ChainId[ChainId["MAALChain"] = 786] = "MAALChain";
    ChainId[ChainId["AcalaNetwork"] = 787] = "AcalaNetwork";
    ChainId[ChainId["AerochainTestnet"] = 788] = "AerochainTestnet";
    ChainId[ChainId["Patex"] = 789] = "Patex";
    ChainId[ChainId["LucidBlockchain"] = 800] = "LucidBlockchain";
    ChainId[ChainId["Haic"] = 803] = "Haic";
    ChainId[ChainId["PortalFantasyChainTest"] = 808] = "PortalFantasyChainTest";
    ChainId[ChainId["Haven1Testnet"] = 810] = "Haven1Testnet";
    ChainId[ChainId["Qitmeer"] = 813] = "Qitmeer";
    ChainId[ChainId["FirechainzkEVM"] = 814] = "FirechainzkEVM";
    ChainId[ChainId["BeOneChainMainnet"] = 818] = "BeOneChainMainnet";
    ChainId[ChainId["CallistoMainnet"] = 820] = "CallistoMainnet";
    ChainId[ChainId["CallistoTestnetDeprecated"] = 821] = "CallistoTestnetDeprecated";
    ChainId[ChainId["TaraxaMainnet"] = 841] = "TaraxaMainnet";
    ChainId[ChainId["TaraxaTestnet"] = 842] = "TaraxaTestnet";
    ChainId[ChainId["ZeethChainDev"] = 859] = "ZeethChainDev";
    ChainId[ChainId["FantasiaChainMainnet"] = 868] = "FantasiaChainMainnet";
    ChainId[ChainId["BandaiNamcoResearchVerseMainnet"] = 876] = "BandaiNamcoResearchVerseMainnet";
    ChainId[ChainId["DexitNetwork"] = 877] = "DexitNetwork";
    ChainId[ChainId["AmbrosChainMainnet"] = 880] = "AmbrosChainMainnet";
    ChainId[ChainId["Wanchain"] = 888] = "Wanchain";
    ChainId[ChainId["GarizonTestnetStage0"] = 900] = "GarizonTestnetStage0";
    ChainId[ChainId["GarizonTestnetStage1"] = 901] = "GarizonTestnetStage1";
    ChainId[ChainId["GarizonTestnetStage2"] = 902] = "GarizonTestnetStage2";
    ChainId[ChainId["GarizonTestnetStage3"] = 903] = "GarizonTestnetStage3";
    ChainId[ChainId["PortalFantasyChain"] = 909] = "PortalFantasyChain";
    ChainId[ChainId["DecentraBoneLayer1Testnet"] = 910] = "DecentraBoneLayer1Testnet";
    ChainId[ChainId["RiniaTestnet"] = 917] = "RiniaTestnet";
    ChainId[ChainId["ModeTestnet"] = 919] = "ModeTestnet";
    ChainId[ChainId["YidarkChainMainnet"] = 927] = "YidarkChainMainnet";
    ChainId[ChainId["PulseChainTestnet"] = 940] = "PulseChainTestnet";
    ChainId[ChainId["PulseChainTestnetv2b"] = 941] = "PulseChainTestnetv2b";
    ChainId[ChainId["PulseChainTestnetv3"] = 942] = "PulseChainTestnetv3";
    ChainId[ChainId["PulseChainTestnetv4"] = 943] = "PulseChainTestnetv4";
    ChainId[ChainId["MuNodeTestnet"] = 956] = "MuNodeTestnet";
    ChainId[ChainId["LyraChain"] = 957] = "LyraChain";
    ChainId[ChainId["BTC20SmartChain"] = 963] = "BTC20SmartChain";
    ChainId[ChainId["OortMainnet"] = 970] = "OortMainnet";
    ChainId[ChainId["OortHuygens"] = 971] = "OortHuygens";
    ChainId[ChainId["OortAscraeus"] = 972] = "OortAscraeus";
    ChainId[ChainId["NepalBlockchainNetwork"] = 977] = "NepalBlockchainNetwork";
    ChainId[ChainId["TOPMainnetEVM"] = 980] = "TOPMainnetEVM";
    ChainId[ChainId["MemoSmartChainMainnet"] = 985] = "MemoSmartChainMainnet";
    ChainId[ChainId["TOPMainnet"] = 989] = "TOPMainnet";
    ChainId[ChainId["ELibertyMainnet"] = 990] = "ELibertyMainnet";
    ChainId[ChainId["5ireChainThunder"] = 997] = "5ireChainThunder";
    ChainId[ChainId["LuckyNetwork"] = 998] = "LuckyNetwork";
    ChainId[ChainId["WanchainTestnet"] = 999] = "WanchainTestnet";
    ChainId[ChainId["GTONMainnet"] = 1000] = "GTONMainnet";
    ChainId[ChainId["KlaytnTestnetBaobab"] = 1001] = "KlaytnTestnetBaobab";
    ChainId[ChainId["TectumEmissionToken"] = 1003] = "TectumEmissionToken";
    ChainId[ChainId["T-EKTA"] = 1004] = "T-EKTA";
    ChainId[ChainId["NewtonTestnet"] = 1007] = "NewtonTestnet";
    ChainId[ChainId["EurusMainnet"] = 1008] = "EurusMainnet";
    ChainId[ChainId["EvriceNetwork"] = 1010] = "EvriceNetwork";
    ChainId[ChainId["Newton"] = 1012] = "Newton";
    ChainId[ChainId["Sakura"] = 1022] = "Sakura";
    ChainId[ChainId["CloverTestnet"] = 1023] = "CloverTestnet";
    ChainId[ChainId["CLVParachain"] = 1024] = "CLVParachain";
    ChainId[ChainId["BitTorrentChainTestnet"] = 1028] = "BitTorrentChainTestnet";
    ChainId[ChainId["ConfluxeSpace"] = 1030] = "ConfluxeSpace";
    ChainId[ChainId["ProxyNetworkTestnet"] = 1031] = "ProxyNetworkTestnet";
    ChainId[ChainId["BronosTestnet"] = 1038] = "BronosTestnet";
    ChainId[ChainId["BronosMainnet"] = 1039] = "BronosMainnet";
    ChainId[ChainId["ShimmerEVMTestnetDeprecated"] = 1071] = "ShimmerEVMTestnetDeprecated";
    ChainId[ChainId["ShimmerEVMTestnetDeprecated1072"] = 1072] = "ShimmerEVMTestnetDeprecated1072";
    ChainId[ChainId["ShimmerEVMTestnet"] = 1073] = "ShimmerEVMTestnet";
    ChainId[ChainId["MintaraTestnet"] = 1079] = "MintaraTestnet";
    ChainId[ChainId["MintaraMainnet"] = 1080] = "MintaraMainnet";
    ChainId[ChainId["MetisAndromedaMainnet"] = 1088] = "MetisAndromedaMainnet";
    ChainId[ChainId["Humans.aiMainnet"] = 1089] = "Humans.aiMainnet";
    ChainId[ChainId["MOACmainnet"] = 1099] = "MOACmainnet";
    ChainId[ChainId["PolygonzkEVM"] = 1101] = "PolygonzkEVM";
    ChainId[ChainId["BLXqTestnet"] = 1107] = "BLXqTestnet";
    ChainId[ChainId["BLXqMainnet"] = 1108] = "BLXqMainnet";
    ChainId[ChainId["WEMIX3.0Mainnet"] = 1111] = "WEMIX3.0Mainnet";
    ChainId[ChainId["WEMIX3.0Testnet"] = 1112] = "WEMIX3.0Testnet";
    ChainId[ChainId["CoreBlockchainTestnet"] = 1115] = "CoreBlockchainTestnet";
    ChainId[ChainId["CoreBlockchainMainnet"] = 1116] = "CoreBlockchainMainnet";
    ChainId[ChainId["DogcoinMainnet"] = 1117] = "DogcoinMainnet";
    ChainId[ChainId["DeFiChainEVMNetworkMainnet"] = 1130] = "DeFiChainEVMNetworkMainnet";
    ChainId[ChainId["DeFiChainEVMNetworkTestnet"] = 1131] = "DeFiChainEVMNetworkTestnet";
    ChainId[ChainId["DeFiMetaChainChangiTestnet"] = 1133] = "DeFiMetaChainChangiTestnet";
    ChainId[ChainId["AmStarTestnet"] = 1138] = "AmStarTestnet";
    ChainId[ChainId["MathChain"] = 1139] = "MathChain";
    ChainId[ChainId["MathChainTestnet"] = 1140] = "MathChainTestnet";
    ChainId[ChainId["SymplexiaSmartChain"] = 1149] = "SymplexiaSmartChain";
    ChainId[ChainId["OriginTestnet"] = 1170] = "OriginTestnet";
    ChainId[ChainId["SmartHostTeknolojiTESTNET"] = 1177] = "SmartHostTeknolojiTESTNET";
    ChainId[ChainId["IoraChain"] = 1197] = "IoraChain";
    ChainId[ChainId["EvanescoTestnet"] = 1201] = "EvanescoTestnet";
    ChainId[ChainId["WorldTradeTechnicalChainMainnet"] = 1202] = "WorldTradeTechnicalChainMainnet";
    ChainId[ChainId["PopcateumMainnet"] = 1213] = "PopcateumMainnet";
    ChainId[ChainId["EnterChainMainnet"] = 1214] = "EnterChainMainnet";
    ChainId[ChainId["ExzoNetworkMainnet"] = 1229] = "ExzoNetworkMainnet";
    ChainId[ChainId["UltronTestnet"] = 1230] = "UltronTestnet";
    ChainId[ChainId["UltronMainnet"] = 1231] = "UltronMainnet";
    ChainId[ChainId["StepNetwork"] = 1234] = "StepNetwork";
    ChainId[ChainId["ARCMainnet"] = 1243] = "ARCMainnet";
    ChainId[ChainId["ARCTestnet"] = 1244] = "ARCTestnet";
    ChainId[ChainId["OMPlatformMainnet"] = 1246] = "OMPlatformMainnet";
    ChainId[ChainId["DogetherMainnet"] = 1248] = "DogetherMainnet";
    ChainId[ChainId["CICChainTestnet"] = 1252] = "CICChainTestnet";
    ChainId[ChainId["HALOMainnet"] = 1280] = "HALOMainnet";
    ChainId[ChainId["Moonbeam"] = 1284] = "Moonbeam";
    ChainId[ChainId["Moonriver"] = 1285] = "Moonriver";
    ChainId[ChainId["Moonrockold"] = 1286] = "Moonrockold";
    ChainId[ChainId["MoonbaseAlpha"] = 1287] = "MoonbaseAlpha";
    ChainId[ChainId["Moonrock"] = 1288] = "Moonrock";
    ChainId[ChainId["SwisstronikTestnet"] = 1291] = "SwisstronikTestnet";
    ChainId[ChainId["Bobabeam"] = 1294] = "Bobabeam";
    ChainId[ChainId["BobabaseTestnet"] = 1297] = "BobabaseTestnet";
    ChainId[ChainId["DosFujiSubnet"] = 1311] = "DosFujiSubnet";
    ChainId[ChainId["AlyxMainnet"] = 1314] = "AlyxMainnet";
    ChainId[ChainId["AIAMainnet"] = 1319] = "AIAMainnet";
    ChainId[ChainId["AIATestnet"] = 1320] = "AIATestnet";
    ChainId[ChainId["GethTestnet"] = 1337] = "GethTestnet";
    ChainId[ChainId["ElysiumTestnet"] = 1338] = "ElysiumTestnet";
    ChainId[ChainId["ElysiumMainnet"] = 1339] = "ElysiumMainnet";
    ChainId[ChainId["BlitzSubnet"] = 1343] = "BlitzSubnet";
    ChainId[ChainId["CICChainMainnet"] = 1353] = "CICChainMainnet";
    ChainId[ChainId["ZafiriumMainnet"] = 1369] = "ZafiriumMainnet";
    ChainId[ChainId["KalarChain"] = 1379] = "KalarChain";
    ChainId[ChainId["AmStarMainnet"] = 1388] = "AmStarMainnet";
    ChainId[ChainId["JoseonMainnet"] = 1392] = "JoseonMainnet";
    ChainId[ChainId["PolygonzkEVMTestnetold"] = 1402] = "PolygonzkEVMTestnetold";
    ChainId[ChainId["PolygonzkEVMTestnetPreAudit-Upgraded"] = 1422] = "PolygonzkEVMTestnetPreAudit-Upgraded";
    ChainId[ChainId["RikezaNetworkMainnet"] = 1433] = "RikezaNetworkMainnet";
    ChainId[ChainId["LivingAssetsMainnet"] = 1440] = "LivingAssetsMainnet";
    ChainId[ChainId["PolygonzkEVMTestnet"] = 1442] = "PolygonzkEVMTestnet";
    ChainId[ChainId["GILTestnet"] = 1452] = "GILTestnet";
    ChainId[ChainId["CtexScanBlockchain"] = 1455] = "CtexScanBlockchain";
    ChainId[ChainId["BEVMCanary"] = 1501] = "BEVMCanary";
    ChainId[ChainId["SherpaxMainnet"] = 1506] = "SherpaxMainnet";
    ChainId[ChainId["SherpaxTestnet"] = 1507] = "SherpaxTestnet";
    ChainId[ChainId["BeagleMessagingChain"] = 1515] = "BeagleMessagingChain";
    ChainId[ChainId["Tenet"] = 1559] = "Tenet";
    ChainId[ChainId["CatecoinChainMainnet"] = 1618] = "CatecoinChainMainnet";
    ChainId[ChainId["Atheios"] = 1620] = "Atheios";
    ChainId[ChainId["Btachain"] = 1657] = "Btachain";
    ChainId[ChainId["Liquichain"] = 1662] = "Liquichain";
    ChainId[ChainId["HorizenGobiTestnet"] = 1663] = "HorizenGobiTestnet";
    ChainId[ChainId["LUDANMainnet"] = 1688] = "LUDANMainnet";
    ChainId[ChainId["AnytypeEVMChain"] = 1701] = "AnytypeEVMChain";
    ChainId[ChainId["TBSIMainnet"] = 1707] = "TBSIMainnet";
    ChainId[ChainId["TBSITestnet"] = 1708] = "TBSITestnet";
    ChainId[ChainId["PaletteChainMainnet"] = 1718] = "PaletteChainMainnet";
    ChainId[ChainId["PartyChain"] = 1773] = "PartyChain";
    ChainId[ChainId["GaussMainnet"] = 1777] = "GaussMainnet";
    ChainId[ChainId["Kerleano"] = 1804] = "Kerleano";
    ChainId[ChainId["RabbitAnalogTestnetChain"] = 1807] = "RabbitAnalogTestnetChain";
    ChainId[ChainId["CubeChainMainnet"] = 1818] = "CubeChainMainnet";
    ChainId[ChainId["CubeChainTestnet"] = 1819] = "CubeChainTestnet";
    ChainId[ChainId["RubySmartChainMAINNET"] = 1821] = "RubySmartChainMAINNET";
    ChainId[ChainId["Teslafunds"] = 1856] = "Teslafunds";
    ChainId[ChainId["WhiteBITNetwork"] = 1875] = "WhiteBITNetwork";
    ChainId[ChainId["GitshockCartenzTestnet"] = 1881] = "GitshockCartenzTestnet";
    ChainId[ChainId["LightlinkPhoenixMainnet"] = 1890] = "LightlinkPhoenixMainnet";
    ChainId[ChainId["LightlinkPegasusTestnet"] = 1891] = "LightlinkPegasusTestnet";
    ChainId[ChainId["BONNetwork"] = 1898] = "BONNetwork";
    ChainId[ChainId["SportsChainNetwork"] = 1904] = "SportsChainNetwork";
    ChainId[ChainId["BitcichainMainnet"] = 1907] = "BitcichainMainnet";
    ChainId[ChainId["BitcichainTestnet"] = 1908] = "BitcichainTestnet";
    ChainId[ChainId["MerkleScan"] = 1909] = "MerkleScan";
    ChainId[ChainId["Scalind"] = 1911] = "Scalind";
    ChainId[ChainId["RubySmartChainTestnet"] = 1912] = "RubySmartChainTestnet";
    ChainId[ChainId["ONUSChainTestnet"] = 1945] = "ONUSChainTestnet";
    ChainId[ChainId["D-ChainMainnet"] = 1951] = "D-ChainMainnet";
    ChainId[ChainId["DexillaTestnet"] = 1954] = "DexillaTestnet";
    ChainId[ChainId["Eleanor"] = 1967] = "Eleanor";
    ChainId[ChainId["SuperSmartChainTestnet"] = 1969] = "SuperSmartChainTestnet";
    ChainId[ChainId["SuperSmartChainMainnet"] = 1970] = "SuperSmartChainMainnet";
    ChainId[ChainId["Atelier"] = 1971] = "Atelier";
    ChainId[ChainId["RedeCoin"] = 1972] = "RedeCoin";
    ChainId[ChainId["ONUSChainMainnet"] = 1975] = "ONUSChainMainnet";
    ChainId[ChainId["EurusTestnet"] = 1984] = "EurusTestnet";
    ChainId[ChainId["SatoshIE"] = 1985] = "SatoshIE";
    ChainId[ChainId["SatoshIETestnet"] = 1986] = "SatoshIETestnet";
    ChainId[ChainId["EtherGem"] = 1987] = "EtherGem";
    ChainId[ChainId["Ekta"] = 1994] = "Ekta";
    ChainId[ChainId["EdeXaTestnet"] = 1995] = "EdeXaTestnet";
    ChainId[ChainId["KyotoTestnet"] = 1998] = "KyotoTestnet";
    ChainId[ChainId["DogechainMainnet"] = 2000] = "DogechainMainnet";
    ChainId[ChainId["MilkomedaC1Mainnet"] = 2001] = "MilkomedaC1Mainnet";
    ChainId[ChainId["MilkomedaA1Mainnet"] = 2002] = "MilkomedaA1Mainnet";
    ChainId[ChainId["CloudWalkTestnet"] = 2008] = "CloudWalkTestnet";
    ChainId[ChainId["CloudWalkMainnet"] = 2009] = "CloudWalkMainnet";
    ChainId[ChainId["MainnetZMainnet"] = 2016] = "MainnetZMainnet";
    ChainId[ChainId["PublicMintDevnet"] = 2018] = "PublicMintDevnet";
    ChainId[ChainId["PublicMintTestnet"] = 2019] = "PublicMintTestnet";
    ChainId[ChainId["PublicMintMainnet"] = 2020] = "PublicMintMainnet";
    ChainId[ChainId["EdgewareEdgeEVMMainnet"] = 2021] = "EdgewareEdgeEVMMainnet";
    ChainId[ChainId["BeresheetBereEVMTestnet"] = 2022] = "BeresheetBereEVMTestnet";
    ChainId[ChainId["TaycanTestnet"] = 2023] = "TaycanTestnet";
    ChainId[ChainId["RangersProtocolMainnet"] = 2025] = "RangersProtocolMainnet";
    ChainId[ChainId["Centrifuge"] = 2031] = "Centrifuge";
    ChainId[ChainId["Catalyst"] = 2032] = "Catalyst";
    ChainId[ChainId["PhalaNetwork"] = 2035] = "PhalaNetwork";
    ChainId[ChainId["KiwiSubnet"] = 2037] = "KiwiSubnet";
    ChainId[ChainId["ShrapnelTestnet"] = 2038] = "ShrapnelTestnet";
    ChainId[ChainId["OriginTrailParachain"] = 2043] = "OriginTrailParachain";
    ChainId[ChainId["ShrapnelSubnet"] = 2044] = "ShrapnelSubnet";
    ChainId[ChainId["StratosTestnet"] = 2047] = "StratosTestnet";
    ChainId[ChainId["Stratos"] = 2048] = "Stratos";
    ChainId[ChainId["MovoSmartChainMainnet"] = 2049] = "MovoSmartChainMainnet";
    ChainId[ChainId["QuokkacoinMainnet"] = 2077] = "QuokkacoinMainnet";
    ChainId[ChainId["Altair"] = 2088] = "Altair";
    ChainId[ChainId["Algol"] = 2089] = "Algol";
    ChainId[ChainId["EcoballMainnet"] = 2100] = "EcoballMainnet";
    ChainId[ChainId["EcoballTestnetEspuma"] = 2101] = "EcoballTestnetEspuma";
    ChainId[ChainId["ExosamaNetwork"] = 2109] = "ExosamaNetwork";
    ChainId[ChainId["MetaplayeroneMainnet"] = 2122] = "MetaplayeroneMainnet";
    ChainId[ChainId["MetaplayeroneDubaiTestnet"] = 2124] = "MetaplayeroneDubaiTestnet";
    ChainId[ChainId["BigShortBets"] = 2137] = "BigShortBets";
    ChainId[ChainId["DefiOracleMetaTestnet"] = 2138] = "DefiOracleMetaTestnet";
    ChainId[ChainId["BOSagoraMainnet"] = 2151] = "BOSagoraMainnet";
    ChainId[ChainId["FindoraMainnet"] = 2152] = "FindoraMainnet";
    ChainId[ChainId["FindoraTestnet"] = 2153] = "FindoraTestnet";
    ChainId[ChainId["FindoraForge"] = 2154] = "FindoraForge";
    ChainId[ChainId["MoonsamaNetwork"] = 2199] = "MoonsamaNetwork";
    ChainId[ChainId["AntofyMainnet"] = 2202] = "AntofyMainnet";
    ChainId[ChainId["BitcoinEVM"] = 2203] = "BitcoinEVM";
    ChainId[ChainId["EvanescoMainnet"] = 2213] = "EvanescoMainnet";
    ChainId[ChainId["KavaTestnet"] = 2221] = "KavaTestnet";
    ChainId[ChainId["Kava"] = 2222] = "Kava";
    ChainId[ChainId["VChainMainnet"] = 2223] = "VChainMainnet";
    ChainId[ChainId["KrestNetwork"] = 2241] = "KrestNetwork";
    ChainId[ChainId["BOMBChain"] = 2300] = "BOMBChain";
    ChainId[ChainId["EbroNetwork"] = 2306] = "EbroNetwork";
    ChainId[ChainId["Arevia"] = 2309] = "Arevia";
    ChainId[ChainId["SOMANetworkTestnet"] = 2323] = "SOMANetworkTestnet";
    ChainId[ChainId["Altcoinchain"] = 2330] = "Altcoinchain";
    ChainId[ChainId["SOMANetworkMainnet"] = 2332] = "SOMANetworkMainnet";
    ChainId[ChainId["(deprecated)KromaSepolia"] = 2357] = "(deprecated)KromaSepolia";
    ChainId[ChainId["KromaSepolia"] = 2358] = "KromaSepolia";
    ChainId[ChainId["BOMBChainTestnet"] = 2399] = "BOMBChainTestnet";
    ChainId[ChainId["TCGVerseMainnet"] = 2400] = "TCGVerseMainnet";
    ChainId[ChainId["XODEX"] = 2415] = "XODEX";
    ChainId[ChainId["HybridChainNetworkTestnet"] = 2458] = "HybridChainNetworkTestnet";
    ChainId[ChainId["HybridChainNetworkMainnet"] = 2468] = "HybridChainNetworkMainnet";
    ChainId[ChainId["UnicornUltraNebulasTestnet"] = 2484] = "UnicornUltraNebulasTestnet";
    ChainId[ChainId["FraxtalTestnet"] = 2522] = "FraxtalTestnet";
    ChainId[ChainId["KorthoMainnet"] = 2559] = "KorthoMainnet";
    ChainId[ChainId["TechPayMainnet"] = 2569] = "TechPayMainnet";
    ChainId[ChainId["PoCRNet"] = 2606] = "PoCRNet";
    ChainId[ChainId["RedlightChainMainnet"] = 2611] = "RedlightChainMainnet";
    ChainId[ChainId["EZChainC-ChainMainnet"] = 2612] = "EZChainC-ChainMainnet";
    ChainId[ChainId["EZChainC-ChainTestnet"] = 2613] = "EZChainC-ChainTestnet";
    ChainId[ChainId["WhiteBITNetworkTestnet"] = 2625] = "WhiteBITNetworkTestnet";
    ChainId[ChainId["MorphTestnet"] = 2710] = "MorphTestnet";
    ChainId[ChainId["K-LAOS"] = 2718] = "K-LAOS";
    ChainId[ChainId["BobaNetworkGoerliTestnet"] = 2888] = "BobaNetworkGoerliTestnet";
    ChainId[ChainId["BitYuanMainnet"] = 2999] = "BitYuanMainnet";
    ChainId[ChainId["CENNZnetRata"] = 3000] = "CENNZnetRata";
    ChainId[ChainId["CENNZnetNikau"] = 3001] = "CENNZnetNikau";
    ChainId[ChainId["CanxiumMainnet"] = 3003] = "CanxiumMainnet";
    ChainId[ChainId["PLAYA3ULLGAMES"] = 3011] = "PLAYA3ULLGAMES";
    ChainId[ChainId["OrlandoChain"] = 3031] = "OrlandoChain";
    ChainId[ChainId["BifrostMainnet"] = 3068] = "BifrostMainnet";
    ChainId[ChainId["Immu3EVM"] = 3100] = "Immu3EVM";
    ChainId[ChainId["VultureEVMBeta"] = 3102] = "VultureEVMBeta";
    ChainId[ChainId["Filecoin-Hyperspacetestnet"] = 3141] = "Filecoin-Hyperspacetestnet";
    ChainId[ChainId["Dubxcoinnetwork"] = 3269] = "Dubxcoinnetwork";
    ChainId[ChainId["Dubxcointestnet"] = 3270] = "Dubxcointestnet";
    ChainId[ChainId["DebounceSubnetTestnet"] = 3306] = "DebounceSubnetTestnet";
    ChainId[ChainId["ZCoreTestnet"] = 3331] = "ZCoreTestnet";
    ChainId[ChainId["Web3QTestnet"] = 3333] = "Web3QTestnet";
    ChainId[ChainId["Web3QGalileo"] = 3334] = "Web3QGalileo";
    ChainId[ChainId["ParibuNetMainnet"] = 3400] = "ParibuNetMainnet";
    ChainId[ChainId["SecureChainTestnet"] = 3434] = "SecureChainTestnet";
    ChainId[ChainId["ParibuNetTestnet"] = 3500] = "ParibuNetTestnet";
    ChainId[ChainId["JFINChain"] = 3501] = "JFINChain";
    ChainId[ChainId["PandoProjectMainnet"] = 3601] = "PandoProjectMainnet";
    ChainId[ChainId["PandoProjectTestnet"] = 3602] = "PandoProjectTestnet";
    ChainId[ChainId["BotanixTestnet"] = 3636] = "BotanixTestnet";
    ChainId[ChainId["BotanixMainnet"] = 3637] = "BotanixMainnet";
    ChainId[ChainId["IChainNetwork"] = 3639] = "IChainNetwork";
    ChainId[ChainId["JouleverseMainnet"] = 3666] = "JouleverseMainnet";
    ChainId[ChainId["BittexMainnet"] = 3690] = "BittexMainnet";
    ChainId[ChainId["EmpireNetwork"] = 3693] = "EmpireNetwork";
    ChainId[ChainId["SenjePowersTestnet"] = 3698] = "SenjePowersTestnet";
    ChainId[ChainId["SenjePowersMainnet"] = 3699] = "SenjePowersMainnet";
    ChainId[ChainId["XplaTestnet"] = 3701] = "XplaTestnet";
    ChainId[ChainId["Crossbell"] = 3737] = "Crossbell";
    ChainId[ChainId["AlveyChainMainnet"] = 3797] = "AlveyChainMainnet";
    ChainId[ChainId["TangleTestnet"] = 3799] = "TangleTestnet";
    ChainId[ChainId["FirechainzkEVMGhostrider"] = 3885] = "FirechainzkEVMGhostrider";
    ChainId[ChainId["KalyChainMainnet"] = 3888] = "KalyChainMainnet";
    ChainId[ChainId["KalyChainTestnet"] = 3889] = "KalyChainTestnet";
    ChainId[ChainId["DRACNetwork"] = 3912] = "DRACNetwork";
    ChainId[ChainId["DOSTesnet"] = 3939] = "DOSTesnet";
    ChainId[ChainId["DYNOMainnet"] = 3966] = "DYNOMainnet";
    ChainId[ChainId["DYNOTestnet"] = 3967] = "DYNOTestnet";
    ChainId[ChainId["YuanChainMainnet"] = 3999] = "YuanChainMainnet";
    ChainId[ChainId["OzoneChainMainnet"] = 4000] = "OzoneChainMainnet";
    ChainId[ChainId["PeperiumChainTestnet"] = 4001] = "PeperiumChainTestnet";
    ChainId[ChainId["FantomTestnet"] = 4002] = "FantomTestnet";
    ChainId[ChainId["X1Fastnet"] = 4003] = "X1Fastnet";
    ChainId[ChainId["BobaoperaTestnet"] = 4051] = "BobaoperaTestnet";
    ChainId[ChainId["Nahmii3Mainnet"] = 4061] = "Nahmii3Mainnet";
    ChainId[ChainId["Nahmii3Testnet"] = 4062] = "Nahmii3Testnet";
    ChainId[ChainId["MusterMainnet"] = 4078] = "MusterMainnet";
    ChainId[ChainId["FastexChain(Bahamut)OasisTestnet"] = 4090] = "FastexChain(Bahamut)OasisTestnet";
    ChainId[ChainId["BitindiTestnet"] = 4096] = "BitindiTestnet";
    ChainId[ChainId["BitindiMainnet"] = 4099] = "BitindiMainnet";
    ChainId[ChainId["AIOZNetworkTestnet"] = 4102] = "AIOZNetworkTestnet";
    ChainId[ChainId["Humans.aiTestnet"] = 4139] = "Humans.aiTestnet";
    ChainId[ChainId["TipboxcoinTestnet"] = 4141] = "TipboxcoinTestnet";
    ChainId[ChainId["PHINetworkV1"] = 4181] = "PHINetworkV1";
    ChainId[ChainId["LUKSOTestnet"] = 4201] = "LUKSOTestnet";
    ChainId[ChainId["NexiMainnet"] = 4242] = "NexiMainnet";
    ChainId[ChainId["NexiV2Mainnet"] = 4243] = "NexiV2Mainnet";
    ChainId[ChainId["BobafujiTestnet"] = 4328] = "BobafujiTestnet";
    ChainId[ChainId["Beam"] = 4337] = "Beam";
    ChainId[ChainId["CreditSmartChainMainnet"] = 4400] = "CreditSmartChainMainnet";
    ChainId[ChainId["HtmlcoinMainnet"] = 4444] = "HtmlcoinMainnet";
    ChainId[ChainId["OrderlySepoliaTestnet"] = 4460] = "OrderlySepoliaTestnet";
    ChainId[ChainId["IoTeXNetworkMainnet"] = 4689] = "IoTeXNetworkMainnet";
    ChainId[ChainId["IoTeXNetworkTestnet"] = 4690] = "IoTeXNetworkTestnet";
    ChainId[ChainId["MEVerseChainTestnet"] = 4759] = "MEVerseChainTestnet";
    ChainId[ChainId["BlackFortExchangeNetworkTestnet"] = 4777] = "BlackFortExchangeNetworkTestnet";
    ChainId[ChainId["GlobelChain"] = 4893] = "GlobelChain";
    ChainId[ChainId["VenidiumTestnet"] = 4918] = "VenidiumTestnet";
    ChainId[ChainId["VenidiumMainnet"] = 4919] = "VenidiumMainnet";
    ChainId[ChainId["BlackFortExchangeNetwork"] = 4999] = "BlackFortExchangeNetwork";
    ChainId[ChainId["Mantle"] = 5000] = "Mantle";
    ChainId[ChainId["MantleTestnet"] = 5001] = "MantleTestnet";
    ChainId[ChainId["TreasurenetMainnetAlpha"] = 5002] = "TreasurenetMainnetAlpha";
    ChainId[ChainId["MantleSepoliaTestnet"] = 5003] = "MantleSepoliaTestnet";
    ChainId[ChainId["TreasurenetTestnet"] = 5005] = "TreasurenetTestnet";
    ChainId[ChainId["Bahamut"] = 5165] = "Bahamut";
    ChainId[ChainId["SmartLayerNetwork"] = 5169] = "SmartLayerNetwork";
    ChainId[ChainId["TLChainNetworkMainnet"] = 5177] = "TLChainNetworkMainnet";
    ChainId[ChainId["EraSwapMainnet"] = 5197] = "EraSwapMainnet";
    ChainId[ChainId["HumanodeMainnet"] = 5234] = "HumanodeMainnet";
    ChainId[ChainId["FirechainMainnetOld"] = 5290] = "FirechainMainnetOld";
    ChainId[ChainId["UzmiNetworkMainnet"] = 5315] = "UzmiNetworkMainnet";
    ChainId[ChainId["TritaniumTestnet"] = 5353] = "TritaniumTestnet";
    ChainId[ChainId["VEXEVMTESTNET"] = 5522] = "VEXEVMTESTNET";
    ChainId[ChainId["NahmiiMainnet"] = 5551] = "NahmiiMainnet";
    ChainId[ChainId["NahmiiTestnet"] = 5553] = "NahmiiTestnet";
    ChainId[ChainId["ChainVerseMainnet"] = 5555] = "ChainVerseMainnet";
    ChainId[ChainId["OpBNBTestnet"] = 5611] = "OpBNBTestnet";
    ChainId[ChainId["ArcturusChainTestnet"] = 5616] = "ArcturusChainTestnet";
    ChainId[ChainId["TanssiEVMContainerChain"] = 5678] = "TanssiEVMContainerChain";
    ChainId[ChainId["SyscoinTanenbaumTestnet"] = 5700] = "SyscoinTanenbaumTestnet";
    ChainId[ChainId["HikaNetworkTestnet"] = 5729] = "HikaNetworkTestnet";
    ChainId[ChainId["SatoshiChainTestnet"] = 5758] = "SatoshiChainTestnet";
    ChainId[ChainId["Ganache"] = 5777] = "Ganache";
    ChainId[ChainId["OntologyTestnet"] = 5851] = "OntologyTestnet";
    ChainId[ChainId["WegochainRubidiumMainnet"] = 5869] = "WegochainRubidiumMainnet";
    ChainId[ChainId["TresTestnet"] = 6065] = "TresTestnet";
    ChainId[ChainId["TresMainnet"] = 6066] = "TresMainnet";
    ChainId[ChainId["CascadiaTestnet"] = 6102] = "CascadiaTestnet";
    ChainId[ChainId["UPTNTestnet"] = 6118] = "UPTNTestnet";
    ChainId[ChainId["UPTN"] = 6119] = "UPTN";
    ChainId[ChainId["DigitSoulSmartChain"] = 6363] = "DigitSoulSmartChain";
    ChainId[ChainId["Peerpay"] = 6502] = "Peerpay";
    ChainId[ChainId["ScolcoinWeiChainTestnet"] = 6552] = "ScolcoinWeiChainTestnet";
    ChainId[ChainId["FoxTestnetNetwork"] = 6565] = "FoxTestnetNetwork";
    ChainId[ChainId["PixieChainMainnet"] = 6626] = "PixieChainMainnet";
    ChainId[ChainId["LatestChainTestnet"] = 6660] = "LatestChainTestnet";
    ChainId[ChainId["CybriaMainnet"] = 6661] = "CybriaMainnet";
    ChainId[ChainId["CybriaTestnet"] = 6666] = "CybriaTestnet";
    ChainId[ChainId["IRIShub"] = 6688] = "IRIShub";
    ChainId[ChainId["PAXBMainnet"] = 6701] = "PAXBMainnet";
    ChainId[ChainId["CompverseMainnet"] = 6779] = "CompverseMainnet";
    ChainId[ChainId["GoldSmartChainMainnet"] = 6789] = "GoldSmartChainMainnet";
    ChainId[ChainId["TombChainMainnet"] = 6969] = "TombChainMainnet";
    ChainId[ChainId["PolySmartChain"] = 6999] = "PolySmartChain";
    ChainId[ChainId["ZetaChainMainnet"] = 7000] = "ZetaChainMainnet";
    ChainId[ChainId["ZetaChainAthens3Testnet"] = 7001] = "ZetaChainAthens3Testnet";
    ChainId[ChainId["BSTChain"] = 7007] = "BSTChain";
    ChainId[ChainId["Ellatheheart"] = 7027] = "Ellatheheart";
    ChainId[ChainId["PlanqMainnet"] = 7070] = "PlanqMainnet";
    ChainId[ChainId["Nume"] = 7100] = "Nume";
    ChainId[ChainId["HelpTheHomeless"] = 7118] = "HelpTheHomeless";
    ChainId[ChainId["BitrockMainnet"] = 7171] = "BitrockMainnet";
    ChainId[ChainId["KLYNTAR"] = 7331] = "KLYNTAR";
    ChainId[ChainId["HorizenEONMainnet"] = 7332] = "HorizenEONMainnet";
    ChainId[ChainId["ShyftMainnet"] = 7341] = "ShyftMainnet";
    ChainId[ChainId["RabaNetworkMainnet"] = 7484] = "RabaNetworkMainnet";
    ChainId[ChainId["MEVerseChainMainnet"] = 7518] = "MEVerseChainMainnet";
    ChainId[ChainId["ADILTestnet"] = 7575] = "ADILTestnet";
    ChainId[ChainId["AdilChainV2Mainnet"] = 7576] = "AdilChainV2Mainnet";
    ChainId[ChainId["TheRootNetwork-Mainnet"] = 7668] = "TheRootNetwork-Mainnet";
    ChainId[ChainId["TheRootNetwork-PorciniTestnet"] = 7672] = "TheRootNetwork-PorciniTestnet";
    ChainId[ChainId["Canto"] = 7700] = "Canto";
    ChainId[ChainId["CantoTesnet"] = 7701] = "CantoTesnet";
    ChainId[ChainId["BitrockTestnet"] = 7771] = "BitrockTestnet";
    ChainId[ChainId["RiseoftheWarbotsTestnet"] = 7777] = "RiseoftheWarbotsTestnet";
    ChainId[ChainId["MaalChainTestnet"] = 7860] = "MaalChainTestnet";
    ChainId[ChainId["HazlorTestnet"] = 7878] = "HazlorTestnet";
    ChainId[ChainId["KintoMainnet"] = 7887] = "KintoMainnet";
    ChainId[ChainId["ARDENIUMAthena"] = 7895] = "ARDENIUMAthena";
    ChainId[ChainId["DOSChain"] = 7979] = "DOSChain";
    ChainId[ChainId["Teleport"] = 8000] = "Teleport";
    ChainId[ChainId["TeleportTestnet"] = 8001] = "TeleportTestnet";
    ChainId[ChainId["MDGLTestnet"] = 8029] = "MDGLTestnet";
    ChainId[ChainId["ShardeumLiberty1.X"] = 8080] = "ShardeumLiberty1.X";
    ChainId[ChainId["ShardeumLiberty2.X"] = 8081] = "ShardeumLiberty2.X";
    ChainId[ChainId["ShardeumSphinx1.X"] = 8082] = "ShardeumSphinx1.X";
    ChainId[ChainId["BitcoinChain"] = 8086] = "BitcoinChain";
    ChainId[ChainId["E-Dollar"] = 8087] = "E-Dollar";
    ChainId[ChainId["StreamuXBlockchain"] = 8098] = "StreamuXBlockchain";
    ChainId[ChainId["QitmeerNetworkTestnet"] = 8131] = "QitmeerNetworkTestnet";
    ChainId[ChainId["QitmeerNetworkMixnet"] = 8132] = "QitmeerNetworkMixnet";
    ChainId[ChainId["QitmeerNetworkPrivnet"] = 8133] = "QitmeerNetworkPrivnet";
    ChainId[ChainId["Amana"] = 8134] = "Amana";
    ChainId[ChainId["Flana"] = 8135] = "Flana";
    ChainId[ChainId["Mizana"] = 8136] = "Mizana";
    ChainId[ChainId["TestnetBeOneChain"] = 8181] = "TestnetBeOneChain";
    ChainId[ChainId["TorusMainnet"] = 8192] = "TorusMainnet";
    ChainId[ChainId["TorusTestnet"] = 8194] = "TorusTestnet";
    ChainId[ChainId["KlaytnMainnetCypress"] = 8217] = "KlaytnMainnetCypress";
    ChainId[ChainId["BlocktonBlockchain"] = 8272] = "BlocktonBlockchain";
    ChainId[ChainId["KorthoTest"] = 8285] = "KorthoTest";
    ChainId[ChainId["DraconesFinancialServices"] = 8387] = "DraconesFinancialServices";
    ChainId[ChainId["Base"] = 8453] = "Base";
    ChainId[ChainId["TokiNetwork"] = 8654] = "TokiNetwork";
    ChainId[ChainId["TokiTestnet"] = 8655] = "TokiTestnet";
    ChainId[ChainId["HelaOfficialRuntimeMainnet"] = 8668] = "HelaOfficialRuntimeMainnet";
    ChainId[ChainId["TOOLGlobalMainnet"] = 8723] = "TOOLGlobalMainnet";
    ChainId[ChainId["TOOLGlobalTestnet"] = 8724] = "TOOLGlobalTestnet";
    ChainId[ChainId["StoragechainMainnet"] = 8726] = "StoragechainMainnet";
    ChainId[ChainId["StoragechainTestnet"] = 8727] = "StoragechainTestnet";
    ChainId[ChainId["AlphNetwork"] = 8738] = "AlphNetwork";
    ChainId[ChainId["TMYChain"] = 8768] = "TMYChain";
    ChainId[ChainId["MAROBlockchainMainnet"] = 8848] = "MAROBlockchainMainnet";
    ChainId[ChainId["Unique"] = 8880] = "Unique";
    ChainId[ChainId["QuartzbyUnique"] = 8881] = "QuartzbyUnique";
    ChainId[ChainId["OpaltestnetbyUnique"] = 8882] = "OpaltestnetbyUnique";
    ChainId[ChainId["SapphirebyUnique"] = 8883] = "SapphirebyUnique";
    ChainId[ChainId["XANAChain"] = 8888] = "XANAChain";
    ChainId[ChainId["VyvoSmartChain"] = 8889] = "VyvoSmartChain";
    ChainId[ChainId["MammothMainnet"] = 8898] = "MammothMainnet";
    ChainId[ChainId["JIBCHAINL1"] = 8899] = "JIBCHAINL1";
    ChainId[ChainId["GiantMammothMainnet"] = 8989] = "GiantMammothMainnet";
    ChainId[ChainId["Bloxberg"] = 8995] = "Bloxberg";
    ChainId[ChainId["EvmosTestnet"] = 9000] = "EvmosTestnet";
    ChainId[ChainId["Evmos"] = 9001] = "Evmos";
    ChainId[ChainId["BerylBitMainnet"] = 9012] = "BerylBitMainnet";
    ChainId[ChainId["NexaBlock"] = 9024] = "NexaBlock";
    ChainId[ChainId["GenesisCoin"] = 9100] = "GenesisCoin";
    ChainId[ChainId["RiniaTestnetOld"] = 9170] = "RiniaTestnetOld";
    ChainId[ChainId["CodefinMainnet"] = 9223] = "CodefinMainnet";
    ChainId[ChainId["DogcoinTestnet"] = 9339] = "DogcoinTestnet";
    ChainId[ChainId["EvokeMainnet"] = 9395] = "EvokeMainnet";
    ChainId[ChainId["RangersProtocolTestnetRobin"] = 9527] = "RangersProtocolTestnetRobin";
    ChainId[ChainId["QEasyWeb3Testnet"] = 9528] = "QEasyWeb3Testnet";
    ChainId[ChainId["NeonlinkTestnet"] = 9559] = "NeonlinkTestnet";
    ChainId[ChainId["OortMainnetDev"] = 9700] = "OortMainnetDev";
    ChainId[ChainId["BobaBNBTestnet"] = 9728] = "BobaBNBTestnet";
    ChainId[ChainId["MainnetZTestnet"] = 9768] = "MainnetZTestnet";
    ChainId[ChainId["PepeNetworkMainnet"] = 9779] = "PepeNetworkMainnet";
    ChainId[ChainId["CarbonEVM"] = 9790] = "CarbonEVM";
    ChainId[ChainId["CarbonEVMTestnet"] = 9792] = "CarbonEVMTestnet";
    ChainId[ChainId["IMPERIUMTESTNET"] = 9818] = "IMPERIUMTESTNET";
    ChainId[ChainId["IMPERIUMMAINNET"] = 9819] = "IMPERIUMMAINNET";
    ChainId[ChainId["DogelayerMainnet"] = 9888] = "DogelayerMainnet";
    ChainId[ChainId["MindSmartChainTestnet"] = 9977] = "MindSmartChainTestnet";
    ChainId[ChainId["ComboMainnet"] = 9980] = "ComboMainnet";
    ChainId[ChainId["AgungNetwork"] = 9990] = "AgungNetwork";
    ChainId[ChainId["MindSmartChainMainnet"] = 9996] = "MindSmartChainMainnet";
    ChainId[ChainId["AltLayerTestnet"] = 9997] = "AltLayerTestnet";
    ChainId[ChainId["MyOwnTestnet"] = 9999] = "MyOwnTestnet";
    ChainId[ChainId["SmartBitcoinCash"] = 10000] = "SmartBitcoinCash";
    ChainId[ChainId["SmartBitcoinCashTestnet"] = 10001] = "SmartBitcoinCashTestnet";
    ChainId[ChainId["GonChain"] = 10024] = "GonChain";
    ChainId[ChainId["JapanOpenChainTestnet"] = 10081] = "JapanOpenChainTestnet";
    ChainId[ChainId["SJATSH"] = 10086] = "SJATSH";
    ChainId[ChainId["BlockchainGenesisMainnet"] = 10101] = "BlockchainGenesisMainnet";
    ChainId[ChainId["GnosisChiadoTestnet"] = 10200] = "GnosisChiadoTestnet";
    ChainId[ChainId["MaxxChainMainnet"] = 10201] = "MaxxChainMainnet";
    ChainId[ChainId["ArtheraMainnet"] = 10242] = "ArtheraMainnet";
    ChainId[ChainId["ArtheraTestnet"] = 10243] = "ArtheraTestnet";
    ChainId[ChainId["0XTade"] = 10248] = "0XTade";
    ChainId[ChainId["WorldlandTestnet"] = 10395] = "WorldlandTestnet";
    ChainId[ChainId["NumbersMainnet"] = 10507] = "NumbersMainnet";
    ChainId[ChainId["NumbersTestnet"] = 10508] = "NumbersTestnet";
    ChainId[ChainId["CryptoCoinPay"] = 10823] = "CryptoCoinPay";
    ChainId[ChainId["QuadransBlockchain"] = 10946] = "QuadransBlockchain";
    ChainId[ChainId["QuadransBlockchainTestnet"] = 10947] = "QuadransBlockchainTestnet";
    ChainId[ChainId["Astra"] = 11110] = "Astra";
    ChainId[ChainId["WAGMI"] = 11111] = "WAGMI";
    ChainId[ChainId["AstraTestnet"] = 11115] = "AstraTestnet";
    ChainId[ChainId["HashBitMainnet"] = 11119] = "HashBitMainnet";
    ChainId[ChainId["HaqqNetwork"] = 11235] = "HaqqNetwork";
    ChainId[ChainId["ShyftTestnet"] = 11437] = "ShyftTestnet";
    ChainId[ChainId["SardisTestnet"] = 11612] = "SardisTestnet";
    ChainId[ChainId["SanRChain"] = 11888] = "SanRChain";
    ChainId[ChainId["PolygonSupernetArianee"] = 11891] = "PolygonSupernetArianee";
    ChainId[ChainId["SatoshiChainMainnet"] = 12009] = "SatoshiChainMainnet";
    ChainId[ChainId["SingularityZEROTestnet"] = 12051] = "SingularityZEROTestnet";
    ChainId[ChainId["SingularityZEROMainnet"] = 12052] = "SingularityZEROMainnet";
    ChainId[ChainId["BRCChainMainnet"] = 12123] = "BRCChainMainnet";
    ChainId[ChainId["FibonacciMainnet"] = 12306] = "FibonacciMainnet";
    ChainId[ChainId["BLGTestnet"] = 12321] = "BLGTestnet";
    ChainId[ChainId["StepTestnet"] = 12345] = "StepTestnet";
    ChainId[ChainId["AstarzkEVM"] = 12611] = "AstarzkEVM";
    ChainId[ChainId["RikezaNetworkTestnet"] = 12715] = "RikezaNetworkTestnet";
    ChainId[ChainId["QuantumChainTestnet"] = 12890] = "QuantumChainTestnet";
    ChainId[ChainId["SPS"] = 13000] = "SPS";
    ChainId[ChainId["CreditSmartChain"] = 13308] = "CreditSmartChain";
    ChainId[ChainId["BeamTestnet"] = 13337] = "BeamTestnet";
    ChainId[ChainId["ImmutablezkEVM"] = 13371] = "ImmutablezkEVM";
    ChainId[ChainId["PhoenixMainnet"] = 13381] = "PhoenixMainnet";
    ChainId[ChainId["ImmutablezkEVMTestnet"] = 13473] = "ImmutablezkEVMTestnet";
    ChainId[ChainId["Susono"] = 13812] = "Susono";
    ChainId[ChainId["SPSTestnet"] = 14000] = "SPSTestnet";
    ChainId[ChainId["HumanodeTestnet5Israfel"] = 14853] = "HumanodeTestnet5Israfel";
    ChainId[ChainId["ImmutablezkEVMDevnet"] = 15003] = "ImmutablezkEVMDevnet";
    ChainId[ChainId["LoopNetworkMainnet"] = 15551] = "LoopNetworkMainnet";
    ChainId[ChainId["TrustEVMTestnet"] = 15555] = "TrustEVMTestnet";
    ChainId[ChainId["EOSEVMNetworkTestnet"] = 15557] = "EOSEVMNetworkTestnet";
    ChainId[ChainId["MetaDotMainnet"] = 16000] = "MetaDotMainnet";
    ChainId[ChainId["MetaDotTestnet"] = 16001] = "MetaDotTestnet";
    ChainId[ChainId["GenesysMainnet"] = 16507] = "GenesysMainnet";
    ChainId[ChainId["IRIShubTestnet"] = 16688] = "IRIShubTestnet";
    ChainId[ChainId["AirDAOMainnet"] = 16718] = "AirDAOMainnet";
    ChainId[ChainId["IVARChainTestnet"] = 16888] = "IVARChainTestnet";
    ChainId[ChainId["Holesky"] = 17000] = "Holesky";
    ChainId[ChainId["RedstoneHoleskyTestnet"] = 17001] = "RedstoneHoleskyTestnet";
    ChainId[ChainId["G8ChainMainnet"] = 17171] = "G8ChainMainnet";
    ChainId[ChainId["EclipseSubnet"] = 17172] = "EclipseSubnet";
    ChainId[ChainId["PaletteChainTestnet"] = 17180] = "PaletteChainTestnet";
    ChainId[ChainId["EOSEVMNetwork"] = 17777] = "EOSEVMNetwork";
    ChainId[ChainId["FrontierofDreamsTestnet"] = 18000] = "FrontierofDreamsTestnet";
    ChainId[ChainId["SmartTradeNetworks"] = 18122] = "SmartTradeNetworks";
    ChainId[ChainId["ProofOfMemes"] = 18159] = "ProofOfMemes";
    ChainId[ChainId["G8ChainTestnet"] = 18181] = "G8ChainTestnet";
    ChainId[ChainId["MXCzkEVMMainnet"] = 18686] = "MXCzkEVMMainnet";
    ChainId[ChainId["HOMEVerseMainnet"] = 19011] = "HOMEVerseMainnet";
    ChainId[ChainId["MagnetNetwork"] = 19527] = "MagnetNetwork";
    ChainId[ChainId["BTCIXNetwork"] = 19845] = "BTCIXNetwork";
    ChainId[ChainId["CamelarkMainnet"] = 20001] = "CamelarkMainnet";
    ChainId[ChainId["CallistoTestnet"] = 20729] = "CallistoTestnet";
    ChainId[ChainId["P12Chain"] = 20736] = "P12Chain";
    ChainId[ChainId["Jono11Subnet"] = 20765] = "Jono11Subnet";
    ChainId[ChainId["CENNZnetAzalea"] = 21337] = "CENNZnetAzalea";
    ChainId[ChainId["OmChainMainnet"] = 21816] = "OmChainMainnet";
    ChainId[ChainId["BSLMainnet"] = 21912] = "BSLMainnet";
    ChainId[ChainId["Taycan"] = 22023] = "Taycan";
    ChainId[ChainId["AirDAOTestnet"] = 22040] = "AirDAOTestnet";
    ChainId[ChainId["NautilusMainnet"] = 22222] = "NautilusMainnet";
    ChainId[ChainId["GoldXChainTestnet"] = 22324] = "GoldXChainTestnet";
    ChainId[ChainId["MAPMainnet"] = 22776] = "MAPMainnet";
    ChainId[ChainId["AntofyTestnet"] = 23006] = "AntofyTestnet";
    ChainId[ChainId["OpsideTestnet"] = 23118] = "OpsideTestnet";
    ChainId[ChainId["OasisSapphire"] = 23294] = "OasisSapphire";
    ChainId[ChainId["OasisSapphireTestnet"] = 23295] = "OasisSapphireTestnet";
    ChainId[ChainId["BlastTestnet"] = 23888] = "BlastTestnet";
    ChainId[ChainId["Webchain"] = 24484] = "Webchain";
    ChainId[ChainId["MintMe.comCoin"] = 24734] = "MintMe.comCoin";
    ChainId[ChainId["LiquidLayerMainnet"] = 25186] = "LiquidLayerMainnet";
    ChainId[ChainId["HammerChainMainnet"] = 25888] = "HammerChainMainnet";
    ChainId[ChainId["BitkubChainTestnet"] = 25925] = "BitkubChainTestnet";
    ChainId[ChainId["FerrumTestnet"] = 26026] = "FerrumTestnet";
    ChainId[ChainId["HertzNetworkMainnet"] = 26600] = "HertzNetworkMainnet";
    ChainId[ChainId["OasisChainMainnet"] = 26863] = "OasisChainMainnet";
    ChainId[ChainId["OptimismBedrock(GoerliAlphaTestnet)"] = 28528] = "OptimismBedrock(GoerliAlphaTestnet)";
    ChainId[ChainId["MCHVerseMainnet"] = 29548] = "MCHVerseMainnet";
    ChainId[ChainId["Piecetestnet"] = 30067] = "Piecetestnet";
    ChainId[ChainId["CeriumTestnet"] = 30103] = "CeriumTestnet";
    ChainId[ChainId["EthersocialNetwork"] = 31102] = "EthersocialNetwork";
    ChainId[ChainId["CloudTxMainnet"] = 31223] = "CloudTxMainnet";
    ChainId[ChainId["CloudTxTestnet"] = 31224] = "CloudTxTestnet";
    ChainId[ChainId["GoChainTestnet"] = 31337] = "GoChainTestnet";
    ChainId[ChainId["EvokeTestnet"] = 31414] = "EvokeTestnet";
    ChainId[ChainId["Filecoin-Wallabytestnet"] = 31415] = "Filecoin-Wallabytestnet";
    ChainId[ChainId["W3GamezHoleskyTestnet"] = 32001] = "W3GamezHoleskyTestnet";
    ChainId[ChainId["BitgertMainnet"] = 32520] = "BitgertMainnet";
    ChainId[ChainId["FusionMainnet"] = 32659] = "FusionMainnet";
    ChainId[ChainId["ZilliqaEVM"] = 32769] = "ZilliqaEVM";
    ChainId[ChainId["ZilliqaEVMIsolatedServer"] = 32990] = "ZilliqaEVMIsolatedServer";
    ChainId[ChainId["ZilliqaEVMTestnet"] = 33101] = "ZilliqaEVMTestnet";
    ChainId[ChainId["CloudverseSubnet"] = 33210] = "CloudverseSubnet";
    ChainId[ChainId["AvesMainnet"] = 33333] = "AvesMainnet";
    ChainId[ChainId["ZilliqaEVMDevnet"] = 33385] = "ZilliqaEVMDevnet";
    ChainId[ChainId["Zilliqa2EVMDevnet"] = 33469] = "Zilliqa2EVMDevnet";
    ChainId[ChainId["Mode"] = 34443] = "Mode";
    ChainId[ChainId["J2OTaro"] = 35011] = "J2OTaro";
    ChainId[ChainId["QMainnet"] = 35441] = "QMainnet";
    ChainId[ChainId["QTestnet"] = 35443] = "QTestnet";
    ChainId[ChainId["ConnectorManager"] = 38400] = "ConnectorManager";
    ChainId[ChainId["ConnectorManagerRobin"] = 38401] = "ConnectorManagerRobin";
    ChainId[ChainId["EnergiMainnet"] = 39797] = "EnergiMainnet";
    ChainId[ChainId["OHOMainnet"] = 39815] = "OHOMainnet";
    ChainId[ChainId["Opulent-XBETA"] = 41500] = "Opulent-XBETA";
    ChainId[ChainId["Pegglecoin"] = 42069] = "Pegglecoin";
    ChainId[ChainId["ArbitrumOne"] = 42161] = "ArbitrumOne";
    ChainId[ChainId["ArbitrumNova"] = 42170] = "ArbitrumNova";
    ChainId[ChainId["CeloMainnet"] = 42220] = "CeloMainnet";
    ChainId[ChainId["OasisEmeraldTestnet"] = 42261] = "OasisEmeraldTestnet";
    ChainId[ChainId["OasisEmerald"] = 42262] = "OasisEmerald";
    ChainId[ChainId["GoldXChainMainnet"] = 42355] = "GoldXChainMainnet";
    ChainId[ChainId["ZKFairMainnet"] = 42766] = "ZKFairMainnet";
    ChainId[ChainId["GesotenVerseTestnet"] = 42801] = "GesotenVerseTestnet";
    ChainId[ChainId["KintoTestnet"] = 42888] = "KintoTestnet";
    ChainId[ChainId["Athereum"] = 43110] = "Athereum";
    ChainId[ChainId["AvalancheFujiTestnet"] = 43113] = "AvalancheFujiTestnet";
    ChainId[ChainId["AvalancheC-Chain"] = 43114] = "AvalancheC-Chain";
    ChainId[ChainId["BobaAvax"] = 43288] = "BobaAvax";
    ChainId[ChainId["ZKFairTestnet"] = 43851] = "ZKFairTestnet";
    ChainId[ChainId["Frenchain"] = 44444] = "Frenchain";
    ChainId[ChainId["CeloAlfajoresTestnet"] = 44787] = "CeloAlfajoresTestnet";
    ChainId[ChainId["AutobahnNetwork"] = 45000] = "AutobahnNetwork";
    ChainId[ChainId["DeelanceMainnet"] = 45510] = "DeelanceMainnet";
    ChainId[ChainId["FusionTestnet"] = 46688] = "FusionTestnet";
    ChainId[ChainId["REINetwork"] = 47805] = "REINetwork";
    ChainId[ChainId["WireshapeFloripaTestnet"] = 49049] = "WireshapeFloripaTestnet";
    ChainId[ChainId["BifrostTestnet"] = 49088] = "BifrostTestnet";
    ChainId[ChainId["EnergiTestnet"] = 49797] = "EnergiTestnet";
    ChainId[ChainId["LiveplexOracleEVM"] = 50001] = "LiveplexOracleEVM";
    ChainId[ChainId["YooldoVerseMainnet"] = 50005] = "YooldoVerseMainnet";
    ChainId[ChainId["YooldoVerseTestnet"] = 50006] = "YooldoVerseTestnet";
    ChainId[ChainId["GTONTestnet"] = 50021] = "GTONTestnet";
    ChainId[ChainId["LumozTestnetAlpha"] = 51178] = "LumozTestnetAlpha";
    ChainId[ChainId["SardisMainnet"] = 51712] = "SardisMainnet";
    ChainId[ChainId["ElectroneumMainnet"] = 52014] = "ElectroneumMainnet";
    ChainId[ChainId["DFKChain"] = 53935] = "DFKChain";
    ChainId[ChainId["HaqqChainTestnet"] = 54211] = "HaqqChainTestnet";
    ChainId[ChainId["ToronetTestnet"] = 54321] = "ToronetTestnet";
    ChainId[ChainId["Titan"] = 55004] = "Titan";
    ChainId[ChainId["REIChainMainnet"] = 55555] = "REIChainMainnet";
    ChainId[ChainId["REIChainTestnet"] = 55556] = "REIChainTestnet";
    ChainId[ChainId["BobaBNBMainnet"] = 56288] = "BobaBNBMainnet";
    ChainId[ChainId["VELOLabsMainnet"] = 56789] = "VELOLabsMainnet";
    ChainId[ChainId["RolluxTestnet"] = 57000] = "RolluxTestnet";
    ChainId[ChainId["SepoliaPGN(PublicGoodsNetwork)"] = 58008] = "SepoliaPGN(PublicGoodsNetwork)";
    ChainId[ChainId["LineaTestnet"] = 59140] = "LineaTestnet";
    ChainId[ChainId["Linea"] = 59144] = "Linea";
    ChainId[ChainId["GenesysCodeMainnet"] = 59971] = "GenesysCodeMainnet";
    ChainId[ChainId["ThinkiumTestnetChain0"] = 60000] = "ThinkiumTestnetChain0";
    ChainId[ChainId["ThinkiumTestnetChain1"] = 60001] = "ThinkiumTestnetChain1";
    ChainId[ChainId["ThinkiumTestnetChain2"] = 60002] = "ThinkiumTestnetChain2";
    ChainId[ChainId["ThinkiumTestnetChain103"] = 60103] = "ThinkiumTestnetChain103";
    ChainId[ChainId["AxelChainDev-Net"] = 61800] = "AxelChainDev-Net";
    ChainId[ChainId["EticaMainnet"] = 61803] = "EticaMainnet";
    ChainId[ChainId["DoKENSuperChainMainnet"] = 61916] = "DoKENSuperChainMainnet";
    ChainId[ChainId["CeloBaklavaTestnet"] = 62320] = "CeloBaklavaTestnet";
    ChainId[ChainId["MultiVACMainnet"] = 62621] = "MultiVACMainnet";
    ChainId[ChainId["ECreditsMainnet"] = 63000] = "ECreditsMainnet";
    ChainId[ChainId["ECreditsTestnet"] = 63001] = "ECreditsTestnet";
    ChainId[ChainId["ScolcoinMainnet"] = 65450] = "ScolcoinMainnet";
    ChainId[ChainId["JanusTestnet"] = 66988] = "JanusTestnet";
    ChainId[ChainId["SiriusNet"] = 67390] = "SiriusNet";
    ChainId[ChainId["CosmicChain"] = 67588] = "CosmicChain";
    ChainId[ChainId["DM2VerseMainnet"] = 68770] = "DM2VerseMainnet";
    ChainId[ChainId["Condrieu"] = 69420] = "Condrieu";
    ChainId[ChainId["ThinkiumMainnetChain0"] = 70000] = "ThinkiumMainnetChain0";
    ChainId[ChainId["ThinkiumMainnetChain1"] = 70001] = "ThinkiumMainnetChain1";
    ChainId[ChainId["ThinkiumMainnetChain2"] = 70002] = "ThinkiumMainnetChain2";
    ChainId[ChainId["ThinkiumMainnetChain103"] = 70103] = "ThinkiumMainnetChain103";
    ChainId[ChainId["GuapcoinX"] = 71111] = "GuapcoinX";
    ChainId[ChainId["PolyjuiceTestnet"] = 71393] = "PolyjuiceTestnet";
    ChainId[ChainId["GodwokenTestnetv1"] = 71401] = "GodwokenTestnetv1";
    ChainId[ChainId["GodwokenMainnet"] = 71402] = "GodwokenMainnet";
    ChainId[ChainId["GrokChainMainnet"] = 72992] = "GrokChainMainnet";
    ChainId[ChainId["EnergyWebVoltaTestnet"] = 73799] = "EnergyWebVoltaTestnet";
    ChainId[ChainId["MixinVirtualMachine"] = 73927] = "MixinVirtualMachine";
    ChainId[ChainId["ResinCoinMainnet"] = 75000] = "ResinCoinMainnet";
    ChainId[ChainId["FoundryChainTestnet"] = 77238] = "FoundryChainTestnet";
    ChainId[ChainId["VentionSmartChainMainnet"] = 77612] = "VentionSmartChainMainnet";
    ChainId[ChainId["ToronetMainnet"] = 77777] = "ToronetMainnet";
    ChainId[ChainId["Firenzetestnetwork"] = 78110] = "Firenzetestnetwork";
    ChainId[ChainId["DragonflyMainnet(Hexapod)"] = 78281] = "DragonflyMainnet(Hexapod)";
    ChainId[ChainId["AmplifySubnet"] = 78430] = "AmplifySubnet";
    ChainId[ChainId["BulletinSubnet"] = 78431] = "BulletinSubnet";
    ChainId[ChainId["ConduitSubnet"] = 78432] = "ConduitSubnet";
    ChainId[ChainId["GoldSmartChainTestnet"] = 79879] = "GoldSmartChainTestnet";
    ChainId[ChainId["Mumbai"] = 80001] = "Mumbai";
    ChainId[ChainId["BerachainArtio"] = 80085] = "BerachainArtio";
    ChainId[ChainId["NordekMainnet"] = 81041] = "NordekMainnet";
    ChainId[ChainId["AmanaTestnet"] = 81341] = "AmanaTestnet";
    ChainId[ChainId["AmanaMixnet"] = 81342] = "AmanaMixnet";
    ChainId[ChainId["AmanaPrivnet"] = 81343] = "AmanaPrivnet";
    ChainId[ChainId["FlanaTestnet"] = 81351] = "FlanaTestnet";
    ChainId[ChainId["FlanaMixnet"] = 81352] = "FlanaMixnet";
    ChainId[ChainId["FlanaPrivnet"] = 81353] = "FlanaPrivnet";
    ChainId[ChainId["MizanaTestnet"] = 81361] = "MizanaTestnet";
    ChainId[ChainId["MizanaMixnet"] = 81362] = "MizanaMixnet";
    ChainId[ChainId["MizanaPrivnet"] = 81363] = "MizanaPrivnet";
    ChainId[ChainId["QuantumChainMainnet"] = 81720] = "QuantumChainMainnet";
    ChainId[ChainId["SmartLayerNetworkTestnet"] = 82459] = "SmartLayerNetworkTestnet";
    ChainId[ChainId["BaseGoerliTestnet"] = 84531] = "BaseGoerliTestnet";
    ChainId[ChainId["BaseSepoliaTestnet"] = 84532] = "BaseSepoliaTestnet";
    ChainId[ChainId["AerieNetwork"] = 84886] = "AerieNetwork";
    ChainId[ChainId["CYBERTRUST"] = 85449] = "CYBERTRUST";
    ChainId[ChainId["NautilusProteusTestnet"] = 88002] = "NautilusProteusTestnet";
    ChainId[ChainId["ChilizScovilleTestnet"] = 88880] = "ChilizScovilleTestnet";
    ChainId[ChainId["IVARChainMainnet"] = 88888] = "IVARChainMainnet";
    ChainId[ChainId["BeverlyHills"] = 90210] = "BeverlyHills";
    ChainId[ChainId["NautilusTritionChain"] = 91002] = "NautilusTritionChain";
    ChainId[ChainId["ComboTestnet"] = 91715] = "ComboTestnet";
    ChainId[ChainId["LambdaTestnet"] = 92001] = "LambdaTestnet";
    ChainId[ChainId["LiquidLayerTestnet"] = 93572] = "LiquidLayerTestnet";
    ChainId[ChainId["MantisTestnet(Hexapod)"] = 96970] = "MantisTestnet(Hexapod)";
    ChainId[ChainId["BobaBNBMainnetOld"] = 97288] = "BobaBNBMainnetOld";
    ChainId[ChainId["ELibertyTestnet"] = 99099] = "ELibertyTestnet";
    ChainId[ChainId["UBSmartChain(testnet)"] = 99998] = "UBSmartChain(testnet)";
    ChainId[ChainId["UBSmartChain"] = 99999] = "UBSmartChain";
    ChainId[ChainId["QuarkChainMainnetRoot"] = 100000] = "QuarkChainMainnetRoot";
    ChainId[ChainId["QuarkChainMainnetShard0"] = 100001] = "QuarkChainMainnetShard0";
    ChainId[ChainId["QuarkChainMainnetShard1"] = 100002] = "QuarkChainMainnetShard1";
    ChainId[ChainId["QuarkChainMainnetShard2"] = 100003] = "QuarkChainMainnetShard2";
    ChainId[ChainId["QuarkChainMainnetShard3"] = 100004] = "QuarkChainMainnetShard3";
    ChainId[ChainId["QuarkChainMainnetShard4"] = 100005] = "QuarkChainMainnetShard4";
    ChainId[ChainId["QuarkChainMainnetShard5"] = 100006] = "QuarkChainMainnetShard5";
    ChainId[ChainId["QuarkChainMainnetShard6"] = 100007] = "QuarkChainMainnetShard6";
    ChainId[ChainId["QuarkChainMainnetShard7"] = 100008] = "QuarkChainMainnetShard7";
    ChainId[ChainId["VeChain"] = 100009] = "VeChain";
    ChainId[ChainId["VeChainTestnet"] = 100010] = "VeChainTestnet";
    ChainId[ChainId["DeprecatedCHI"] = 100100] = "DeprecatedCHI";
    ChainId[ChainId["SoverunTestnet"] = 101010] = "SoverunTestnet";
    ChainId[ChainId["Crystaleum"] = 103090] = "Crystaleum";
    ChainId[ChainId["BROChainMainnet"] = 108801] = "BROChainMainnet";
    ChainId[ChainId["QuarkChainDevnetRoot"] = 110000] = "QuarkChainDevnetRoot";
    ChainId[ChainId["QuarkChainDevnetShard0"] = 110001] = "QuarkChainDevnetShard0";
    ChainId[ChainId["QuarkChainDevnetShard1"] = 110002] = "QuarkChainDevnetShard1";
    ChainId[ChainId["QuarkChainDevnetShard2"] = 110003] = "QuarkChainDevnetShard2";
    ChainId[ChainId["QuarkChainDevnetShard3"] = 110004] = "QuarkChainDevnetShard3";
    ChainId[ChainId["QuarkChainDevnetShard4"] = 110005] = "QuarkChainDevnetShard4";
    ChainId[ChainId["QuarkChainDevnetShard5"] = 110006] = "QuarkChainDevnetShard5";
    ChainId[ChainId["QuarkChainDevnetShard6"] = 110007] = "QuarkChainDevnetShard6";
    ChainId[ChainId["QuarkChainDevnetShard7"] = 110008] = "QuarkChainDevnetShard7";
    ChainId[ChainId["SiberiumTestNetwork"] = 111000] = "SiberiumTestNetwork";
    ChainId[ChainId["SiberiumNetwork"] = 111111] = "SiberiumNetwork";
    ChainId[ChainId["MetachainOneMainnet"] = 112358] = "MetachainOneMainnet";
    ChainId[ChainId["ADILDevnet"] = 123456] = "ADILDevnet";
    ChainId[ChainId["EtherlinkTestnet"] = 128123] = "EtherlinkTestnet";
    ChainId[ChainId["ETNDChainMainnets"] = 131419] = "ETNDChainMainnets";
    ChainId[ChainId["ICPlazaMainnet"] = 142857] = "ICPlazaMainnet";
    ChainId[ChainId["Taiko(Alpha-2Testnet)"] = 167004] = "Taiko(Alpha-2Testnet)";
    ChainId[ChainId["TaikoGrimsvotnL2"] = 167005] = "TaikoGrimsvotnL2";
    ChainId[ChainId["TaikoEldfellL3"] = 167006] = "TaikoEldfellL3";
    ChainId[ChainId["TaikoJolnirL2"] = 167007] = "TaikoJolnirL2";
    ChainId[ChainId["TaikoKatlaL2"] = 167008] = "TaikoKatlaL2";
    ChainId[ChainId["BiticaChainMainnet"] = 188710] = "BiticaChainMainnet";
    ChainId[ChainId["CondorTestNetwork"] = 188881] = "CondorTestNetwork";
    ChainId[ChainId["MilkomedaC1Testnet"] = 200101] = "MilkomedaC1Testnet";
    ChainId[ChainId["MilkomedaA1Testnet"] = 200202] = "MilkomedaA1Testnet";
    ChainId[ChainId["Akroma"] = 200625] = "Akroma";
    ChainId[ChainId["AlayaMainnet"] = 201018] = "AlayaMainnet";
    ChainId[ChainId["AlayaDevTestnet"] = 201030] = "AlayaDevTestnet";
    ChainId[ChainId["MythicalChain"] = 201804] = "MythicalChain";
    ChainId[ChainId["DecimalSmartChainTestnet"] = 202020] = "DecimalSmartChainTestnet";
    ChainId[ChainId["X1Devnet"] = 202212] = "X1Devnet";
    ChainId[ChainId["Jellie"] = 202624] = "Jellie";
    ChainId[ChainId["X1Network"] = 204005] = "X1Network";
    ChainId[ChainId["PlatONMainnet"] = 210425] = "PlatONMainnet";
    ChainId[ChainId["MasMainnet"] = 220315] = "MasMainnet";
    ChainId[ChainId["ReapchainMainnet"] = 221230] = "ReapchainMainnet";
    ChainId[ChainId["ReapchainTestnet"] = 221231] = "ReapchainTestnet";
    ChainId[ChainId["TafECOChainMainnet"] = 224168] = "TafECOChainMainnet";
    ChainId[ChainId["CONETSeboliaTestnet"] = 224422] = "CONETSeboliaTestnet";
    ChainId[ChainId["CONETHolesky"] = 224433] = "CONETHolesky";
    ChainId[ChainId["HashKeyChainTestnet"] = 230315] = "HashKeyChainTestnet";
    ChainId[ChainId["HaymoTestnet"] = 234666] = "HaymoTestnet";
    ChainId[ChainId["ARTISsigma1"] = 246529] = "ARTISsigma1";
    ChainId[ChainId["ARTISTestnettau1"] = 246785] = "ARTISTestnettau1";
    ChainId[ChainId["SaakuruTestnet"] = 247253] = "SaakuruTestnet";
    ChainId[ChainId["CMP-Mainnet"] = 256256] = "CMP-Mainnet";
    ChainId[ChainId["GearZeroNetworkTestnet"] = 266256] = "GearZeroNetworkTestnet";
    ChainId[ChainId["EgonCoinTestnet"] = 271271] = "EgonCoinTestnet";
    ChainId[ChainId["SocialSmartChainMainnet"] = 281121] = "SocialSmartChainMainnet";
    ChainId[ChainId["Filecoin-Calibrationtestnet"] = 314159] = "Filecoin-Calibrationtestnet";
    ChainId[ChainId["TTcoinSmartChainMainnet"] = 330844] = "TTcoinSmartChainMainnet";
    ChainId[ChainId["AvesTestnet"] = 333331] = "AvesTestnet";
    ChainId[ChainId["Nativ3Testnet"] = 333333] = "Nativ3Testnet";
    ChainId[ChainId["OoneChainTestnet"] = 333666] = "OoneChainTestnet";
    ChainId[ChainId["OoneChainDevnet"] = 333777] = "OoneChainDevnet";
    ChainId[ChainId["PolisTestnet"] = 333888] = "PolisTestnet";
    ChainId[ChainId["PolisMainnet"] = 333999] = "PolisMainnet";
    ChainId[ChainId["BitfinityNetworkTestnet"] = 355113] = "BitfinityNetworkTestnet";
    ChainId[ChainId["DigitSoulSmartChain2"] = 363636] = "DigitSoulSmartChain2";
    ChainId[ChainId["HAPchainTestnet"] = 373737] = "HAPchainTestnet";
    ChainId[ChainId["MetalC-Chain"] = 381931] = "MetalC-Chain";
    ChainId[ChainId["MetalTahoeC-Chain"] = 381932] = "MetalTahoeC-Chain";
    ChainId[ChainId["TipboxcoinMainnet"] = 404040] = "TipboxcoinMainnet";
    ChainId[ChainId["Kekchain"] = 420420] = "Kekchain";
    ChainId[ChainId["Kekchain(kektest)"] = 420666] = "Kekchain(kektest)";
    ChainId[ChainId["AlteriumL2Testnet"] = 420692] = "AlteriumL2Testnet";
    ChainId[ChainId["ArbitrumRinkeby"] = 421611] = "ArbitrumRinkeby";
    ChainId[ChainId["ArbitrumGoerli"] = 421613] = "ArbitrumGoerli";
    ChainId[ChainId["ArbitrumSepolia"] = 421614] = "ArbitrumSepolia";
    ChainId[ChainId["FastexChaintestnet"] = 424242] = "FastexChaintestnet";
    ChainId[ChainId["MarkrGo"] = 431140] = "MarkrGo";
    ChainId[ChainId["DexalotSubnetTestnet"] = 432201] = "DexalotSubnetTestnet";
    ChainId[ChainId["DexalotSubnet"] = 432204] = "DexalotSubnet";
    ChainId[ChainId["WeelinkTestnet"] = 444900] = "WeelinkTestnet";
    ChainId[ChainId["PatexSepoliaTestnet"] = 471100] = "PatexSepoliaTestnet";
    ChainId[ChainId["UltraProMainnet"] = 473861] = "UltraProMainnet";
    ChainId[ChainId["OpenChainMainnet"] = 474142] = "OpenChainMainnet";
    ChainId[ChainId["CMP-Testnet"] = 512512] = "CMP-Testnet";
    ChainId[ChainId["EthereumFair"] = 513100] = "EthereumFair";
    ChainId[ChainId["ScrollSepoliaTestnet"] = 534351] = "ScrollSepoliaTestnet";
    ChainId[ChainId["Scroll"] = 534352] = "Scroll";
    ChainId[ChainId["ScrollAlphaTestnet"] = 534353] = "ScrollAlphaTestnet";
    ChainId[ChainId["ScrollPre-AlphaTestnet"] = 534354] = "ScrollPre-AlphaTestnet";
    ChainId[ChainId["ShinariumBeta"] = 534849] = "ShinariumBeta";
    ChainId[ChainId["BeanEcoSmartChain"] = 535037] = "BeanEcoSmartChain";
    ChainId[ChainId["HypraMainnet"] = 622277] = "HypraMainnet";
    ChainId[ChainId["BearNetworkChainMainnet"] = 641230] = "BearNetworkChainMainnet";
    ChainId[ChainId["ALLMainnet"] = 651940] = "ALLMainnet";
    ChainId[ChainId["Vision-VpioneerTestChain"] = 666666] = "Vision-VpioneerTestChain";
    ChainId[ChainId["HelaOfficialRuntimeTestnet"] = 666888] = "HelaOfficialRuntimeTestnet";
    ChainId[ChainId["BearNetworkChainTestnet"] = 751230] = "BearNetworkChainTestnet";
    ChainId[ChainId["MiexsSmartchain"] = 761412] = "MiexsSmartchain";
    ChainId[ChainId["Modularium"] = 776877] = "Modularium";
    ChainId[ChainId["OctaSpace"] = 800001] = "OctaSpace";
    ChainId[ChainId["CURVEMainnet"] = 827431] = "CURVEMainnet";
    ChainId[ChainId["4GoodNetwork"] = 846000] = "4GoodNetwork";
    ChainId[ChainId["Dodao"] = 855456] = "Dodao";
    ChainId[ChainId["BlocXMainnet"] = 879151] = "BlocXMainnet";
    ChainId[ChainId["Vision-Mainnet"] = 888888] = "Vision-Mainnet";
    ChainId[ChainId["PosichainMainnetShard0"] = 900000] = "PosichainMainnetShard0";
    ChainId[ChainId["PosichainTestnetShard0"] = 910000] = "PosichainTestnetShard0";
    ChainId[ChainId["AstriaEVMDusknet"] = 912559] = "AstriaEVMDusknet";
    ChainId[ChainId["PosichainDevnetShard0"] = 920000] = "PosichainDevnetShard0";
    ChainId[ChainId["PosichainDevnetShard1"] = 920001] = "PosichainDevnetShard1";
    ChainId[ChainId["FNCYTestnet"] = 923018] = "FNCYTestnet";
    ChainId[ChainId["Jono12Subnet"] = 955081] = "Jono12Subnet";
    ChainId[ChainId["EluvioContentFabric"] = 955305] = "EluvioContentFabric";
    ChainId[ChainId["EcroxChainMainnet"] = 988207] = "EcroxChainMainnet";
    ChainId[ChainId["TiltyardSubnet"] = 1127469] = "TiltyardSubnet";
    ChainId[ChainId["ZKatana"] = 1261120] = "ZKatana";
    ChainId[ChainId["EthoProtocol"] = 1313114] = "EthoProtocol";
    ChainId[ChainId["Xerom"] = 1313500] = "Xerom";
    ChainId[ChainId["Kintsugi"] = 1337702] = "Kintsugi";
    ChainId[ChainId["Kiln"] = 1337802] = "Kiln";
    ChainId[ChainId["Zhejiang"] = 1337803] = "Zhejiang";
    ChainId[ChainId["TurkeyDemoDev"] = 1731313] = "TurkeyDemoDev";
    ChainId[ChainId["DeBankTestnet"] = 2021398] = "DeBankTestnet";
    ChainId[ChainId["PlianMainnetMain"] = 2099156] = "PlianMainnetMain";
    ChainId[ChainId["PlatONDevTestnetDeprecated"] = 2203181] = "PlatONDevTestnetDeprecated";
    ChainId[ChainId["PlatONDevTestnet2"] = 2206132] = "PlatONDevTestnet2";
    ChainId[ChainId["DPUChain"] = 2611555] = "DPUChain";
    ChainId[ChainId["Filecoin-Butterflytestnet"] = 3141592] = "Filecoin-Butterflytestnet";
    ChainId[ChainId["MantaPacificTestnet"] = 3441005] = "MantaPacificTestnet";
    ChainId[ChainId["AltLayerZeroGasNetwork"] = 4000003] = "AltLayerZeroGasNetwork";
    ChainId[ChainId["WorldsCaldera"] = 4281033] = "WorldsCaldera";
    ChainId[ChainId["MXCWannseezkEVMTestnet"] = 5167003] = "MXCWannseezkEVMTestnet";
    ChainId[ChainId["ElectroneumTestnet"] = 5201420] = "ElectroneumTestnet";
    ChainId[ChainId["ImversedMainnet"] = 5555555] = "ImversedMainnet";
    ChainId[ChainId["ImversedTestnet"] = 5555558] = "ImversedTestnet";
    ChainId[ChainId["SaakuruMainnet"] = 7225878] = "SaakuruMainnet";
    ChainId[ChainId["OpenVessel"] = 7355310] = "OpenVessel";
    ChainId[ChainId["QL1Testnet"] = 7668378] = "QL1Testnet";
    ChainId[ChainId["Musicoin"] = 7762959] = "Musicoin";
    ChainId[ChainId["Zora"] = 7777777] = "Zora";
    ChainId[ChainId["PlianMainnetSubchain1"] = 8007736] = "PlianMainnetSubchain1";
    ChainId[ChainId["Hokum"] = 8080808] = "Hokum";
    ChainId[ChainId["HAPchain"] = 8794598] = "HAPchain";
    ChainId[ChainId["QuarixTestnet"] = 8888881] = "QuarixTestnet";
    ChainId[ChainId["Quarix"] = 8888888] = "Quarix";
    ChainId[ChainId["XCAP"] = 9322252] = "XCAP";
    ChainId[ChainId["Milvine"] = 9322253] = "Milvine";
    ChainId[ChainId["PlianTestnetSubchain1"] = 10067275] = "PlianTestnetSubchain1";
    ChainId[ChainId["SoverunMainnet"] = 10101010] = "SoverunMainnet";
    ChainId[ChainId["Sepolia"] = 11155111] = "Sepolia";
    ChainId[ChainId["OPSepoliaTestnet"] = 11155420] = "OPSepoliaTestnet";
    ChainId[ChainId["PepChainChurchill"] = 13371337] = "PepChainChurchill";
    ChainId[ChainId["AnduschainMainnet"] = 14288640] = "AnduschainMainnet";
    ChainId[ChainId["PlianTestnetMain"] = 16658437] = "PlianTestnetMain";
    ChainId[ChainId["IOLite"] = 18289463] = "IOLite";
    ChainId[ChainId["SmartMeshMainnet"] = 20180430] = "SmartMeshMainnet";
    ChainId[ChainId["Quarkblockchain"] = 20181205] = "Quarkblockchain";
    ChainId[ChainId["PegoNetwork"] = 20201022] = "PegoNetwork";
    ChainId[ChainId["HokumTestnet"] = 20482050] = "HokumTestnet";
    ChainId[ChainId["ExcelonMainnet"] = 22052002] = "ExcelonMainnet";
    ChainId[ChainId["ExcoincialChainVolta-Testnet"] = 27082017] = "ExcoincialChainVolta-Testnet";
    ChainId[ChainId["ExcoincialChainMainnet"] = 27082022] = "ExcoincialChainMainnet";
    ChainId[ChainId["Ancient8Testnet"] = 28122024] = "Ancient8Testnet";
    ChainId[ChainId["AuxiliumNetworkMainnet"] = 28945486] = "AuxiliumNetworkMainnet";
    ChainId[ChainId["FlachainMainnet"] = 29032022] = "FlachainMainnet";
    ChainId[ChainId["Filecoin-Localtestnet"] = 31415926] = "Filecoin-Localtestnet";
    ChainId[ChainId["JoysDigitalMainnet"] = 35855456] = "JoysDigitalMainnet";
    ChainId[ChainId["Maistestsubnet"] = 43214913] = "Maistestsubnet";
    ChainId[ChainId["Aquachain"] = 61717561] = "Aquachain";
    ChainId[ChainId["AutonityBakerloo(Thames)Testnet"] = 65010000] = "AutonityBakerloo(Thames)Testnet";
    ChainId[ChainId["AutonityBakerloo(Barada)Testnet"] = 65010001] = "AutonityBakerloo(Barada)Testnet";
    ChainId[ChainId["AutonityPiccadilly(Thames)Testnet"] = 65100000] = "AutonityPiccadilly(Thames)Testnet";
    ChainId[ChainId["AutonityPiccadilly(Barada)Testnet"] = 65100001] = "AutonityPiccadilly(Barada)Testnet";
    ChainId[ChainId["FrameTestnet"] = 68840142] = "FrameTestnet";
    ChainId[ChainId["T.E.A.MBlockchain"] = 88888888] = "T.E.A.MBlockchain";
    ChainId[ChainId["JoysDigitalTestNet"] = 99415706] = "JoysDigitalTestNet";
    ChainId[ChainId["BlastSepoliaTestnet"] = 168587773] = "BlastSepoliaTestnet";
    ChainId[ChainId["GatherMainnetNetwork"] = 192837465] = "GatherMainnetNetwork";
    ChainId[ChainId["Kanazawa"] = 222000222] = "Kanazawa";
    ChainId[ChainId["NeonEVMDevnet"] = 245022926] = "NeonEVMDevnet";
    ChainId[ChainId["NeonEVMMainnet"] = 245022934] = "NeonEVMMainnet";
    ChainId[ChainId["NeonEVMTestNet"] = 245022940] = "NeonEVMTestNet";
    ChainId[ChainId["RazorSkaleChain"] = 278611351] = "RazorSkaleChain";
    ChainId[ChainId["OneLedgerMainnet"] = 311752642] = "OneLedgerMainnet";
    ChainId[ChainId["Meld"] = 333000333] = "Meld";
    ChainId[ChainId["SKALECalypsoHubTestnet"] = 344106930] = "SKALECalypsoHubTestnet";
    ChainId[ChainId["GatherTestnetNetwork"] = 356256156] = "GatherTestnetNetwork";
    ChainId[ChainId["SKALEEuropaHubTestnet"] = 476158412] = "SKALEEuropaHubTestnet";
    ChainId[ChainId["GatherDevnetNetwork"] = 486217935] = "GatherDevnetNetwork";
    ChainId[ChainId["SKALENebulaHubTestnet"] = 503129905] = "SKALENebulaHubTestnet";
    ChainId[ChainId["ZoraSepoliaTestnet"] = 999999999] = "ZoraSepoliaTestnet";
    ChainId[ChainId["IPOSNetwork"] = 1122334455] = "IPOSNetwork";
    ChainId[ChainId["CyberdeckNet"] = 1146703430] = "CyberdeckNet";
    ChainId[ChainId["HUMANProtocol"] = 1273227453] = "HUMANProtocol";
    ChainId[ChainId["AuroraMainnet"] = 1313161554] = "AuroraMainnet";
    ChainId[ChainId["AuroraTestnet"] = 1313161555] = "AuroraTestnet";
    ChainId[ChainId["AuroraBetanet"] = 1313161556] = "AuroraBetanet";
    ChainId[ChainId["SKALETitanHub"] = 1350216234] = "SKALETitanHub";
    ChainId[ChainId["Chaos(SKALETestnet)"] = 1351057110] = "Chaos(SKALETestnet)";
    ChainId[ChainId["RaptorChain"] = 1380996178] = "RaptorChain";
    ChainId[ChainId["SKALENebulaHub"] = 1482601649] = "SKALENebulaHub";
    ChainId[ChainId["SKALETitanHubTestnet"] = 1517929550] = "SKALETitanHubTestnet";
    ChainId[ChainId["SKALECalypsoHub"] = 1564830818] = "SKALECalypsoHub";
    ChainId[ChainId["HarmonyMainnetShard0"] = 1666600000] = "HarmonyMainnetShard0";
    ChainId[ChainId["HarmonyMainnetShard1"] = 1666600001] = "HarmonyMainnetShard1";
    ChainId[ChainId["HarmonyMainnetShard2"] = 1666600002] = "HarmonyMainnetShard2";
    ChainId[ChainId["HarmonyMainnetShard3"] = 1666600003] = "HarmonyMainnetShard3";
    ChainId[ChainId["HarmonyTestnetShard0"] = 1666700000] = "HarmonyTestnetShard0";
    ChainId[ChainId["HarmonyTestnetShard1"] = 1666700001] = "HarmonyTestnetShard1";
    ChainId[ChainId["HarmonyDevnetShard0"] = 1666900000] = "HarmonyDevnetShard0";
    ChainId[ChainId["HarmonyDevnetShard1"] = 1666900001] = "HarmonyDevnetShard1";
    ChainId[ChainId["DataHopper"] = 2021121117] = "DataHopper";
    ChainId[ChainId["SKALEEuropaHub"] = 2046399126] = "SKALEEuropaHub";
    ChainId[ChainId["Ancient8Testnet(deprecated)"] = 2863311531] = "Ancient8Testnet(deprecated)";
    ChainId[ChainId["Pirl"] = 3125659152] = "Pirl";
    ChainId[ChainId["OneLedgerTestnetFrankenstein"] = 4216137055] = "OneLedgerTestnetFrankenstein";
    ChainId[ChainId["PalmTestnet"] = 11297108099] = "PalmTestnet";
    ChainId[ChainId["Palm"] = 11297108109] = "Palm";
    ChainId[ChainId["AlphabetMainnet"] = 111222333444] = "AlphabetMainnet";
    ChainId[ChainId["NtityMainnet"] = 197710212030] = "NtityMainnet";
    ChainId[ChainId["HaradevTestnet"] = 197710212031] = "HaradevTestnet";
    ChainId[ChainId["Zeniq"] = 383414847825] = "Zeniq";
    ChainId[ChainId["PDCMainnet"] = 666301171999] = "PDCMainnet";
    ChainId[ChainId["MolereumNetwork"] = 6022140761023] = "MolereumNetwork";
    ChainId[ChainId["GodwokenTestnet(V1)"] = 868455272153094] = "GodwokenTestnet(V1)";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
